import * as t from "react";
import { useState as B, useRef as F, useCallback as se, useEffect as H, Fragment as er, Component as tr, useLayoutEffect as Ke, isValidElement as aa, cloneElement as nr, forwardRef as Gr, createContext as Oa, useContext as za, useMemo as xe, Children as Aa, createRef as Yr } from "react";
import { createPortal as Vr } from "react-dom";
const v2 = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Wa = "poc_portal_token", zn = "poc_portal_refresh", Sa = "auth:session-expired", ar = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let or = ar + "/chat-api/api/auth";
function k2(e) {
  e.authBase && (or = e.authBase);
}
function Ka(e) {
  try {
    const n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(n))));
  } catch {
    return {};
  }
}
function Jr(e, n = 30) {
  const a = Ka(e).exp;
  return !a || a * 1e3 < Date.now() + n * 1e3;
}
function rr(e = 30) {
  const n = localStorage.getItem(zn);
  if (!n) return !0;
  const a = Ka(n).exp;
  return !!a && a * 1e3 < Date.now() + e * 1e3;
}
function Qr() {
  return localStorage.getItem(Wa);
}
function Zr(e, n) {
  localStorage.setItem(Wa, e), n && localStorage.setItem(zn, n);
}
function es() {
  localStorage.removeItem(Wa), localStorage.removeItem(zn), sr();
}
function Ln() {
  es(), window.dispatchEvent(new Event(Sa));
}
function w2(e) {
  return window.addEventListener(Sa, e), () => window.removeEventListener(Sa, e);
}
let In = null;
const ts = 2147483647;
function ns() {
  if (sr(), rr()) {
    Ln();
    return;
  }
  const e = localStorage.getItem(zn), n = e ? Ka(e).exp : void 0;
  if (!n) return;
  const a = Math.min(Math.max(n * 1e3 - Date.now() - 30 * 1e3, 0), ts);
  In = setTimeout(() => {
    In = null, ns();
  }, a);
}
function sr() {
  In !== null && (clearTimeout(In), In = null);
}
let ea = null;
function lr() {
  return ea || (ea = as()), ea;
}
async function as() {
  try {
    return await os();
  } finally {
    ea = null;
  }
}
async function os() {
  const e = localStorage.getItem(zn);
  if (!e)
    return Ln(), null;
  let n;
  try {
    n = await fetch(or + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: e })
    });
  } catch {
    return null;
  }
  if (!n.ok)
    return n.status < 500 && Ln(), null;
  const a = await n.json().catch(() => ({}));
  return a.access_token ? (Zr(a.access_token, a.refresh_token), a.access_token) : (Ln(), null);
}
async function rs() {
  if (rr())
    return Ln(), null;
  const e = Qr();
  return e && !Jr(e) ? e : lr();
}
async function Wn(e, n = {}) {
  const a = (s) => {
    var l;
    return {
      ...n,
      headers: { ...(l = n.headers) != null ? l : {}, ...s ? { Authorization: "Bearer " + s } : {} }
    };
  }, o = await rs();
  let r = await fetch(e, a(o));
  if (r.status === 401 && o) {
    const s = await lr();
    s && (r = await fetch(e, a(s)));
  }
  return r;
}
let kn = ar + "/chat-api/api/comments";
function N2(e) {
  e.base && (kn = e.base);
}
function ss(e) {
  return e.parentId !== void 0 && e.parentId !== null;
}
async function Kn(e) {
  var a;
  const n = await e.json().catch(() => ({}));
  if (!e.ok) throw new Error((a = n.error) != null ? a : `요청 실패 (${e.status})`);
  return n;
}
async function no(e, n, a, o, r) {
  const s = new URLSearchParams({ targetType: e, targetId: n, page: String(a), size: String(o) }), l = await Wn(`${kn}?${s}`, { cache: "no-store", signal: r });
  return Kn(l);
}
async function ls(e, n, a, o) {
  const r = await Wn(kn, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: e, targetId: n, content: a, parentId: o })
  });
  return Kn(r);
}
async function cs(e, n) {
  const a = await Wn(`${kn}/${e}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: n })
  });
  return Kn(a);
}
async function is(e) {
  const n = await Wn(`${kn}/${e}`, { method: "DELETE" });
  return (await Kn(n)).status;
}
async function us(e, n, a) {
  if (n.length === 0) return {};
  const o = new URLSearchParams({ targetType: e, targetIds: n.join(",") }), r = await Wn(`${kn}/counts?${o}`, { cache: "no-store", signal: a });
  return (await Kn(r)).counts;
}
const ao = 50;
function Ba(e) {
  return e.parentId === void 0 || e.parentId === null;
}
function ms(e, n) {
  if (Ba(n)) return [...e, n];
  const a = n.parentId;
  let o = -1;
  for (let r = 0; r < e.length; r += 1)
    (e[r].id === a || e[r].parentId === a) && (o = r);
  return o < 0 ? [...e, n] : [...e.slice(0, o + 1), n, ...e.slice(o + 1)];
}
function Nn(e, n) {
  return e instanceof Error && e.message ? e.message : n;
}
function ds(e, n) {
  const [a, o] = B([]), [r, s] = B(!0), [l, i] = B(!0), [c, m] = B(null), [u, d] = B(0), [f, p] = B(0), y = e + " " + n, _ = F(y);
  _.current = y;
  const [b, $] = B(0), E = se(() => $((x) => x + 1), []);
  H(() => {
    const x = new AbortController(), A = y;
    return o([]), p(0), d(0), m(null), s(!0), i(!0), no(e, n, 0, ao, x.signal).then((N) => {
      _.current === A && (o(N.items), d(N.total));
    }).catch((N) => {
      x.signal.aborted || _.current !== A || m(Nn(N, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      _.current === A && (s(!1), i(!1));
    }), () => x.abort();
  }, [e, n, y, b]);
  const D = a.filter(Ba).length < u, h = se(() => {
    if (r || !D) return;
    const x = f + 1, A = _.current;
    s(!0), no(e, n, x, ao).then((N) => {
      _.current === A && (o((L) => [...L, ...N.items]), d(N.total), p(x));
    }).catch((N) => {
      _.current === A && m(Nn(N, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      _.current === A && s(!1);
    });
  }, [r, D, f, e, n]), w = se(async (x, A) => {
    const N = x.trim();
    if (!N) return !1;
    const L = -Date.now(), S = {
      id: L,
      targetType: e,
      targetId: n,
      parentId: A != null ? A : null,
      authorName: "나",
      content: N,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, P = _.current;
    o((W) => ms(W, S)), m(null);
    try {
      const W = await ls(e, n, N, A);
      return _.current !== P || (o((q) => q.map((R) => R.id === L ? W : R)), A === void 0 && d((q) => q + 1)), !0;
    } catch (W) {
      return _.current !== P || (o((q) => q.filter((R) => R.id !== L)), m(Nn(W, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [e, n]), v = se(async (x, A) => {
    const N = A.trim();
    if (!N) return !1;
    const L = _.current;
    try {
      const S = await cs(x, N);
      return _.current !== L || o((P) => P.map((W) => W.id === x ? S : W)), !0;
    } catch (S) {
      return _.current === L && m(Nn(S, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), C = se(async (x) => {
    const A = _.current;
    try {
      const N = await is(x);
      return _.current !== A ? !0 : N === "soft-deleted" ? (o((L) => L.map((S) => S.id === x ? { ...S, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : S)), !0) : (o((L) => {
        const S = L.find((R) => R.id === x), P = L.filter((R) => R.id !== x);
        if (!S) return P;
        if (Ba(S))
          return d((R) => Math.max(0, R - 1)), P;
        const W = S.parentId, q = P.find((R) => R.id === W);
        return q && q.deleted && !P.some((R) => R.parentId === W) ? (d((R) => Math.max(0, R - 1)), P.filter((R) => R.id !== W)) : P;
      }), !0);
    } catch (N) {
      return _.current === A && m(Nn(N, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: r,
    initialLoading: l,
    error: c,
    count: a.filter((x) => !x.deleted).length,
    hasMore: D,
    loadMore: h,
    reload: E,
    add: w,
    edit: v,
    remove: C
  };
}
const _s = "_thread_1layy_9", ps = "_head_1layy_28", fs = "_headTitle_1layy_37", ys = "_headCount_1layy_43", bs = "_list_1layy_54", hs = "_row_1layy_61", gs = "_isReply_1layy_73", Es = "_pending_1layy_80", vs = "_avatar_1layy_84", ks = "_avatarGhost_1layy_98", ws = "_body_1layy_103", Ns = "_meta_1layy_108", $s = "_author_1layy_116", xs = "_dept_1layy_122", Ds = "_time_1layy_130", Cs = "_text_1layy_135", As = "_textDeleted_1layy_143", Ss = "_acts_1layy_148", Bs = "_act_1layy_148", js = "_actDanger_1layy_169", Ms = "_empty_1layy_175", Ts = "_error_1layy_182", Ls = "_skeleton_1layy_196", Is = "_more_1layy_219", qs = "_foot_1layy_245", Fs = "_composer_1layy_252", Rs = "_composerInput_1layy_261", Ps = "_composerActions_1layy_284", Xs = "_btn_1layy_291", Os = "_btnPrimary_1layy_301", zs = "_btnGhost_1layy_310", Q = {
  thread: _s,
  head: ps,
  headTitle: fs,
  headCount: ys,
  list: bs,
  row: hs,
  isReply: gs,
  pending: Es,
  avatar: vs,
  avatarGhost: ks,
  body: ws,
  meta: Ns,
  author: $s,
  dept: xs,
  time: Ds,
  text: Cs,
  textDeleted: As,
  acts: Ss,
  act: Bs,
  actDanger: js,
  empty: Ms,
  error: Ts,
  skeleton: Ls,
  more: Is,
  foot: qs,
  composer: Fs,
  composerInput: Rs,
  composerActions: Ps,
  btn: Xs,
  btnPrimary: Os,
  btnGhost: zs
}, oo = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function Ws(e) {
  let n = 0;
  for (let a = 0; a < e.length; a += 1) n = (n * 31 + e.charCodeAt(a)) % 997;
  return oo[n % oo.length];
}
function Ks(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "?";
}
const ro = 6e4, so = 36e5, lo = 864e5, Hs = 6048e5;
function Us(e) {
  const n = new Date(e).getTime();
  if (Number.isNaN(n)) return "";
  const a = Date.now() - n;
  if (a < ro) return "방금";
  if (a < so) return `${Math.floor(a / ro)}분 전`;
  if (a < lo) return `${Math.floor(a / so)}시간 전`;
  if (a < Hs) return `${Math.floor(a / lo)}일 전`;
  const o = new Date(n), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function ja({
  placeholder: e,
  submitLabel: n,
  autoFocus: a,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, i] = B(o != null ? o : ""), [c, m] = B(!1), u = F(null);
  H(() => {
    a && u.current && u.current.focus();
  }, [a]);
  const d = async () => {
    const f = l.trim();
    if (!f || c) return;
    m(!0);
    const p = await r(f);
    m(!1), p && i("");
  };
  return /* @__PURE__ */ t.createElement("div", { className: Q.composer }, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      ref: u,
      className: Q.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: e,
      value: l,
      disabled: c,
      onChange: (f) => i(f.target.value),
      onKeyDown: (f) => {
        const p = f.nativeEvent.isComposing;
        f.key === "Enter" && !f.shiftKey && !p && (f.preventDefault(), d()), f.key === "Escape" && s && (f.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: Q.composerActions }, s && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Q.btn} ${Q.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Q.btn} ${Q.btnPrimary}`,
      onClick: () => void d(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : n
  )));
}
function Gs({
  item: e,
  replying: n,
  editing: a,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: i,
  onCancel: c
}) {
  var f, p;
  const m = ss(e), u = m ? ` ${Q.isReply}` : "";
  if (e.deleted)
    return /* @__PURE__ */ t.createElement("div", { className: `${Q.row}${u}` }, /* @__PURE__ */ t.createElement("span", { className: `${Q.avatar} ${Q.avatarGhost}` }, "·"), /* @__PURE__ */ t.createElement("div", { className: Q.body }, /* @__PURE__ */ t.createElement("div", { className: `${Q.text} ${Q.textDeleted}` }, "삭제된 댓글입니다")));
  const d = (f = e.authorName) != null ? f : "anonymous";
  return /* @__PURE__ */ t.createElement("div", { className: `${Q.row}${u}${e.pending ? ` ${Q.pending}` : ""}` }, /* @__PURE__ */ t.createElement("span", { className: Q.avatar, style: { background: Ws(d) } }, Ks(d)), /* @__PURE__ */ t.createElement("div", { className: Q.body }, /* @__PURE__ */ t.createElement("div", { className: Q.meta }, /* @__PURE__ */ t.createElement("span", { className: Q.author }, d), e.dept && /* @__PURE__ */ t.createElement("span", { className: Q.dept }, e.dept), /* @__PURE__ */ t.createElement("span", { className: Q.time }, Us(e.createdAt)), e.updatedAt && /* @__PURE__ */ t.createElement("span", { className: Q.time }, "(수정됨)")), a ? /* @__PURE__ */ t.createElement(
    ja,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (p = e.content) != null ? p : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ t.createElement("div", { className: Q.text }, e.content), !a && !e.pending && /* @__PURE__ */ t.createElement("div", { className: Q.acts }, !m && /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.act, onClick: o }, "답글"), e.mine && /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.act, onClick: r }, "수정"), e.mine && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Q.act} ${Q.actDanger}`,
      onClick: i
    },
    "삭제"
  )), n && /* @__PURE__ */ t.createElement(
    ja,
    {
      placeholder: `${d} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function $2({
  targetType: e,
  targetId: n,
  onCountChange: a,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: i, initialLoading: c, loading: m, error: u, count: d, hasMore: f, loadMore: p, reload: y, add: _, edit: b, remove: $ } = ds(e, n), [E, k] = B(null), [D, h] = B(null);
  H(() => {
    k(null), h(null);
  }, [e, n]);
  const w = F(a);
  return w.current = a, H(() => {
    !c && w.current && w.current(d);
  }, [d, c]), /* @__PURE__ */ t.createElement("div", { className: s ? `${Q.thread} ${s}` : Q.thread, style: l }, r && /* @__PURE__ */ t.createElement("div", { className: Q.head }, /* @__PURE__ */ t.createElement("span", { className: Q.headTitle }, "댓글"), /* @__PURE__ */ t.createElement("span", { className: Q.headCount }, d)), /* @__PURE__ */ t.createElement("div", { className: Q.list }, c && /* @__PURE__ */ t.createElement("div", { className: Q.skeleton }, /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null)), u && /* @__PURE__ */ t.createElement("div", { className: Q.error }, /* @__PURE__ */ t.createElement("span", null, u), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Q.btn} ${Q.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !u && i.length === 0 && /* @__PURE__ */ t.createElement("div", { className: Q.empty }, "첫 댓글을 남겨 보세요."), i.map((v) => /* @__PURE__ */ t.createElement(
    Gs,
    {
      key: v.id,
      item: v,
      replying: E === v.id,
      editing: D === v.id,
      onReply: () => {
        h(null), k(v.id);
      },
      onEdit: () => {
        k(null), h(v.id);
      },
      onCancel: () => {
        k(null), h(null);
      },
      onSubmitReply: async (C) => {
        const x = await _(C, v.id);
        return x && k(null), x;
      },
      onSubmitEdit: async (C) => {
        const x = await b(v.id, C);
        return x && h(null), x;
      },
      onDelete: () => {
        $(v.id);
      }
    }
  )), f && /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.more, onClick: p, disabled: m }, m ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ t.createElement("div", { className: Q.foot }, /* @__PURE__ */ t.createElement(
    ja,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (v) => _(v)
    }
  )));
}
function x2(e, n) {
  const [a, o] = B({}), [r, s] = B(!1), [l, i] = B(0), c = n.join(",");
  return H(() => {
    const m = c ? c.split(",") : [];
    if (m.length === 0) {
      o({});
      return;
    }
    const u = new AbortController();
    return s(!0), us(e, m, u.signal).then((d) => {
      u.signal.aborted || o(d);
    }).catch(() => {
      u.signal.aborted || o({});
    }).finally(() => {
      u.signal.aborted || s(!1);
    }), () => u.abort();
  }, [e, c, l]), {
    counts: a,
    loading: r,
    reload: () => i((m) => m + 1)
  };
}
const Ys = "_card_epi3f_1", Vs = "_header_epi3f_8", Js = "_headerNoDivider_epi3f_13", Qs = "_body_epi3f_17", Zs = "_paddingSm_epi3f_22", el = "_paddingMd_epi3f_26", tl = "_paddingLg_epi3f_30", mt = {
  card: Ys,
  header: Vs,
  headerNoDivider: Js,
  body: Qs,
  paddingSm: Zs,
  paddingMd: el,
  paddingLg: tl
};
function D2({
  children: e,
  header: n,
  padding: a = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: i,
  className: c
}) {
  const m = typeof a == "number" ? "" : a === "sm" ? mt.paddingSm : a === "lg" ? mt.paddingLg : mt.paddingMd, u = typeof a == "number" ? { padding: a } : void 0, d = c ? `${mt.card} ${c}` : mt.card, f = r ? mt.header : `${mt.header} ${mt.headerNoDivider}`, p = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...i !== void 0 ? { borderBottomColor: i } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: d, style: o !== void 0 ? { borderRadius: o } : void 0 }, n && /* @__PURE__ */ t.createElement("div", { className: f, style: p }, n), /* @__PURE__ */ t.createElement("div", { className: `${mt.body} ${m}`, style: u }, e));
}
const nl = "_horizontal_mkht7_1", al = "_vertical_mkht7_8", co = {
  horizontal: nl,
  vertical: al
};
function C2({ orientation: e = "horizontal", spacing: n = 0, color: a }) {
  const o = e === "vertical";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: o ? co.vertical : co.horizontal,
      style: {
        ...o ? { marginLeft: n, marginRight: n } : { marginTop: n, marginBottom: n },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": e
    }
  );
}
const ol = "_root_nvy8t_1", rl = "_icon_nvy8t_7", sl = "_iconBadge_nvy8t_15", ll = "_titleGroup_nvy8t_25", cl = "_title_nvy8t_25", il = "_subtitle_nvy8t_41", ul = "_trailing_nvy8t_49", ml = "_closeButton_nvy8t_58", Ct = {
  root: ol,
  icon: rl,
  iconBadge: sl,
  titleGroup: ll,
  title: cl,
  subtitle: il,
  trailing: ul,
  closeButton: ml
};
function A2({
  icon: e,
  iconColor: n,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: i,
  titleSize: c,
  subtitle: m,
  subtitleColor: u,
  subtitleSize: d,
  trailing: f,
  onClose: p
}) {
  const y = {
    ...i !== void 0 ? { fontWeight: i } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, _ = {
    ...u !== void 0 ? { color: u } : {},
    ...d !== void 0 ? { fontSize: d } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: Ct.root }, e && a && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Ct.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    e
  ), e && !a && /* @__PURE__ */ t.createElement("span", { className: Ct.icon, style: n !== void 0 ? { color: n } : void 0 }, e), /* @__PURE__ */ t.createElement("div", { className: Ct.titleGroup }, /* @__PURE__ */ t.createElement("span", { className: Ct.title, style: y }, l), m && /* @__PURE__ */ t.createElement("span", { className: Ct.subtitle, style: _ }, m)), f && /* @__PURE__ */ t.createElement("div", { className: Ct.trailing }, f), p && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Ct.closeButton,
      onClick: p,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const dl = "_badge_19977_1", _l = {
  badge: dl
};
function S2({
  size: e = 32,
  gradient: n = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = e * 0.55;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: _l.badge,
      style: {
        width: e,
        height: e,
        background: `linear-gradient(135deg, ${n[0]}, ${n[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ t.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const pl = "_wrapper_ccmq2_1", fl = "_image_ccmq2_8", yl = "_fallback_ccmq2_16", bl = "_statusDot_ccmq2_29", Gn = {
  wrapper: pl,
  image: fl,
  fallback: yl,
  statusDot: bl
}, hl = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function gl(e) {
  const n = e == null ? void 0 : e.trim();
  return n ? Array.from(n)[0].toUpperCase() : "";
}
const ya = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function El(e) {
  const n = e == null ? void 0 : e.trim();
  if (!n) return ya[5];
  let a = 0;
  for (let o = 0; o < n.length; o += 1)
    a = a * 31 + n.charCodeAt(o) | 0;
  return ya[Math.abs(a) % ya.length];
}
function cr({
  src: e,
  fallbackText: n,
  alt: a,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: i = "#fff"
}) {
  var d;
  const [c, m] = B(), u = !!e && c !== e;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Gn.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${i}` } : {}
      }
    },
    u ? /* @__PURE__ */ t.createElement(
      "img",
      {
        className: Gn.image,
        src: e,
        alt: (d = a != null ? a : n) != null ? d : "",
        onError: () => m(e)
      }
    ) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: Gn.fallback,
        style: {
          backgroundColor: s != null ? s : El(n),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      gl(n)
    ),
    r && /* @__PURE__ */ t.createElement(
      "span",
      {
        className: Gn.statusDot,
        style: {
          backgroundColor: hl[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const vl = "_stack_y8phg_1", kl = "_item_y8phg_6", wl = "_overflow_y8phg_18", Yn = {
  stack: vl,
  item: kl,
  overflow: wl
};
function B2({
  avatars: e,
  max: n = 4,
  size: a = 32
}) {
  const o = e.slice(0, n), r = e.length - o.length;
  return /* @__PURE__ */ t.createElement("span", { className: Yn.stack }, o.map((s, l) => /* @__PURE__ */ t.createElement("span", { key: l, className: Yn.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ t.createElement(cr, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: a }))), r > 0 && /* @__PURE__ */ t.createElement("span", { className: Yn.item, style: { zIndex: 0 } }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Yn.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    r
  )));
}
const Nl = "_badge_1mjda_1", $l = "_pill_1mjda_15", xl = "_dot_1mjda_19", Dl = "_dotPulse_1mjda_26", Cl = "_outline_1mjda_40", Al = "_soft_1mjda_46", $n = {
  badge: Nl,
  pill: $l,
  dot: xl,
  dotPulse: Dl,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: Cl,
  soft: Al
};
function j2({
  label: e,
  variant: n = "default",
  color: a,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: i,
  dotPulse: c = !1,
  border: m = !1,
  borderColor: u = "currentColor"
}) {
  var y;
  const d = {};
  a && (n === "default" ? (d.backgroundColor = a, d.color = "#fff") : n === "outline" ? (d.borderColor = a, d.color = a) : (d.backgroundColor = `${a}1A`, d.color = a)), o !== void 0 && (d.backgroundColor = o), r !== void 0 && (d.color = r), m && (d.borderColor = u);
  const f = [
    $n.badge,
    $n[n],
    s === "pill" ? $n.pill : ""
  ].filter(Boolean).join(" "), p = [$n.dot, c ? $n.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { className: f, style: d }, l && /* @__PURE__ */ t.createElement("span", { className: p, style: { backgroundColor: i != null ? i : (y = r != null ? r : a) != null ? y : "currentColor" } }), e);
}
const Sl = "_row_1k2ap_1", Bl = "_reply_1k2ap_7", jl = "_avatar_1k2ap_12", Ml = "_avatarImage_1k2ap_25", Tl = "_avatarFallback_1k2ap_32", Ll = "_body_1k2ap_44", Il = "_headerLine_1k2ap_49", ql = "_author_1k2ap_56", Fl = "_meta_1k2ap_62", Rl = "_text_1k2ap_67", Pl = "_actionsRow_1k2ap_74", Xl = "_actionBtn_1k2ap_81", Ie = {
  row: Sl,
  reply: Bl,
  avatar: jl,
  avatarImage: Ml,
  avatarFallback: Tl,
  body: Ll,
  headerLine: Il,
  author: ql,
  meta: Fl,
  text: Rl,
  actionsRow: Pl,
  actionBtn: Xl
};
function Ol(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "";
}
function M2({
  avatarSrc: e,
  author: n,
  meta: a,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: i,
  onReplyClick: c
}) {
  const [m, u] = B(!1), d = !!e && !m;
  return /* @__PURE__ */ t.createElement("div", { className: `${Ie.row} ${l ? Ie.reply : ""}` }, /* @__PURE__ */ t.createElement("span", { className: Ie.avatar }, d ? /* @__PURE__ */ t.createElement(
    "img",
    {
      className: Ie.avatarImage,
      src: e,
      alt: n,
      onError: () => u(!0)
    }
  ) : /* @__PURE__ */ t.createElement("span", { className: Ie.avatarFallback }, Ol(n))), /* @__PURE__ */ t.createElement("div", { className: Ie.body }, /* @__PURE__ */ t.createElement("div", { className: Ie.headerLine }, /* @__PURE__ */ t.createElement("span", { className: Ie.author }, n), a && /* @__PURE__ */ t.createElement("span", { className: Ie.meta }, a)), /* @__PURE__ */ t.createElement("div", { className: Ie.text }, o), /* @__PURE__ */ t.createElement("div", { className: Ie.actionsRow }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ie.actionBtn, onClick: i }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ t.createElement("span", null, r)), /* @__PURE__ */ t.createElement("button", { type: "button", className: Ie.actionBtn, onClick: c }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ t.createElement("span", null, s)))));
}
const zl = "_wrapper_79n51_1", Wl = {
  wrapper: zl
}, Kl = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, Hl = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function Ul({ ext: e, size: n = 32 }) {
  var l;
  const a = e.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = Kl[a]) != null ? l : Hl;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Wl.wrapper,
      style: {
        width: n,
        height: n,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, n * 0.26)
      }
    },
    o
  );
}
const Gl = "_chip_1jhj8_1", Yl = "_clickable_1jhj8_12", Vl = "_icon_1jhj8_21", Jl = "_info_1jhj8_26", Ql = "_name_1jhj8_33", Zl = "_size_1jhj8_42", ec = "_chipError_1jhj8_48", tc = "_chipDone_1jhj8_53", nc = "_status_1jhj8_57", ac = "_statusError_1jhj8_66", oc = "_statusDone_1jhj8_67", rc = "_statusIcon_1jhj8_69", sc = "_statusLabel_1jhj8_71", lc = "_progressTrack_1jhj8_78", cc = "_progressFill_1jhj8_88", ic = "_actionBtn_1jhj8_96", Ee = {
  chip: Gl,
  clickable: Yl,
  icon: Vl,
  info: Jl,
  name: Ql,
  size: Zl,
  chipError: ec,
  chipDone: tc,
  status: nc,
  statusError: ac,
  statusDone: oc,
  statusIcon: rc,
  statusLabel: sc,
  progressTrack: lc,
  progressFill: cc,
  actionBtn: ic
};
function T2({
  name: e,
  ext: n,
  size: a,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: i,
  percent: c
}) {
  const m = l === "error" ? Ee.chipError : l === "done" ? Ee.chipDone : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${Ee.chip} ${s ? Ee.clickable : ""} ${m}`,
      onClick: s,
      title: l === "error" ? i : void 0
    },
    n && /* @__PURE__ */ t.createElement("span", { className: Ee.icon }, /* @__PURE__ */ t.createElement(Ul, { ext: n, size: 28 })),
    /* @__PURE__ */ t.createElement("span", { className: Ee.info }, /* @__PURE__ */ t.createElement("span", { className: Ee.name }, e), i ? /* @__PURE__ */ t.createElement("span", { className: `${Ee.status} ${l === "error" ? Ee.statusError : l === "done" ? Ee.statusDone : ""}` }, l === "error" && /* @__PURE__ */ t.createElement("svg", { className: Ee.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ t.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ t.createElement("svg", { className: Ee.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ t.createElement("span", { className: Ee.statusLabel }, i)) : a ? /* @__PURE__ */ t.createElement("span", { className: Ee.size }, a) : null, l === "processing" && /* @__PURE__ */ t.createElement("span", { className: Ee.progressTrack }, /* @__PURE__ */ t.createElement("span", { className: Ee.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ee.actionBtn,
        "aria-label": "download",
        onClick: (u) => u.stopPropagation()
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ee.actionBtn,
        "aria-label": "remove",
        onClick: (u) => {
          u.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const uc = "_list_1yxwc_1", mc = "_row_1yxwc_6", dc = "_inline_1yxwc_15", _c = "_label_1yxwc_22", pc = "_value_1yxwc_29", fc = "_stacked_1yxwc_35", yc = "_bold_1yxwc_51", rn = {
  list: uc,
  row: mc,
  inline: dc,
  label: _c,
  value: pc,
  stacked: fc,
  bold: yc
};
function L2({
  rows: e,
  direction: n = "inline"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: `${rn.list} ${rn[n]}` }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: rn.row }, /* @__PURE__ */ t.createElement("span", { className: rn.label }, a.label), /* @__PURE__ */ t.createElement("span", { className: `${rn.value} ${a.bold ? rn.bold : ""}` }, a.value))));
}
const bc = "_container_2r163_1", hc = "_row_2r163_5", gc = "_clickable_2r163_12", Ec = "_leading_2r163_20", vc = "_main_2r163_26", kc = "_titleLine_2r163_34", wc = "_title_2r163_34", Nc = "_tags_2r163_50", $c = "_meta_2r163_57", xc = "_actions_2r163_62", Dc = "_expandable_2r163_69", Ue = {
  container: bc,
  row: hc,
  clickable: gc,
  leading: Ec,
  main: vc,
  titleLine: kc,
  title: wc,
  tags: Nc,
  meta: $c,
  actions: xc,
  expandable: Dc
};
function I2({
  leading: e,
  title: n,
  meta: a,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: i
}) {
  return /* @__PURE__ */ t.createElement("div", { className: Ue.container }, /* @__PURE__ */ t.createElement("div", { className: `${Ue.row} ${i ? Ue.clickable : ""}`, onClick: i }, e && /* @__PURE__ */ t.createElement("div", { className: Ue.leading }, e), /* @__PURE__ */ t.createElement("div", { className: Ue.main }, /* @__PURE__ */ t.createElement("div", { className: Ue.titleLine }, /* @__PURE__ */ t.createElement("span", { className: Ue.title }, n), o && /* @__PURE__ */ t.createElement("span", { className: Ue.tags }, o)), a && /* @__PURE__ */ t.createElement("div", { className: Ue.meta }, a)), r && /* @__PURE__ */ t.createElement("div", { className: Ue.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ t.createElement("div", { className: Ue.expandable }, s));
}
const Cc = "_row_xzgny_1", Ac = "_info_xzgny_8", Sc = "_name_xzgny_16", Bc = "_subtitle_xzgny_25", jc = "_status_xzgny_33", xn = {
  row: Cc,
  info: Ac,
  name: Sc,
  subtitle: Bc,
  status: jc
};
function q2({
  avatarSrc: e,
  name: n,
  subtitle: a,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: xn.row }, /* @__PURE__ */ t.createElement(cr, { src: e, fallbackText: n, size: 36 }), /* @__PURE__ */ t.createElement("div", { className: xn.info }, /* @__PURE__ */ t.createElement("span", { className: xn.name }, n), a && /* @__PURE__ */ t.createElement("span", { className: xn.subtitle }, a)), o && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: xn.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const Mc = "_row_qoxwr_1", Tc = "_clickable_qoxwr_9", Lc = "_rank_qoxwr_17", Ic = "_title_qoxwr_25", qc = "_trailing_qoxwr_36", Dn = {
  row: Mc,
  clickable: Tc,
  rank: Lc,
  title: Ic,
  trailing: qc
}, Fc = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function F2({
  rank: e,
  rankColor: n,
  title: a,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = n != null ? n : Fc[e]) != null ? l : "#64748B";
  return /* @__PURE__ */ t.createElement("div", { className: `${Dn.row} ${r ? Dn.clickable : ""}`, onClick: r }, /* @__PURE__ */ t.createElement("span", { className: Dn.rank, style: { color: s } }, e), /* @__PURE__ */ t.createElement("span", { className: Dn.title }, a), o && /* @__PURE__ */ t.createElement("span", { className: Dn.trailing }, o));
}
const Rc = "_badge_1qibj_1", Pc = "_sm_1qibj_11", Xc = "_md_1qibj_16", Oc = "_overdue_1qibj_21", zc = "_warning_1qibj_26", Wc = "_progress_1qibj_31", Kc = "_success_1qibj_36", Hc = "_info_1qibj_41", Uc = "_neutral_1qibj_46", ba = {
  badge: Rc,
  sm: Pc,
  md: Xc,
  overdue: Oc,
  warning: zc,
  progress: Wc,
  success: Kc,
  info: Hc,
  neutral: Uc
};
function R2({
  label: e,
  tone: n = "neutral",
  size: a = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ t.createElement("span", { className: `${ba.badge} ${ba[n]} ${ba[a]}`, style: s }, e);
}
const Gc = "_wrapper_14p14_1", Yc = "_avatar_14p14_11", Vc = "_body_14p14_21", Jc = "_message_14p14_26", Qc = "_dots_14p14_32", Zc = "_dot_14p14_32", ei = "_action_14p14_70", ti = "_actionIcon_14p14_89", ni = "_gradientWrapper_14p14_95", ai = "_bareIcon_14p14_100", oi = "_ctaButton_14p14_109", Te = {
  wrapper: Gc,
  avatar: Yc,
  body: Vc,
  message: Jc,
  dots: Qc,
  dot: Zc,
  action: ei,
  actionIcon: ti,
  gradientWrapper: ni,
  bareIcon: ai,
  ctaButton: oi
};
function io() {
  return /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function uo() {
  return /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function P2({
  message: e,
  accentColor: n = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: i = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Te.wrapper, c ? Te.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${n}33`, background: `linear-gradient(135deg, ${i[0]}, ${i[1]})` } : { borderColor: `${n}33` }
    },
    c ? /* @__PURE__ */ t.createElement("span", { className: Te.bareIcon, style: { color: n } }, /* @__PURE__ */ t.createElement(io, null)) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: Te.avatar,
        style: { backgroundColor: `${n}1A`, color: n }
      },
      /* @__PURE__ */ t.createElement(io, null)
    ),
    /* @__PURE__ */ t.createElement("div", { className: Te.body }, s === "loading" ? /* @__PURE__ */ t.createElement("span", { className: Te.dots }, /* @__PURE__ */ t.createElement("span", { className: Te.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: Te.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: Te.dot, style: { backgroundColor: n } })) : /* @__PURE__ */ t.createElement("span", { className: Te.message, style: c ? { color: n } : void 0 }, e)),
    a && r && (c ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Te.ctaButton,
        style: { backgroundColor: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: Te.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(uo, null) : o)
    ) : /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Te.action,
        style: { color: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: Te.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(uo, null) : o)
    ))
  );
}
const ri = "_wrapper_68zkp_1", si = "_bordered_68zkp_13", li = "_compact_68zkp_17", ci = "_icon_68zkp_23", ii = "_title_68zkp_31", ui = "_description_68zkp_38", mi = "_action_68zkp_46", Ft = {
  wrapper: ri,
  bordered: si,
  compact: li,
  icon: ci,
  title: ii,
  description: ui,
  action: mi
};
function di() {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function X2({
  icon: e,
  hideIcon: n = !1,
  title: a,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: i,
  onAction: c,
  bordered: m = !0,
  compact: u = !1
}) {
  const d = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Ft.wrapper, m && !u ? Ft.bordered : "", u ? Ft.compact : ""].join(" ")
    },
    !n && /* @__PURE__ */ t.createElement("div", { className: Ft.icon }, e != null ? e : /* @__PURE__ */ t.createElement(di, null)),
    /* @__PURE__ */ t.createElement("p", { className: Ft.title, style: d }, a),
    l && /* @__PURE__ */ t.createElement("p", { className: Ft.description }, l),
    i && c && /* @__PURE__ */ t.createElement("button", { type: "button", className: Ft.action, onClick: c }, i)
  );
}
const _i = "_wrapper_oide4_1", pi = "_toggle_oide4_7", fi = "_toggleOpen_oide4_29", yi = "_panel_oide4_34", bi = "_text_oide4_41", Cn = {
  wrapper: _i,
  toggle: pi,
  toggleOpen: fi,
  panel: yi,
  text: bi
};
function O2({
  label: e,
  summaryText: n,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ t.createElement("div", { className: Cn.wrapper }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Cn.toggle, a ? Cn.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    e
  ), a && /* @__PURE__ */ t.createElement("div", { className: Cn.panel }, /* @__PURE__ */ t.createElement("p", { className: Cn.text }, n)));
}
const hi = "_wrapper_96dw1_1", gi = "_labelRow_96dw1_8", Ei = "_label_96dw1_8", vi = "_value_96dw1_21", ki = "_track_96dw1_27", wi = "_xs_96dw1_35", Ni = "_sm_96dw1_39", $i = "_md_96dw1_43", xi = "_square_96dw1_47", Di = "_fill_96dw1_51", dt = {
  wrapper: hi,
  labelRow: gi,
  label: Ei,
  value: vi,
  track: ki,
  xs: wi,
  sm: Ni,
  md: $i,
  square: xi,
  fill: Di
};
function z2({
  value: e,
  max: n = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: i,
  trackColor: c
}) {
  const m = n > 0 ? n : 100, u = Math.min(100, Math.max(0, e / m * 100)), d = r ? { width: `${u}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${u}%`, backgroundColor: o }, f = {
    ...i !== void 0 ? { height: i } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: dt.wrapper }, a && /* @__PURE__ */ t.createElement("div", { className: dt.labelRow }, /* @__PURE__ */ t.createElement("span", { className: dt.label }, a), /* @__PURE__ */ t.createElement("span", { className: dt.value }, Math.round(u), "%")), /* @__PURE__ */ t.createElement("div", { className: [dt.track, dt[s], l ? "" : dt.square].join(" "), style: f }, /* @__PURE__ */ t.createElement("div", { className: [dt.fill, l ? "" : dt.square].join(" "), style: d })));
}
const Ci = "_list_aixh6_1", Ai = "_vertical_aixh6_8", Si = "_horizontal_aixh6_13", Bi = "_item_aixh6_18", ji = "_iconWrap_aixh6_41", Mi = "_iconSvg_aixh6_51", Ti = "_spin_aixh6_56", Li = "_label_aixh6_70", Ii = "_item_active_aixh6_82", qi = "_item_done_aixh6_87", Fi = "_connector_aixh6_91", Ri = "_cardList_aixh6_114", Pi = "_cardItem_aixh6_122", Xi = "_card_pending_aixh6_133", Oi = "_card_active_aixh6_142", zi = "_card_done_aixh6_152", Le = {
  list: Ci,
  vertical: Ai,
  horizontal: Si,
  item: Bi,
  iconWrap: ji,
  iconSvg: Mi,
  spin: Ti,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Li,
  item_active: Ii,
  item_done: qi,
  connector: Fi,
  cardList: Ri,
  cardItem: Pi,
  card_pending: Xi,
  card_active: Oi,
  card_done: zi
};
function Wi({ status: e }) {
  return e === "done" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: Le.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : e === "active" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: [Le.iconSvg, Le.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: Le.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function W2({
  steps: e,
  orientation: n = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ t.createElement("ul", { className: [Le.list, Le[n], o ? Le.cardList : ""].join(" ") }, e.map((r, s) => /* @__PURE__ */ t.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        Le.item,
        o ? Le.cardItem : "",
        Le[`item_${r.status}`],
        o ? Le[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ t.createElement("span", { className: Le.iconWrap }, /* @__PURE__ */ t.createElement(Wi, { status: r.status })),
    /* @__PURE__ */ t.createElement("span", { className: Le.label }, r.label),
    !o && s < e.length - 1 && /* @__PURE__ */ t.createElement("span", { className: Le.connector })
  )));
}
const Ki = "_wrapper_1ohmw_1", Hi = "_icon_1ohmw_7", Ui = "_dots_1ohmw_14", Gi = "_dot_1ohmw_14", Yi = "_sm_1ohmw_27", Vi = "_md_1ohmw_32", Rt = {
  wrapper: Ki,
  icon: Hi,
  dots: Ui,
  dot: Gi,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: Yi,
  md: Vi
};
function K2({ withIcon: e, size: n = "md" }) {
  return /* @__PURE__ */ t.createElement("div", { className: Rt.wrapper }, e && /* @__PURE__ */ t.createElement("span", { className: Rt.icon }, e), /* @__PURE__ */ t.createElement("span", { className: [Rt.dots, Rt[n]].join(" ") }, /* @__PURE__ */ t.createElement("span", { className: Rt.dot }), /* @__PURE__ */ t.createElement("span", { className: Rt.dot }), /* @__PURE__ */ t.createElement("span", { className: Rt.dot })));
}
const Ji = "_container_85404_1", Qi = "_table_85404_9", Zi = "_row_85404_31", eu = "_striped_85404_35", tu = "_clickable_85404_43", nu = "_alignLeft_85404_47", au = "_alignCenter_85404_51", ou = "_alignRight_85404_55", ru = "_emptyCell_85404_59", _t = {
  container: Ji,
  table: Qi,
  row: Zi,
  striped: eu,
  clickable: tu,
  alignLeft: nu,
  alignCenter: au,
  alignRight: ou,
  emptyCell: ru
};
function H2({
  columns: e,
  rows: n,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? _t.alignCenter : l === "right" ? _t.alignRight : _t.alignLeft;
  return /* @__PURE__ */ t.createElement("div", { className: _t.container }, /* @__PURE__ */ t.createElement("table", { className: _t.table }, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, e.map((l) => /* @__PURE__ */ t.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ t.createElement("tbody", null, n.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: _t.emptyCell, colSpan: e.length }, r)) : n.map((l, i) => {
    const c = [
      _t.row,
      a && i % 2 === 1 ? _t.striped : "",
      o ? _t.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: i,
        className: c,
        onClick: o ? () => o(l, i) : void 0
      },
      e.map((m) => /* @__PURE__ */ t.createElement("td", { key: m.key, className: s(m.align) }, l[m.key]))
    );
  }))));
}
const su = "_grid_plbcd_1", lu = "_cell_plbcd_6", cu = "_primaryCell_plbcd_16", iu = "_label_plbcd_21", uu = "_value_plbcd_26", mu = "_note_plbcd_32", sn = {
  grid: su,
  cell: lu,
  primaryCell: cu,
  label: iu,
  value: uu,
  note: mu
};
function U2({
  items: e,
  columns: n = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: i,
  primaryLabelColor: c,
  primaryValueColor: m,
  primaryNoteColor: u
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: sn.grid,
      style: { gridTemplateColumns: `repeat(${n}, 1fr)` }
    },
    e.map((d, f) => {
      const p = a && f === 0, y = [sn.cell, p ? sn.primaryCell : ""].filter(Boolean).join(" "), _ = {};
      o !== void 0 && (_.background = o), r !== void 0 && (_.borderColor = r), p && i !== void 0 && (_.background = i, _.borderColor = "transparent");
      const b = {};
      s !== void 0 && (b.color = s), p && c !== void 0 && (b.color = c);
      const $ = {};
      l !== void 0 && ($.color = l), p && m !== void 0 && ($.color = m);
      const E = {};
      return p && u !== void 0 && (E.color = u), /* @__PURE__ */ t.createElement("div", { key: `${d.label}-${f}`, className: y, style: _ }, /* @__PURE__ */ t.createElement("span", { className: sn.label, style: b }, d.label), /* @__PURE__ */ t.createElement("span", { className: sn.value, style: $ }, d.value), d.note && /* @__PURE__ */ t.createElement("span", { className: sn.note, style: E }, d.note));
    })
  );
}
const du = "_button_16ajt_1", _u = "_disabledSolid_16ajt_19", pu = "_icon_16ajt_26", fu = "_label_16ajt_32", yu = "_fullWidth_16ajt_37", bu = "_sm_16ajt_41", hu = "_md_16ajt_47", gu = "_lg_16ajt_53", Eu = "_primary_16ajt_59", vu = "_secondary_16ajt_70", ku = "_outline_16ajt_81", wu = "_ghost_16ajt_93", Nu = "_active_16ajt_104", $u = "_colorOverride_16ajt_116", xu = "_gradient_16ajt_126", Du = "_dashed_16ajt_135", Cu = "_pill_16ajt_139", Xe = {
  button: du,
  disabledSolid: _u,
  icon: pu,
  label: fu,
  fullWidth: yu,
  sm: bu,
  md: hu,
  lg: gu,
  primary: Eu,
  secondary: vu,
  outline: ku,
  ghost: wu,
  active: Nu,
  colorOverride: $u,
  gradient: xu,
  dashed: Du,
  pill: Cu
};
function G2({
  variant: e = "primary",
  size: n = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: i,
  fullWidth: c = !1,
  type: m = "button",
  active: u = !1,
  color: d,
  background: f,
  borderColor: p,
  hoverColor: y,
  hoverBackground: _,
  gradient: b,
  borderStyle: $ = "solid",
  shape: E = "rounded"
}) {
  const k = d !== void 0 || p !== void 0 || y !== void 0 || _ !== void 0, D = [
    Xe.button,
    Xe[e],
    Xe[n],
    c ? Xe.fullWidth : "",
    r && s === "solid" ? Xe.disabledSolid : "",
    u ? Xe.active : "",
    k ? Xe.colorOverride : "",
    b || f ? Xe.gradient : "",
    $ === "dashed" ? Xe.dashed : "",
    E === "pill" ? Xe.pill : ""
  ].filter(Boolean).join(" "), h = {
    ...d !== void 0 ? { "--ax-btn-color": d } : {},
    ...p !== void 0 ? { "--ax-btn-border": p } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ..._ !== void 0 ? { "--ax-btn-hover-bg": _ } : {},
    ...b ? { background: `linear-gradient(135deg, ${b[0]}, ${b[1]})` } : {},
    ...f !== void 0 ? { background: f } : {}
  }, w = a && /* @__PURE__ */ t.createElement("span", { className: Xe.icon }, a);
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: m,
      className: D,
      style: h,
      disabled: r,
      onClick: l
    },
    o === "leading" && w,
    /* @__PURE__ */ t.createElement("span", { className: Xe.label }, i),
    o === "trailing" && w
  );
}
const Au = "_iconButton_1oiog_1", Su = "_sm_1oiog_18", Bu = "_md_1oiog_23", ju = "_lg_1oiog_28", Mu = "_plain_1oiog_33", Tu = "_outline_1oiog_42", Lu = "_circle_1oiog_53", Iu = "_bordered_1oiog_62", qu = "_tint_1oiog_73", Fu = "_active_1oiog_81", Ru = "_hoverBgOverride_1oiog_92", Pu = "_gradient_1oiog_96", At = {
  iconButton: Au,
  sm: Su,
  md: Bu,
  lg: ju,
  plain: Mu,
  outline: Tu,
  circle: Lu,
  bordered: Iu,
  tint: qu,
  active: Fu,
  hoverBgOverride: Ru,
  gradient: Pu
};
function Y2({
  icon: e,
  title: n,
  active: a = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: i = !1,
  color: c,
  hoverColor: m,
  bordered: u = !1,
  borderColor: d = "#e2e8f0",
  borderHoverColor: f = "#3b82f6",
  tint: p = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: _ = "#dbeafe",
  hoverBackground: b,
  gradient: $
}) {
  const E = typeof o == "number", k = [
    At.iconButton,
    E ? "" : At[o],
    At[r],
    a ? At.active : "",
    u ? At.bordered : "",
    p ? At.tint : "",
    b !== void 0 ? At.hoverBgOverride : "",
    $ ? At.gradient : ""
  ].filter(Boolean).join(" "), D = {
    ...E ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...m !== void 0 ? { "--ax-icon-hover": m } : {},
    ...u ? { "--ax-icon-border": d, "--ax-icon-border-hover": f } : {},
    ...p ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": _ } : {},
    ...b !== void 0 ? { "--ax-icon-hover-bg": b } : {},
    ...$ ? { background: `linear-gradient(135deg, ${$[0]}, ${$[1]})` } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: k,
      style: D,
      onClick: s,
      onMouseDown: l,
      disabled: i,
      title: n,
      "aria-label": n
    },
    e
  );
}
const Xu = "_wrapper_wrch3_1", Ou = "_searchIcon_wrch3_18", zu = "_input_wrch3_26", Wu = "_clearButton_wrch3_40", Ku = "_hint_wrch3_60", An = {
  wrapper: Xu,
  searchIcon: Ou,
  input: zu,
  clearButton: Wu,
  hint: Ku
}, Hu = /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ t.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Uu({
  value: e,
  onChange: n,
  placeholder: a,
  hint: o,
  onSubmit: r,
  onClear: s
}) {
  const l = (i) => {
    i.key === "Enter" && (r == null || r());
  };
  return /* @__PURE__ */ t.createElement("div", { className: An.wrapper }, /* @__PURE__ */ t.createElement("span", { className: An.searchIcon }, Hu), /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "text",
      className: An.input,
      value: e,
      placeholder: a,
      onChange: (i) => n(i.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: An.clearButton,
      onClick: s,
      "aria-label": "clear"
    },
    /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ t.createElement("span", { className: An.hint }, o));
}
const Gu = "_control_1kv40_1", Yu = "_option_1kv40_10", Vu = "_active_1kv40_28", Ju = "_sm_1kv40_37", Qu = "_md_1kv40_43", Zu = "_dot_1kv40_49", em = "_count_1kv40_56", tm = "_outline_1kv40_70", nm = "_outlineOption_1kv40_75", pt = {
  control: Gu,
  option: Yu,
  active: Vu,
  sm: Ju,
  md: Qu,
  dot: Zu,
  count: em,
  outline: tm,
  outlineOption: nm
};
function V2({
  options: e,
  value: n,
  onChange: a,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: i
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [pt.control, pt[o], r === "outline" ? pt.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    e.map((c) => {
      const m = c.value === n, u = m ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...i !== void 0 ? { borderColor: i } : {}
      } : void 0;
      return /* @__PURE__ */ t.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": m,
          className: [pt.option, m ? pt.active : "", r === "outline" ? pt.outlineOption : ""].filter(Boolean).join(" "),
          style: u,
          onClick: () => a(c.value)
        },
        c.dot && /* @__PURE__ */ t.createElement("span", { className: pt.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ t.createElement("span", { className: pt.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ t.createElement("span", { className: pt.count }, c.count)
      );
    })
  );
}
const am = "_chip_8jgxm_1", om = "_clickable_8jgxm_14", rm = "_suggested_8jgxm_23", sm = "_readonly_8jgxm_33", lm = "_plusIcon_8jgxm_39", cm = "_label_8jgxm_45", im = "_removeButton_8jgxm_50", ln = {
  chip: am,
  clickable: om,
  default: "_default_8jgxm_18",
  suggested: rm,
  readonly: sm,
  plusIcon: lm,
  label: cm,
  removeButton: im
};
function J2({
  label: e,
  variant: n = "default",
  onRemove: a,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const i = [ln.chip, ln[n], o ? ln.clickable : ""].filter(Boolean).join(" "), m = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, u = n !== "readonly" && !!a, d = /* @__PURE__ */ t.createElement(t.Fragment, null, n === "suggested" && /* @__PURE__ */ t.createElement("span", { className: ln.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ t.createElement("span", { className: ln.label }, e), u && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: ln.removeButton,
      "aria-label": `remove ${e}`,
      onClick: (f) => {
        f.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ t.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: i,
      style: m,
      onClick: o,
      onKeyDown: (f) => {
        (f.key === "Enter" || f.key === " ") && (f.preventDefault(), o());
      }
    },
    d
  ) : /* @__PURE__ */ t.createElement("span", { className: i, style: m }, d);
}
const um = "_wrapper_15dm4_1", mm = "_disabled_15dm4_8", dm = "_track_15dm4_13", _m = "_checked_15dm4_30", pm = "_thumb_15dm4_34", fm = "_label_15dm4_50", cn = {
  wrapper: um,
  disabled: mm,
  track: dm,
  checked: _m,
  thumb: pm,
  label: fm
};
function Q2({
  checked: e,
  onChange: n,
  labelOn: a,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = e ? a : o;
  return /* @__PURE__ */ t.createElement("label", { className: [cn.wrapper, r ? cn.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      disabled: r,
      className: [cn.track, e ? cn.checked : ""].filter(Boolean).join(" "),
      style: e && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && n(!e)
    },
    /* @__PURE__ */ t.createElement("span", { className: cn.thumb })
  ), l && /* @__PURE__ */ t.createElement("span", { className: cn.label }, l));
}
const ym = "_card_1uh3t_1", bm = "_active_1uh3t_24", hm = "_iconChip_1uh3t_29", gm = "_body_1uh3t_41", Em = "_label_1uh3t_48", vm = "_description_1uh3t_54", un = {
  card: ym,
  active: bm,
  iconChip: hm,
  body: gm,
  label: Em,
  description: vm
};
function Z2(e) {
  const { icon: n, label: a, description: o, active: r = !1, onClick: s } = e;
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${un.card} ${r ? un.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ t.createElement("span", { className: un.iconChip }, n),
    /* @__PURE__ */ t.createElement("span", { className: un.body }, /* @__PURE__ */ t.createElement("span", { className: un.label }, a), o && /* @__PURE__ */ t.createElement("span", { className: un.description }, o))
  );
}
const km = "_breadcrumb_zkol9_1", wm = "_list_zkol9_6", Nm = "_item_zkol9_16", $m = "_link_zkol9_22", xm = "_plain_zkol9_43", Dm = "_current_zkol9_48", Cm = "_separator_zkol9_54", Pt = {
  breadcrumb: km,
  list: wm,
  item: Nm,
  link: $m,
  plain: xm,
  current: Dm,
  separator: Cm
};
function ex(e) {
  const { items: n, separator: a = "/", textColor: o, hoverColor: r, currentColor: s } = e, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ t.createElement("nav", { className: Pt.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ t.createElement("ol", { className: Pt.list }, n.map((i, c) => {
    const m = c === n.length - 1;
    return /* @__PURE__ */ t.createElement("li", { key: c, className: Pt.item }, m ? /* @__PURE__ */ t.createElement("span", { className: Pt.current, "aria-current": "page" }, i.label) : i.onClick ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Pt.link,
        onClick: i.onClick
      },
      i.label
    ) : /* @__PURE__ */ t.createElement("span", { className: Pt.plain }, i.label), !m && /* @__PURE__ */ t.createElement("span", { className: Pt.separator, "aria-hidden": "true" }, a));
  })));
}
const Am = "_treeItem_1ouqz_1", Sm = "_active_1ouqz_18", Bm = "_chevron_1ouqz_28", jm = "_chevronExpanded_1ouqz_48", Mm = "_chevronSpacer_1ouqz_52", Tm = "_icon_1ouqz_57", Lm = "_label_1ouqz_69", Im = "_count_1ouqz_76", qm = "_dark_1ouqz_86", ft = {
  treeItem: Am,
  active: Sm,
  chevron: Bm,
  chevronExpanded: jm,
  chevronSpacer: Mm,
  icon: Tm,
  label: Lm,
  count: Im,
  dark: qm
};
function tx(e) {
  const {
    icon: n,
    label: a,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: i = !1,
    theme: c = "light",
    onToggleExpand: m,
    onClick: u
  } = e, d = (p) => {
    p.stopPropagation(), m == null || m();
  }, f = c === "dark" ? ft.dark : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${ft.treeItem} ${f} ${s ? ft.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: u,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? i : void 0
    },
    l ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: `${ft.chevron} ${i ? ft.chevronExpanded : ""}`,
        onClick: d,
        "aria-label": i ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ t.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ t.createElement("span", { className: ft.chevronSpacer }),
    n && /* @__PURE__ */ t.createElement("span", { className: ft.icon }, n),
    /* @__PURE__ */ t.createElement("span", { className: ft.label }, a),
    typeof o == "number" && /* @__PURE__ */ t.createElement("span", { className: ft.count }, o)
  );
}
let Fm = 0;
function Qt(e = "axe") {
  const n = F(null);
  return n.current || (n.current = `${e}-${++Fm}`), n.current;
}
const Rm = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function mo(e) {
  return Array.from(e.querySelectorAll(Rm)).filter((n) => n.getClientRects().length > 0 && getComputedStyle(n).visibility !== "hidden");
}
let _o = 0, po = "";
function ir(e) {
  const n = F(null), a = F(e);
  a.current = e;
  const o = F(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), H(() => {
    var i;
    const s = n.current, l = (i = o.current) != null ? i : null;
    return s && !s.contains(document.activeElement) && (mo(s)[0] || s).focus(), _o++ === 0 && (po = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --_o === 0 && (document.body.style.overflow = po), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: n, onKeyDown: (s) => {
    const l = n.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), a.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const i = mo(l);
    if (i.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = i[0], m = i[i.length - 1], u = document.activeElement;
    s.shiftKey && (u === c || u === l) ? (s.preventDefault(), m.focus()) : !s.shiftKey && u === m && (s.preventDefault(), c.focus());
  } };
}
const Pm = "_backdrop_gstyy_1", Xm = "_panel_gstyy_9", Om = "_right_gstyy_21", zm = "_left_gstyy_27", Wm = "_header_gstyy_51", Km = "_icon_gstyy_59", Hm = "_titleGroup_gstyy_66", Um = "_kicker_gstyy_71", Gm = "_title_gstyy_66", Ym = "_subtitle_gstyy_87", Vm = "_closeButton_gstyy_93", Jm = "_body_gstyy_115", Qm = "_footer_gstyy_123", qe = {
  backdrop: Pm,
  panel: Xm,
  right: Om,
  left: zm,
  header: Wm,
  icon: Km,
  titleGroup: Hm,
  kicker: Um,
  title: Gm,
  subtitle: Ym,
  closeButton: Vm,
  body: Jm,
  footer: Qm
};
function nx(e) {
  return e.open ? /* @__PURE__ */ t.createElement(Zm, { ...e }) : null;
}
function Zm({
  onClose: e,
  icon: n,
  kicker: a,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: i,
  children: c,
  side: m = "right",
  headerBackground: u,
  topOffset: d
}) {
  const { dialogRef: f, onKeyDown: p } = ir(e), y = Qt("ax-drawer-t"), _ = [qe.panel, m === "left" ? qe.left : qe.right].filter(Boolean).join(" "), b = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, $ = d !== void 0 ? { top: d, height: `calc(100vh - ${d}px)` } : void 0;
  return /* @__PURE__ */ t.createElement("div", { className: qe.backdrop, onClick: e }, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: f,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: _,
      style: $,
      onClick: (E) => E.stopPropagation(),
      onKeyDown: p
    },
    /* @__PURE__ */ t.createElement("div", { className: qe.header, style: u !== void 0 ? { background: u } : void 0 }, n && /* @__PURE__ */ t.createElement("span", { className: qe.icon }, n), /* @__PURE__ */ t.createElement("div", { className: qe.titleGroup }, a && /* @__PURE__ */ t.createElement("p", { className: qe.kicker }, a), /* @__PURE__ */ t.createElement("h2", { className: qe.title, id: y, style: b }, o), l && /* @__PURE__ */ t.createElement("p", { className: qe.subtitle }, l)), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: qe.closeButton,
        onClick: e,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ t.createElement("div", { className: qe.body }, c),
    i && /* @__PURE__ */ t.createElement("div", { className: qe.footer }, i)
  ));
}
const ed = "_backdrop_6kso7_1", td = "_menu_6kso7_8", nd = "_alignRight_6kso7_24", ad = "_alignLeft_6kso7_28", od = "_item_6kso7_32", rd = "_itemIcon_6kso7_50", sd = "_itemText_6kso7_59", ld = "_itemLabel_6kso7_66", cd = "_itemDescription_6kso7_72", id = "_danger_6kso7_77", Ze = {
  backdrop: ed,
  menu: td,
  alignRight: nd,
  alignLeft: ad,
  item: od,
  itemIcon: rd,
  itemText: sd,
  itemLabel: ld,
  itemDescription: cd,
  danger: id
};
function ax(e) {
  return e.open ? /* @__PURE__ */ t.createElement(ud, { ...e }) : null;
}
function ud({
  onClose: e,
  items: n,
  anchor: a = "right"
}) {
  const o = F(null), r = F(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), H(() => {
    var m, u, d;
    const c = (m = r.current) != null ? m : null;
    return (d = (u = o.current) == null ? void 0 : u.querySelector("button")) == null || d.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [Ze.menu, a === "left" ? Ze.alignLeft : Ze.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), e();
  }, i = (c) => {
    var f, p;
    const m = Array.from((p = (f = o.current) == null ? void 0 : f.querySelectorAll("button")) != null ? p : []), u = m.indexOf(document.activeElement), d = (y) => {
      var _;
      c.preventDefault(), (_ = m[(y + m.length) % m.length]) == null || _.focus();
    };
    c.key === "ArrowDown" ? d(u + 1) : c.key === "ArrowUp" ? d(u <= 0 ? m.length - 1 : u - 1) : c.key === "Home" ? d(0) : c.key === "End" ? d(m.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), e());
  };
  return /* @__PURE__ */ t.createElement(er, null, /* @__PURE__ */ t.createElement("div", { className: Ze.backdrop, onClick: e }), /* @__PURE__ */ t.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: i }, n.map((c, m) => {
    const u = [Ze.item, c.danger ? Ze.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: m,
        type: "button",
        role: "menuitem",
        className: u,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ t.createElement("span", { className: Ze.itemIcon }, c.icon),
      /* @__PURE__ */ t.createElement("span", { className: Ze.itemText }, /* @__PURE__ */ t.createElement("span", { className: Ze.itemLabel }, c.label), c.description && /* @__PURE__ */ t.createElement("span", { className: Ze.itemDescription }, c.description))
    );
  })));
}
const md = "_backdrop_3pc9i_1", dd = "_card_3pc9i_12", _d = "_header_3pc9i_23", pd = "_icon_3pc9i_31", fd = "_titleGroup_3pc9i_38", yd = "_title_3pc9i_38", bd = "_subtitle_3pc9i_50", hd = "_closeButton_3pc9i_56", gd = "_body_3pc9i_78", Ed = "_footer_3pc9i_85", et = {
  backdrop: md,
  card: dd,
  header: _d,
  icon: pd,
  titleGroup: fd,
  title: yd,
  subtitle: bd,
  closeButton: hd,
  body: gd,
  footer: Ed
};
function ox(e) {
  return e.open ? /* @__PURE__ */ t.createElement(vd, { ...e }) : null;
}
function vd({
  onClose: e,
  icon: n,
  title: a,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: i, onKeyDown: c } = ir(e), m = Qt("ax-modal-t"), u = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ t.createElement("div", { className: et.backdrop, onClick: e }, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: i,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": m,
      className: et.card,
      style: { width: u },
      onClick: (d) => d.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ t.createElement("div", { className: et.header }, n && /* @__PURE__ */ t.createElement("span", { className: et.icon }, n), /* @__PURE__ */ t.createElement("div", { className: et.titleGroup }, /* @__PURE__ */ t.createElement("h2", { className: et.title, id: m }, a), o && /* @__PURE__ */ t.createElement("p", { className: et.subtitle }, o)), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: et.closeButton,
        onClick: e,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ t.createElement("div", { className: et.body }, l),
    r && /* @__PURE__ */ t.createElement("div", { className: et.footer }, r)
  ));
}
const kd = "_page_1f94v_5", wd = "_inner_1f94v_18", fo = {
  page: kd,
  inner: wd
};
function rx({
  gnbHeight: e = 64,
  minWidth: n = 1024,
  className: a = "",
  style: o,
  children: r
}) {
  return /* @__PURE__ */ t.createElement(
    "main",
    {
      className: [fo.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ t.createElement("div", { className: fo.inner, style: { minWidth: n } }, r)
  );
}
const Nd = "_orbitPortalRoot_177qv_2", $d = {
  orbitPortalRoot: Nd
};
class wn extends tr {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const n = this.props.portalClassName || $d.orbitPortalRoot, a = Array.from(document.body.childNodes).find((o) => o.className === n);
      if (!a) {
        const o = document.createElement("div");
        return o.className = n, document.body.appendChild(o), o;
      }
      return a;
    };
  }
  render() {
    return Vr(this.props.children, this.getPortalRoot());
  }
}
const xd = "_anchor_7h2m7_2", Dd = "_tip_7h2m7_5", yo = {
  anchor: xd,
  tip: Dd
};
let Cd = 0;
function Zt({
  content: e,
  children: n,
  placement: a = "bottom",
  delay: o = 250,
  focusable: r,
  describe: s = !0,
  className: l = "",
  keepWrapper: i
}) {
  const [c, m] = B(!1), [u, d] = B({ top: 0, left: 0 }), f = F(null), p = F(null), y = F(null), _ = F("");
  _.current || (_.current = `axe-tip-${++Cd}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, $ = (h) => {
    b(), h <= 0 ? m(!0) : y.current = setTimeout(() => m(!0), h);
  }, E = () => {
    b(), m(!1);
  };
  H(() => b, []), Ke(() => {
    if (!c) return;
    const h = () => {
      const w = f.current, v = p.current;
      if (!w || !v) return;
      const C = w.getBoundingClientRect(), x = v.offsetHeight, A = v.offsetWidth;
      let N = a === "top" ? C.top - x - 6 : C.bottom + 6;
      a === "bottom" && N + x > window.innerHeight - 4 && C.top - x - 6 > 4 && (N = C.top - x - 6), a === "top" && N < 4 && C.bottom + 6 + x < window.innerHeight - 4 && (N = C.bottom + 6);
      const L = Math.max(4, Math.min(C.left + C.width / 2 - A / 2, window.innerWidth - A - 4));
      d((S) => S.top === N && S.left === L ? S : { top: N, left: L });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [c, a, e]), H(() => {
    if (!c) return;
    const h = (w) => {
      w.key === "Escape" && E();
    };
    return document.addEventListener("keydown", h), () => document.removeEventListener("keydown", h);
  }, [c]);
  const k = e != null && e !== !1 && e !== "";
  if (!k && !i) return n;
  const D = k && aa(n) ? nr(n, c && s ? { "aria-describedby": _.current } : {}) : n;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      ref: f,
      className: [yo.anchor, l].filter(Boolean).join(" "),
      tabIndex: r ? 0 : void 0,
      onMouseEnter: () => {
        k && $(o);
      },
      onMouseLeave: E,
      onFocus: () => {
        k && $(0);
      },
      onBlur: E
    },
    D,
    k && c && /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: p,
        id: _.current,
        role: "tooltip",
        className: yo.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: b,
        onMouseLeave: E
      },
      e
    ))
  );
}
const Ad = "_bar_bhn0l_1", Sd = "_menu_bhn0l_9", Bd = "_title_bhn0l_19", jd = "_info_bhn0l_21", Md = "_badge_bhn0l_29", Td = "_badge_muted_bhn0l_30", Ld = "_badge_ok_bhn0l_31", Id = "_badge_warn_bhn0l_32", qd = "_meta_bhn0l_34", Fd = "_actions_bhn0l_18", Rd = "_notice_bhn0l_51", Pd = "_notice_info_bhn0l_57", Xd = "_notice_ok_bhn0l_58", Od = "_notice_err_bhn0l_59", tt = {
  bar: Ad,
  menu: Sd,
  title: Bd,
  info: jd,
  badge: Md,
  badge_muted: Td,
  badge_ok: Ld,
  badge_warn: Id,
  meta: qd,
  actions: Fd,
  notice: Rd,
  notice_info: Pd,
  notice_ok: Xd,
  notice_err: Od
};
function sx({
  title: e,
  onMenu: n,
  info: a,
  badge: o,
  meta: r,
  notice: s,
  children: l
}) {
  var i;
  return /* @__PURE__ */ t.createElement("header", { className: tt.bar }, n && /* @__PURE__ */ t.createElement("button", { type: "button", className: tt.menu, "aria-label": "메뉴", onClick: n }, "☰"), /* @__PURE__ */ t.createElement("h1", { className: tt.title }, e), a && /* @__PURE__ */ t.createElement(Zt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: tt.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(o) ? o : [o]).filter(Boolean).map((c, m) => {
    var u;
    return /* @__PURE__ */ t.createElement("span", { key: m, className: [tt.badge, tt[`badge_${(u = c.tone) != null ? u : "muted"}`]].join(" ") }, c.label);
  }), r && /* @__PURE__ */ t.createElement("span", { className: tt.meta }, r), /* @__PURE__ */ t.createElement("span", { className: tt.actions }, s && s.text && /* @__PURE__ */ t.createElement("span", { className: [tt.notice, tt[`notice_${(i = s.tone) != null ? i : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const zd = "_btn_a0orf_1", Wd = "_sm_a0orf_18", Kd = "_primary_a0orf_21", Hd = "_dark_a0orf_23", Ud = "_danger_a0orf_25", Gd = "_soon_a0orf_29", Yd = "_soonTag_a0orf_30", Vd = "_blocked_a0orf_39", Jd = "_kbd_a0orf_51", Qd = "_iconBtn_a0orf_54", Zd = "_link_a0orf_70", kt = {
  btn: zd,
  sm: Wd,
  primary: Kd,
  dark: Hd,
  danger: Ud,
  soon: Gd,
  soonTag: Yd,
  blocked: Vd,
  kbd: Jd,
  iconBtn: Qd,
  link: Zd
}, hn = Gr(function(n, a) {
  const {
    variant: o = "default",
    size: r = "md",
    kbd: s,
    soon: l,
    blockedReason: i,
    children: c,
    className: m = "",
    type: u = "button",
    onClick: d,
    title: f,
    disabled: p,
    ...y
  } = n, _ = l || i || "", b = _ !== "", $ = "blockedReason" in n, E = /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: a,
      type: u,
      className: [kt.btn, kt[o], r === "sm" ? kt.sm : "", l ? kt.soon : b ? kt.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": b ? !0 : void 0,
      disabled: b ? void 0 : p,
      title: b ? void 0 : f,
      onClick: b ? (k) => k.preventDefault() : d,
      ...y
    },
    c,
    s && /* @__PURE__ */ t.createElement("kbd", { className: kt.kbd }, s),
    l && /* @__PURE__ */ t.createElement("em", { className: kt.soonTag }, "준비 중")
  );
  return b || $ ? /* @__PURE__ */ t.createElement(Zt, { content: _, keepWrapper: $ }, E) : E;
});
function Ma({ label: e, children: n, className: a = "", type: o = "button", ...r }) {
  return /* @__PURE__ */ t.createElement(Zt, { content: e, describe: !1 }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: o,
      className: [kt.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...r
    },
    n
  ));
}
function Ha({ children: e, className: n = "", type: a = "button", ...o }) {
  return /* @__PURE__ */ t.createElement("button", { type: a, className: [kt.link, n].filter(Boolean).join(" "), ...o }, e);
}
const e_ = "_wrap_10shm_1", t_ = "_btn_10shm_2", n_ = "_on_10shm_6", a_ = "_caret_10shm_8", o_ = "_pop_10shm_9", r_ = "_sec_10shm_14", s_ = "_item_10shm_17", l_ = "_danger_10shm_24", St = {
  wrap: e_,
  btn: t_,
  on: n_,
  caret: a_,
  pop: o_,
  sec: r_,
  item: s_,
  danger: l_
}, c_ = (e, n, a, o = {}) => ({ kind: "item", key: e, label: n, onClick: a, ...o }), lx = (e, n, a) => ({ kind: "section", key: e, label: n, note: a });
function i_({ label: e, entries: n, disabled: a, title: o }) {
  const [r, s] = B(!1), l = F(null), i = F(null), c = F(null), m = () => {
    var d, f;
    return Array.from((f = (d = c.current) == null ? void 0 : d.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? f : []);
  };
  H(() => {
    var d;
    r && ((d = m()[0]) == null || d.focus());
  }, [r]), H(() => {
    if (!r) return;
    const d = (p) => {
      l.current && !l.current.contains(p.target) && s(!1);
    }, f = (p) => {
      var y;
      p.key === "Escape" && (s(!1), (y = i.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", f), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", f);
    };
  }, [r]);
  const u = (d) => {
    const f = m();
    if (f.length === 0) return;
    const p = f.indexOf(document.activeElement);
    let y = -1;
    if (d.key === "ArrowDown") y = (p + 1) % f.length;
    else if (d.key === "ArrowUp") y = (p <= 0 ? f.length : p) - 1;
    else if (d.key === "Home") y = 0;
    else if (d.key === "End") y = f.length - 1;
    else if (d.key === "Tab") {
      s(!1);
      return;
    } else return;
    d.preventDefault(), f[y].focus();
  };
  return /* @__PURE__ */ t.createElement("span", { className: St.wrap, ref: l }, /* @__PURE__ */ t.createElement(Zt, { content: r ? void 0 : o, keepWrapper: !0 }, /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: i,
      type: "button",
      className: [St.btn, r ? St.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": r,
      onClick: () => s((d) => !d),
      onKeyDown: (d) => {
        d.key === "ArrowDown" && !r && (d.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ t.createElement("span", { className: St.caret, "aria-hidden": "true" }, "▾")
  )), r && /* @__PURE__ */ t.createElement("div", { ref: c, className: St.pop, role: "menu", onKeyDown: u }, n.map((d) => d.kind === "section" ? /* @__PURE__ */ t.createElement("div", { key: d.key, className: St.sec }, d.label, d.note && /* @__PURE__ */ t.createElement("small", null, d.note)) : /* @__PURE__ */ t.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "menuitem",
      disabled: d.disabled,
      className: [St.item, d.danger ? St.danger : ""].join(" "),
      onClick: () => {
        var f;
        s(!1), (f = i.current) == null || f.focus(), d.onClick();
      }
    },
    /* @__PURE__ */ t.createElement("span", null, d.label),
    d.disabled && d.reason && /* @__PURE__ */ t.createElement("small", null, d.reason)
  ))));
}
function cx(e, n, a = !0) {
  const o = F(n);
  o.current = n, H(() => {
    if (!a) return;
    const r = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, i = document.activeElement;
      !l || !i || !l.contains(i) || (s.preventDefault(), o.current());
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e, a]);
}
function u_() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const m_ = "_bar_1g564_2", d_ = "_sticky_1g564_12", __ = "_start_1g564_19", p_ = "_end_1g564_20", f_ = "_status_1g564_22", y_ = "_dirty_1g564_23", b_ = "_kbd_1g564_25", Xt = {
  bar: m_,
  sticky: d_,
  start: __,
  end: p_,
  status: f_,
  dirty: y_,
  kbd: b_
};
function ix({ start: e, children: n, status: a, dirty: o, inline: r, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-save-bar", Xt.bar, r ? "" : Xt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ t.createElement("span", { className: Xt.start }, e), /* @__PURE__ */ t.createElement("span", { className: Xt.end }, a && /* @__PURE__ */ t.createElement("span", { className: [Xt.status, o ? Xt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), n, s && /* @__PURE__ */ t.createElement("kbd", { className: Xt.kbd }, u_())));
}
const h_ = {
  print: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ t.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ t.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ t.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ t.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ t.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ t.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ t.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ t.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ t.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ t.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ t.createElement("path", { d: "M10 11v6M14 11v6" }))
}, g_ = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function E_({ name: e, className: n }) {
  return /* @__PURE__ */ t.createElement("span", { className: n, "aria-hidden": "true" }, g_[e]);
}
function oa({ name: e, size: n = 15, className: a }) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: a,
      width: n,
      height: n,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    h_[e]
  );
}
const v_ = "_root_j67qt_2", k_ = "_closed_j67qt_3", w_ = "_tab_j67qt_6", N_ = "_collapse_j67qt_7", $_ = "_body_j67qt_16", x_ = "_card_j67qt_32", D_ = "_head_j67qt_37", C_ = "_cardOpen_j67qt_44", A_ = "_headBtn_j67qt_47", S_ = "_icon_j67qt_56", B_ = "_badge_j67qt_57", j_ = "_trailing_j67qt_58", M_ = "_chev_j67qt_59", T_ = "_panelWrap_j67qt_63", L_ = "_panelOpen_j67qt_67", I_ = "_panelBody_j67qt_68", q_ = "_panelInner_j67qt_69", F_ = "_panelSettled_j67qt_70", ke = {
  root: v_,
  closed: k_,
  tab: w_,
  collapse: N_,
  body: $_,
  card: x_,
  head: D_,
  cardOpen: C_,
  headBtn: A_,
  icon: S_,
  badge: B_,
  trailing: j_,
  chev: M_,
  panelWrap: T_,
  panelOpen: L_,
  panelBody: I_,
  panelInner: q_,
  panelSettled: F_
}, R_ = 1280, P_ = 8, ur = "axe-side-bar:";
function X_(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(ur + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function O_(e, n) {
  if (e)
    try {
      window.localStorage.setItem(ur + e, n ? "1" : "0");
    } catch {
    }
}
function ux({
  enabled: e = !0,
  defaultOpen: n = !0,
  width: a = 260,
  collapseBelow: o = R_,
  storageKey: r,
  className: s = "",
  children: l
}) {
  var f;
  const i = F(X_(r)), [c, m] = B((f = i.current) != null ? f : n), u = F(i.current !== null);
  if (H(() => {
    if (!e || !o || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${o - 1}px)`), y = () => {
      u.current || m(!p.matches && n);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, o, n]), !e) return null;
  const d = () => {
    u.current = !0, O_(r, !c), m(!c);
  };
  return /* @__PURE__ */ t.createElement(
    "aside",
    {
      className: ["axe-side-bar", ke.root, c ? "" : ke.closed, s].filter(Boolean).join(" "),
      style: { width: c ? a : P_ }
    },
    /* @__PURE__ */ t.createElement("div", { className: ke.tab }, /* @__PURE__ */ t.createElement(Zt, { content: c ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: ke.collapse,
        onClick: d,
        "aria-label": c ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": c
      },
      /* @__PURE__ */ t.createElement(E_, { name: c ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ t.createElement("div", { className: ke.body }, l)
  );
}
const mr = Oa(null);
function mx({ children: e, defaultOpenId: n = null, exclusive: a = !0 }) {
  const [o, r] = B(n);
  return a ? /* @__PURE__ */ t.createElement(mr.Provider, { value: { openId: o, setOpenId: r } }, e) : /* @__PURE__ */ t.createElement(t.Fragment, null, e);
}
const dr = "axe-side-panel:";
function z_(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(dr + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function W_(e, n) {
  if (e)
    try {
      window.localStorage.setItem(dr + e, n ? "1" : "0");
    } catch {
    }
}
function dx({
  title: e,
  enabled: n = !0,
  defaultOpen: a = !0,
  icon: o,
  badge: r,
  trailing: s,
  storageKey: l,
  panelId: i,
  className: c = "",
  children: m
}) {
  var h;
  const u = za(mr), d = !!u && i != null, f = F(z_(l)), [p, y] = B((h = f.current) != null ? h : a), _ = d ? u.openId === i : p, [b, $] = B(_), [E, k] = B(_);
  if (!n) return null;
  _ && !b && $(!0);
  const D = () => {
    const w = !_;
    W_(l, w), $(!0), k(!1), d ? u.setOpenId(w ? i : null) : y(w);
  };
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-side-card", ke.card, _ ? ke.cardOpen : "", c].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("header", { className: ke.head, onClick: D }, /* @__PURE__ */ t.createElement("button", { type: "button", className: ke.headBtn, "aria-expanded": _ }, o && /* @__PURE__ */ t.createElement("span", { className: ke.icon, "aria-hidden": "true" }, o), /* @__PURE__ */ t.createElement("strong", null, e)), r && /* @__PURE__ */ t.createElement("span", { className: ke.badge }, r), s && /* @__PURE__ */ t.createElement("span", { className: ke.trailing, onClick: (w) => w.stopPropagation() }, s), /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: ke.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ t.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [ke.panelWrap, _ ? ke.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && k(!0);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: [ke.panelBody, _ && E ? ke.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: ke.panelInner }, m))
  ));
}
const K_ = "_guide_qnh7l_1", H_ = "_title_qnh7l_5", U_ = "_desc_qnh7l_6", G_ = "_act_qnh7l_7", Y_ = "_why_qnh7l_13", V_ = "_steps_qnh7l_14", J_ = "_no_qnh7l_20", Q_ = "_cur_qnh7l_24", Z_ = "_link_qnh7l_26", yt = {
  guide: K_,
  title: H_,
  desc: U_,
  act: G_,
  why: Y_,
  steps: V_,
  no: J_,
  cur: Q_,
  link: Z_
};
function _x({ title: e, desc: n, action: a, steps: o }) {
  return /* @__PURE__ */ t.createElement("section", { className: yt.guide, "aria-label": e }, /* @__PURE__ */ t.createElement("h2", { className: yt.title }, e), n && /* @__PURE__ */ t.createElement("p", { className: yt.desc }, n), a && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", className: yt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ t.createElement("p", { className: yt.why }, a.reason)), o && o.length > 0 && /* @__PURE__ */ t.createElement("ol", { className: yt.steps }, o.map((r, s) => /* @__PURE__ */ t.createElement("li", { key: r.label, className: r.current ? yt.cur : void 0 }, /* @__PURE__ */ t.createElement("span", { className: yt.no }, s + 1), r.onClick && !r.current ? /* @__PURE__ */ t.createElement("button", { type: "button", className: yt.link, onClick: r.onClick }, r.label) : /* @__PURE__ */ t.createElement("span", null, r.label), r.hint && /* @__PURE__ */ t.createElement("small", null, r.hint)))));
}
const ep = "_list_1w2rs_1", tp = "_row_1w2rs_2", np = "_label_1w2rs_6", ap = "_value_1w2rs_7", op = "_emphasis_1w2rs_8", rp = "_changed_1w2rs_10", mn = {
  list: ep,
  row: tp,
  label: np,
  value: ap,
  emphasis: op,
  changed: rp
};
function px({ items: e, className: n }) {
  return /* @__PURE__ */ t.createElement("dl", { className: [mn.list, n != null ? n : ""].join(" ") }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: [mn.row, a.emphasis ? mn.emphasis : ""].join(" ") }, /* @__PURE__ */ t.createElement("dt", { className: mn.label }, a.label), /* @__PURE__ */ t.createElement("dd", { className: [mn.value, a.changed ? mn.changed : ""].join(" ") }, a.value))));
}
const sp = "_underline_xl221_2", lp = "_active_xl221_24", cp = "_segmented_xl221_33", ha = {
  underline: sp,
  active: lp,
  segmented: cp
};
function _r({
  items: e,
  value: n,
  onChange: a,
  variant: o = "underline",
  className: r = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      className: [o === "segmented" ? ha.segmented : ha.underline, r].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === n,
        className: l.key === n ? ha.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const ip = "_bar_1e999_1", up = "_actions_1e999_17", mp = "_field_1e999_24", dp = "_fieldLabel_1e999_25", _p = "_readout_1e999_33", pp = "_search_1e999_44", fp = "_detail_1e999_58", yp = "_pill_1e999_70", bp = "_hint_1e999_81", wt = {
  bar: ip,
  actions: up,
  field: mp,
  fieldLabel: dp,
  readout: _p,
  search: pp,
  detail: fp,
  pill: yp,
  hint: bp
}, hp = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function gp(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const n = e.target;
  return !(!(n instanceof HTMLInputElement) || !e.currentTarget.contains(n) || !hp.has(n.type) || n.readOnly || n.disabled || n.getAttribute("role") === "combobox" || n.getAttribute("aria-expanded") === "true");
}
function fx({
  children: e,
  onSearch: n,
  searchLabel: a = "조회",
  searchDisabled: o,
  searchTitle: r,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: i = "상세검색",
  trailing: c,
  enterSearch: m = !0
}) {
  const u = (d) => {
    !m || !n || o || !gp(d) || (d.preventDefault(), n());
  };
  return /* @__PURE__ */ t.createElement("section", { className: wt.bar, onKeyDown: u }, e, /* @__PURE__ */ t.createElement("span", { className: wt.actions }, c, s && /* @__PURE__ */ t.createElement("button", { type: "button", className: wt.detail, onClick: l }, "⌕ ", i), n && /* @__PURE__ */ t.createElement(Zt, { content: r, keepWrapper: !0 }, /* @__PURE__ */ t.createElement("button", { type: "button", className: wt.search, onClick: n, disabled: o }, "⌕ ", a))));
}
function Ep({ label: e, children: n }) {
  return /* @__PURE__ */ t.createElement("label", { className: wt.field }, /* @__PURE__ */ t.createElement("span", { className: wt.fieldLabel }, e), n);
}
function yx({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: wt.readout }, e);
}
function bx({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: wt.pill, role: "status" }, e);
}
function hx({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: wt.hint }, e);
}
function vp(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function gx({ rows: e, value: n, onChange: a, disabled: o, label: r = "기수" }) {
  return /* @__PURE__ */ t.createElement(Ep, { label: r }, /* @__PURE__ */ t.createElement(
    "select",
    {
      value: n != null ? n : "",
      "aria-label": r,
      disabled: o,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ t.createElement("option", { key: s.gisu, value: s.gisu }, vp(s)))
  ));
}
class pr {
  constructor(n, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((o) => {
        try {
          for (const r of o) {
            const s = r.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, r);
          }
        } catch (r) {
          console.error(r);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = n, this._callback = a, this.initializeResizeObserver();
  }
}
const kp = "_card_1iq35_2", wp = "_grow_1iq35_19", Np = "_head_1iq35_21", $p = "_title_1iq35_30", xp = "_trailing_1iq35_31", Dp = "_scroll_1iq35_9", Cp = "_foot_1iq35_49", Ap = "_strip_1iq35_51", Sp = "_pager_1iq35_53", Bp = "_spacer_1iq35_55", jp = "_table_1iq35_57", Mp = "_fixed_1iq35_58", Tp = "_fz_1iq35_76", Lp = "_fzEdge_1iq35_88", Ip = "_frozen_1iq35_95", qp = "_statusCell_1iq35_38", Fp = "_status_1iq35_38", Rp = "_st_error_1iq35_222", Pp = "_stIcon_1iq35_223", Xp = "_spin_1iq35_229", Op = "_axeSpin_1iq35_1", zp = "_busy_1iq35_239", Wp = "_statusRow_1iq35_241", Kp = "_busyBar_1iq35_242", Hp = "_axeBusy_1iq35_1", me = {
  card: kp,
  grow: wp,
  head: Np,
  title: $p,
  trailing: xp,
  scroll: Dp,
  foot: Cp,
  strip: Ap,
  pager: Sp,
  spacer: Bp,
  table: jp,
  fixed: Mp,
  fz: Tp,
  fzEdge: Lp,
  frozen: Ip,
  statusCell: qp,
  status: Fp,
  st_error: Rp,
  stIcon: Pp,
  spin: Xp,
  axeSpin: Op,
  busy: zp,
  statusRow: Wp,
  busyBar: Kp,
  axeBusy: Hp
}, Up = 120;
function Gp(e) {
  if (!e || !e.length) return;
  let n = 0, a = 0;
  for (const o of e)
    if (o == null) a += 1;
    else if (typeof o == "number") n += o;
    else if (/^\d+(\.\d+)?px$/.test(o)) n += parseFloat(o);
    else return;
  return a > 0 ? n + a * Up : void 0;
}
function bo({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ t.createElement("colgroup", null, e.map((n, a) => /* @__PURE__ */ t.createElement("col", { key: a, style: n == null ? void 0 : { width: n } })));
}
const ho = /* @__PURE__ */ new Set();
function Yp(e) {
  var o;
  if (typeof process == "undefined" || ((o = process.env) == null ? void 0 : o.NODE_ENV) === "production") return;
  const n = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, l;
    r.scrollWidth > r.clientWidth + 1 && n.push((l = (s = r.textContent) == null ? void 0 : s.trim()) != null ? l : "");
  }), !n.length) return;
  const a = n.slice(0, 5).join("|");
  ho.has(a) || (ho.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${n.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    n.slice(0, 5)
  ));
}
function go(e, n, a) {
  if (!e) return;
  const o = /* @__PURE__ */ new Map();
  for (const r of Array.from(e.rows)) {
    o.forEach((l, i) => {
      l <= 1 ? o.delete(i) : o.set(i, l - 1);
    });
    let s = 0;
    for (const l of Array.from(r.cells)) {
      for (; o.has(s); ) s += 1;
      const i = l.colSpan || 1, c = n > 0 && s + i <= n;
      if (l.classList.toggle(me.fz, c), l.classList.toggle(me.fzEdge, c && s + i === n), l.style.left = c ? `${a[s]}px` : "", l.rowSpan > 1) for (let m = s; m < s + i; m += 1) o.set(m, l.rowSpan);
      s += i;
    }
  }
}
function Ex({
  cols: e,
  footer: n,
  pagination: a,
  title: o,
  trailing: r,
  grow: s,
  fixed: l,
  stickyCols: i = 0,
  busy: c,
  tableRole: m,
  "aria-label": u,
  className: d = "",
  children: f
}) {
  const p = l || e !== void 0 && e.length > 0, y = p ? Gp(e) : void 0, { stick: _, offsets: b } = xe(() => {
    const A = Math.max(Math.trunc(i), 0), N = [];
    if (A === 0 || !e) return { stick: 0, offsets: N };
    let L = 0, S = 0;
    for (let P = 0; P < A; P += 1) {
      const W = e[P];
      if (typeof W != "number") break;
      N.push(L), L += W, S += 1;
    }
    return { stick: S, offsets: N };
  }, [e, i]), $ = [me.table, p ? me.fixed : "", _ > 0 ? me.frozen : ""].filter(Boolean).join(" "), E = F(null), k = F(null), D = F(null), h = F(null), w = F(0), v = () => {
    const A = E.current, N = D.current, L = h.current;
    if (!A || !N || !L) return;
    const S = A.scrollWidth;
    L.style.width = S + "px", N.style.display = S > A.clientWidth + 1 ? "" : "none";
    const P = A.offsetWidth - A.clientWidth;
    N.style.paddingRight = P + "px", k.current && (k.current.style.paddingRight = P + "px"), Yp(A);
  };
  H(() => {
    const A = E.current;
    if (!A) return;
    const N = new pr(A, v);
    return () => N.detach();
  }, []), Ke(() => {
    var A, N, L, S, P;
    (_ > 0 || w.current > 0) && (go((N = (A = E.current) == null ? void 0 : A.querySelector("table")) != null ? N : null, _, b), go((S = (L = k.current) == null ? void 0 : L.querySelector("table")) != null ? S : null, _, b)), w.current = _, (P = E.current) == null || P.querySelectorAll("thead th:not([scope])").forEach((W) => W.setAttribute("scope", "col")), v();
  });
  const C = (A) => {
    const N = A.target.scrollLeft;
    E.current && (E.current.scrollLeft = N), k.current && (k.current.scrollLeft = N);
  }, x = (A) => {
    const N = A.target.scrollLeft;
    k.current && (k.current.scrollLeft = N), D.current && (D.current.scrollLeft = N);
  };
  return /* @__PURE__ */ t.createElement("div", { className: [me.card, s ? me.grow : "", c ? me.busy : "", d].filter(Boolean).join(" ") }, c && /* @__PURE__ */ t.createElement("div", { className: me.busyBar, "aria-hidden": "true" }), (o !== void 0 || r !== void 0) && /* @__PURE__ */ t.createElement("header", { className: me.head }, /* @__PURE__ */ t.createElement("span", { className: me.title }, o), r && /* @__PURE__ */ t.createElement("span", { className: me.trailing }, r)), /* @__PURE__ */ t.createElement("div", { className: me.scroll, ref: E, onScroll: x }, /* @__PURE__ */ t.createElement("table", { className: $, "aria-busy": c || void 0, "aria-label": u != null ? u : typeof o == "string" && o ? o : void 0, style: y ? { minWidth: y } : void 0 }, /* @__PURE__ */ t.createElement(bo, { cols: e }), f)), n && /* @__PURE__ */ t.createElement("div", { className: me.foot, ref: k }, /* @__PURE__ */ t.createElement("table", { className: $, style: y ? { minWidth: y } : void 0 }, /* @__PURE__ */ t.createElement(bo, { cols: e }), /* @__PURE__ */ t.createElement("tbody", null, n))), /* @__PURE__ */ t.createElement("div", { className: me.strip, ref: D, onScroll: C }, /* @__PURE__ */ t.createElement("div", { ref: h, className: me.spacer })), a && /* @__PURE__ */ t.createElement("div", { className: me.pager }, a));
}
const Vp = 7.09, Jp = 3.88, Qp = 4.46, Zp = 16, ef = 2;
function tf(e, n = {}) {
  var s;
  const a = Math.max(1, e), o = Math.floor((a - 1) / 3), r = a * Vp + o * Jp + (n.negative ? Qp : 0) + Zp + ef;
  return Math.max(Math.ceil(r), (s = n.min) != null ? s : 0);
}
function vx(e, n = {}) {
  var r, s;
  let a = 0, o = (r = n.negative) != null ? r : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const i = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(i)) continue;
    i < 0 && (o = !0);
    const c = Math.floor(Math.abs(i)).toString().length;
    c > a && (a = c);
  }
  return a === 0 ? Math.max((s = n.min) != null ? s : 96, 96) : tf(a, { ...n, negative: o });
}
function kx(e) {
  const n = document.createElement("span");
  n.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(n);
  const a = (l) => (n.textContent = l, n.getBoundingClientRect().width), o = a("000000000000"), r = a("000,000,000,000"), s = a("-000,000,000,000");
  return n.remove(), { digit: o / 12, comma: (r - o) / 3, minus: s - r };
}
function wx({
  colSpan: e,
  loading: n,
  error: a,
  count: o,
  empty: r = "조회 결과가 없습니다",
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: i = ""
}) {
  const c = a != null && a !== !1 && a !== "", m = o == null || o === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let d;
  if (c) d = "error";
  else if (n && m) d = "loading";
  else if (o == null) {
    if (s === null) return null;
    d = "idle";
  } else if (o === 0) d = "empty";
  else return null;
  const f = /* @__PURE__ */ t.createElement(t.Fragment, null, d === "loading" && /* @__PURE__ */ t.createElement("span", { className: me.spin, "aria-hidden": "true" }), d === "error" && /* @__PURE__ */ t.createElement("span", { className: me.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ t.createElement("span", null, d === "error" ? u : d === "loading" ? l : d === "idle" ? s : r)), p = /* @__PURE__ */ t.createElement("div", { className: [me.status, me[`st_${d}`]].join(" "), role: "status" }, f);
  return e === void 0 ? /* @__PURE__ */ t.createElement("div", { className: i || void 0, "data-state": d }, p) : /* @__PURE__ */ t.createElement("tr", { className: [me.statusRow, i].filter(Boolean).join(" "), "data-state": d }, /* @__PURE__ */ t.createElement("td", { colSpan: e, className: me.statusCell }, p));
}
function Nx(e, n) {
  return {
    tabIndex: 0,
    "aria-current": n ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const nf = "_cell_n9rrj_1", af = "_toggle_n9rrj_2", of = "_spacer_n9rrj_8", rf = "_label_n9rrj_9", sf = "_dim_n9rrj_10", Sn = {
  cell: nf,
  toggle: af,
  spacer: of,
  label: rf,
  dim: sf
};
function $x(e, { id: n, parentId: a, defaultOpen: o = !0 }) {
  const [r, s] = B(() => /* @__PURE__ */ new Set()), [l, i] = B(() => /* @__PURE__ */ new Set()), { parents: c, kids: m } = xe(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), _ = new Set(e.map((b) => String(n(b))));
    for (const b of e) {
      const $ = a(b), E = $ == null || !_.has(String($)) ? null : String($);
      p.set(String(n(b)), E), E && y.add(E);
    }
    return { parents: p, kids: y };
  }, [e, n, a]), u = se((p) => o ? !r.has(p) : l.has(p), [o, r, l]), d = xe(() => e.filter((p) => {
    var b, $;
    let y = (b = c.get(String(n(p)))) != null ? b : null;
    const _ = /* @__PURE__ */ new Set();
    for (; y && !_.has(y); ) {
      if (!u(y)) return !1;
      _.add(y), y = ($ = c.get(y)) != null ? $ : null;
    }
    return !0;
  }), [e, c, n, u]), f = se((p, y) => {
    const _ = (b, $) => {
      const E = new Set(b);
      return $ ? E.add(p) : E.delete(p), E;
    };
    o ? s((b) => _(b, !y)) : i((b) => _(b, y));
  }, [o]);
  return {
    visible: d,
    hasChildren: (p) => m.has(String(n(p))),
    isOpen: (p) => u(String(n(p))),
    toggle: (p) => {
      const y = String(n(p));
      f(y, !u(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), i(new Set(m));
    },
    collapseAll: () => {
      s(new Set(m)), i(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = r, y = l;
      return s(/* @__PURE__ */ new Set()), i(new Set(m)), () => {
        s(p), i(y);
      };
    },
    reveal: (p) => {
      var b, $;
      let y = (b = c.get(String(p))) != null ? b : null;
      const _ = /* @__PURE__ */ new Set();
      for (; y && !_.has(y); )
        f(y, !0), _.add(y), y = ($ = c.get(y)) != null ? $ : null;
    }
  };
}
function xx({ depth: e, hasChildren: n, open: a, onToggle: o, dim: r, toggleOutOfTabOrder: s, title: l, csvPath: i, children: c }) {
  const m = (d) => {
    d.stopPropagation(), o();
  }, u = l != null ? l : typeof c == "string" ? c : void 0;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: [Sn.cell, r ? Sn.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": i
    },
    n ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Sn.toggle,
        "aria-expanded": a,
        "aria-label": `${u ? `${u} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: m,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ t.createElement("span", { className: Sn.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ t.createElement("span", { className: Sn.label, title: u }, c)
  );
}
function lf(e, n, a, o = !1) {
  const r = e[n.r];
  if (!r || n.i < 0 || n.i >= r.length) return null;
  const s = r[n.i], l = e.findIndex((c) => c.length > 0);
  let i = -1;
  for (let c = e.length - 1; c >= 0; c--) if (e[c].length > 0) {
    i = c;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return n.i > 0 ? { r: n.r, i: n.i - 1 } : null;
    case "ArrowRight":
      return n.i < r.length - 1 ? { r: n.r, i: n.i + 1 } : null;
    case "Home":
      return o ? { r: l, i: 0 } : { r: n.r, i: 0 };
    case "End":
      return o ? { r: i, i: e[i].length - 1 } : { r: n.r, i: r.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const c = a === "ArrowUp" ? -1 : 1;
      for (let m = n.r + c; m >= 0 && m < e.length; m += c)
        if (e[m].length > 0) return { r: m, i: cf(e[m], s) };
      return null;
    }
    default:
      return null;
  }
}
function cf(e, n) {
  let a = 0;
  for (let o = 1; o < e.length; o++)
    Math.abs(e[o] - n) < Math.abs(e[a] - n) && (a = o);
  return a;
}
function Dx(e, n = {}) {
  var i;
  const a = (i = n.cellSelector) != null ? i : "[data-roving]", o = n.initialSelector, r = F(null), [s, l] = B(null);
  H(() => {
    e.current !== s && l(e.current);
  }), H(() => {
    if (!s) return;
    const c = () => Array.from(s.querySelectorAll(a)), m = () => {
      const y = c();
      if (!y.length) {
        r.current = null;
        return;
      }
      (!r.current || !y.includes(r.current)) && (r.current = o && y.find((_) => _.matches(o)) || y[0]), y.forEach((_) => {
        const b = _ === r.current ? "0" : "-1";
        _.getAttribute("tabindex") !== b && _.setAttribute("tabindex", b);
      });
    }, u = () => {
      const y = c(), _ = [], b = [], $ = /* @__PURE__ */ new Map(), E = [];
      return y.forEach((k) => {
        var A;
        const D = k.tagName === "TR", h = D ? null : k.closest("td, th"), w = h && s.contains(h) ? h.parentElement : null, v = D ? k : (A = w != null ? w : k.parentElement) != null ? A : s;
        let C = _.indexOf(v);
        C < 0 && (C = _.length, _.push(v), b.push([]), E.push([]));
        let x;
        if (D)
          x = 0;
        else if (h && w) {
          x = 0;
          for (const N of Array.from(w.cells)) {
            if (N === h) break;
            x += Math.max(1, N.colSpan || 1);
          }
        } else
          x = b[C].length;
        $.set(k, { r: C, i: b[C].length }), b[C].push(x), E[C].push(k);
      }), { rows: b, where: $, byPos: E };
    }, d = (y) => {
      var w;
      const _ = y.target;
      if (!_ || !_.matches(a) || !s.contains(_) || y.altKey || y.metaKey || _.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: $, byPos: E } = u(), k = $.get(_);
      if (!k) return;
      const D = lf(b, k, y.key, y.ctrlKey);
      if (D === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (w = E[D.r]) == null ? void 0 : w[D.i];
      h && (r.current = h, m(), h.focus());
    }, f = (y) => {
      const _ = y.target;
      !_ || !_.matches(a) || _ === r.current || (r.current = _, m());
    };
    m(), s.addEventListener("keydown", d), s.addEventListener("focusin", f);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(m) : null;
    return p == null || p.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", d), s.removeEventListener("focusin", f), p == null || p.disconnect();
    };
  }, [s, a, o]);
}
function uf(e, n) {
  return !e || e.key !== n ? { key: n, dir: "asc" } : e.dir === "asc" ? { key: n, dir: "desc" } : null;
}
function mf(e, n) {
  return !e || e.key !== n ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function df(e, n) {
  return e ? `${n(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
const _f = "_btn_r1trx_1", pf = "_mark_r1trx_7", ff = "_sr_r1trx_9", Ta = {
  btn: _f,
  mark: pf,
  sr: ff
};
function Cx({ sortKey: e, sort: n, onSort: a, children: o, className: r = "", colSpan: s, style: l, title: i }) {
  const c = mf(n, e);
  return /* @__PURE__ */ t.createElement("th", { scope: "col", "aria-sort": c, colSpan: s, style: l, title: i, className: r }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ta.btn, onClick: () => a(uf(n, e)) }, /* @__PURE__ */ t.createElement("span", null, o), /* @__PURE__ */ t.createElement("span", { className: Ta.mark, "aria-hidden": "true" }, c === "ascending" ? "▲" : c === "descending" ? "▼" : "↕")));
}
function Ax({ sort: e, labelOf: n }) {
  return /* @__PURE__ */ t.createElement("span", { className: Ta.sr, role: "status", "aria-live": "polite" }, df(e, n));
}
const yf = "_card_14vt3_1", bf = "_accent_14vt3_8", hf = "_grow_14vt3_9", gf = "_head_14vt3_11", Ef = "_body_14vt3_20", vf = "_title_14vt3_28", kf = "_trailing_14vt3_29", wf = "_summary_14vt3_32", Nf = "_sumHead_14vt3_33", $f = "_sumTotal_14vt3_42", xf = "_tone_warn_14vt3_43", Df = "_tone_ok_14vt3_44", Cf = "_sumList_14vt3_46", Af = "_sumEm_14vt3_55", Sf = "_sumFoot_14vt3_57", Bf = "_sumNote_14vt3_66", $e = {
  card: yf,
  accent: bf,
  grow: hf,
  head: gf,
  body: Ef,
  title: vf,
  trailing: kf,
  summary: wf,
  sumHead: Nf,
  sumTotal: $f,
  tone_warn: xf,
  tone_ok: Df,
  sumList: Cf,
  sumEm: Af,
  sumFoot: Sf,
  sumNote: Bf
};
function fr({
  title: e,
  trailing: n,
  accent: a,
  grow: o,
  flush: r,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ t.createElement(
    "section",
    {
      className: [$e.card, a ? $e.accent : "", o ? $e.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ t.createElement("header", { className: $e.head }, /* @__PURE__ */ t.createElement("span", { className: $e.title, role: "heading", "aria-level": 2 }, e), n && /* @__PURE__ */ t.createElement("span", { className: $e.trailing }, n)),
    r ? l : /* @__PURE__ */ t.createElement("div", { className: ["axe-card-body", $e.body].join(" ") }, l)
  );
}
function Sx({
  title: e,
  total: n,
  items: a,
  footerLabel: o,
  footerValue: r,
  note: s,
  tone: l = "default",
  children: i
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [$e.card, $e.accent, $e.summary, $e[`tone_${l}`]].join(" ") }, /* @__PURE__ */ t.createElement("header", { className: $e.sumHead }, /* @__PURE__ */ t.createElement("span", null, e), n !== void 0 && /* @__PURE__ */ t.createElement("strong", { className: $e.sumTotal }, n)), /* @__PURE__ */ t.createElement("ul", { className: $e.sumList }, a.map((c, m) => {
    var u;
    return /* @__PURE__ */ t.createElement("li", { key: (u = c.key) != null ? u : m, className: c.em ? $e.sumEm : "" }, /* @__PURE__ */ t.createElement("span", null, c.label), /* @__PURE__ */ t.createElement("strong", null, c.value));
  })), i, o !== void 0 && /* @__PURE__ */ t.createElement("footer", { className: $e.sumFoot }, /* @__PURE__ */ t.createElement("span", null, o), /* @__PURE__ */ t.createElement("strong", null, r)), s && /* @__PURE__ */ t.createElement("div", { className: $e.sumNote }, s));
}
const jf = "_sr_1y2mv_2", Mf = "_skip_1y2mv_8", Tf = "_crit_1y2mv_16", Lf = "_c_danger_1y2mv_21", If = "_c_warn_1y2mv_22", qf = "_critI_1y2mv_23", Ff = "_critBody_1y2mv_24", Rf = "_critX_1y2mv_25", Pf = "_ch_1y2mv_32", Xf = "_chBtn_1y2mv_33", Of = "_chBox_1y2mv_43", rt = {
  sr: jf,
  skip: Mf,
  crit: Tf,
  c_danger: Lf,
  c_warn: If,
  critI: qf,
  critBody: Ff,
  critX: Rf,
  ch: Pf,
  chBtn: Xf,
  chBox: Of
};
function yr({ as: e = "span", children: n, id: a }) {
  return /* @__PURE__ */ t.createElement(e, { className: rt.sr, id: a }, n);
}
function Bx({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: n = "" }) {
  const a = (o, r) => {
    const s = document.getElementById(r);
    s && (o.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ t.createElement("nav", { className: [rt.skip, n].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((o) => /* @__PURE__ */ t.createElement("a", { key: o.targetId, href: `#${o.targetId}`, onClick: (r) => a(r, o.targetId) }, o.label)));
}
function jx({ title: e, children: n, tone: a = "danger", onClose: o, className: r = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: [rt.crit, rt[`c_${a}`], r].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ t.createElement("span", { className: rt.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ t.createElement("div", { className: rt.critBody }, /* @__PURE__ */ t.createElement("b", null, e), n ? /* @__PURE__ */ t.createElement("span", null, " ", n) : null), o && /* @__PURE__ */ t.createElement("button", { type: "button", className: rt.critX, onClick: o, "aria-label": "공지 닫기" }, "✕"));
}
function Mx({ label: e, children: n, className: a = "" }) {
  const [o, r] = B(!1), s = Qt("axe-ch"), l = F(null), i = F(null);
  return H(() => {
    if (!o) return;
    const c = (u) => {
      l.current && !l.current.contains(u.target) && r(!1);
    }, m = (u) => {
      var d;
      u.key === "Escape" && (r(!1), (d = i.current) == null || d.focus());
    };
    return document.addEventListener("mousedown", c), document.addEventListener("keydown", m), () => {
      document.removeEventListener("mousedown", c), document.removeEventListener("keydown", m);
    };
  }, [o]), /* @__PURE__ */ t.createElement("span", { className: [rt.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: i,
      type: "button",
      className: rt.chBtn,
      "aria-label": e,
      "aria-expanded": o,
      "aria-controls": s,
      onClick: () => r((c) => !c)
    },
    "?"
  ), o && /* @__PURE__ */ t.createElement("span", { id: s, role: "region", "aria-label": e, className: rt.chBox }, n));
}
function La(e, n, a = "codeName") {
  const o = (e != null ? e : "").trim();
  if (!o) return "";
  const r = (n != null ? n : "").trim();
  return !r || a === "code" ? o : a === "name" ? r : `${o}. ${r}`;
}
function zf(e, n = "전체", a = "codeName") {
  if (e.length === 0) return n;
  const o = La(e[0].cd, e[0].nm, a);
  return e.length === 1 ? o : `${o} 외 ${e.length - 1}건`;
}
function Wf(e, n, a, o) {
  const r = (e != null ? e : "").trim();
  if (!r) return null;
  if (n && n.name && n.code === r) return n.name;
  if (a && a.code === r && a.name) return a.name;
  const s = o == null ? void 0 : o.find((l) => l.code === r);
  return s && s.name ? s.name : null;
}
const Kf = "_root_umk7w_1", Hf = "_rootNone_umk7w_5", Uf = "_field_umk7w_12", Gf = "_codeInput_umk7w_13", Yf = "_pickBtn_umk7w_17", Vf = "_suggest_umk7w_34", Jf = "_suggestList_umk7w_40", Qf = "_suggestRow_umk7w_41", Zf = "_suggestOn_umk7w_42", ey = "_suggestEmpty_umk7w_47", ty = "_suggestMore_umk7w_47", ny = "_popup_umk7w_51", ay = "_popupHead_umk7w_65", oy = "_searchRow_umk7w_75", ry = "_list_umk7w_79", sy = "_current_umk7w_88", ly = "_empty_umk7w_92", cy = "_summaryBtn_umk7w_100", iy = "_ov_umk7w_121", uy = "_modal_umk7w_132", my = "_modalWide_umk7w_132", dy = "_head_umk7w_144", _y = "_sub_umk7w_152", py = "_x_umk7w_154", fy = "_body_umk7w_171", yy = "_chips_umk7w_179", by = "_chip_umk7w_179", hy = "_chipOn_umk7w_193", gy = "_search_umk7w_75", Ey = "_tbl_umk7w_212", vy = "_row_umk7w_242", ky = "_rowCursor_umk7w_244", wy = "_rowPicked_umk7w_245", Ny = "_rowCurrent_umk7w_246", $y = "_curTag_umk7w_247", xy = "_busy_umk7w_248", Dy = "_count_umk7w_249", Cy = "_chk_umk7w_251", Ay = "_tdLeft_umk7w_252", Sy = "_tdCenter_umk7w_253", By = "_emptyCell_umk7w_255", jy = "_stop_umk7w_257", My = "_more_umk7w_268", Ty = "_pager_umk7w_280", Ly = "_note_umk7w_293", Iy = "_foot_umk7w_296", qy = "_ghost_umk7w_305", Fy = "_primary_umk7w_317", z = {
  root: Kf,
  rootNone: Hf,
  field: Uf,
  codeInput: Gf,
  pickBtn: Yf,
  suggest: Vf,
  suggestList: Jf,
  suggestRow: Qf,
  suggestOn: Zf,
  suggestEmpty: ey,
  suggestMore: ty,
  popup: ny,
  popupHead: ay,
  searchRow: oy,
  list: ry,
  current: sy,
  empty: ly,
  summaryBtn: cy,
  ov: iy,
  modal: uy,
  modalWide: my,
  head: dy,
  sub: _y,
  x: py,
  body: fy,
  chips: yy,
  chip: by,
  chipOn: hy,
  search: gy,
  tbl: Ey,
  row: vy,
  rowCursor: ky,
  rowPicked: wy,
  rowCurrent: Ny,
  curTag: $y,
  busy: xy,
  count: Dy,
  chk: Cy,
  tdLeft: Ay,
  tdCenter: Sy,
  emptyCell: By,
  stop: jy,
  more: My,
  pager: Ty,
  note: Ly,
  foot: Iy,
  ghost: qy,
  primary: Fy
}, br = 250, Vn = 7;
let Ry = 0;
function Eo(e, n) {
  const a = n.trim().toLowerCase();
  if (!a) return e;
  const o = e.toLowerCase().indexOf(a);
  return o < 0 ? e : /* @__PURE__ */ t.createElement(t.Fragment, null, e.slice(0, o), /* @__PURE__ */ t.createElement("b", null, e.slice(o, o + a.length)), e.slice(o + a.length));
}
function Tx({
  value: e = "",
  name: n,
  show: a = "codeName",
  onChange: o,
  items: r,
  source: s,
  multiple: l = !1,
  selected: i,
  onConfirm: c,
  current: m,
  trigger: u,
  emptyLabel: d = "전체",
  open: f,
  onOpenChange: p,
  placeholder: y,
  title: _ = "코드도움",
  variant: b,
  disabled: $,
  className: E = "",
  maxLength: k,
  numeric: D = !1,
  ariaLabel: h,
  autoFocus: w,
  onEnter: v,
  onEscape: C,
  onBlur: x,
  invalid: A
}) {
  const N = s ? "source" : "static", L = h != null ? h : (s == null ? void 0 : s.title) || (typeof _ == "string" && _ !== "코드도움" ? _ : "") || "코드", S = b != null ? b : N === "source" ? "modal" : "anchor", P = u != null ? u : l ? "summary" : "input", [W, q] = B(!1), R = f != null ? f : W, oe = se(
    (I) => {
      f === void 0 && q(I), p && p(I);
    },
    [f, p]
  ), ne = F(null), g = F(null), X = F(null), [Y, V] = B(null), T = () => {
    if (!$) {
      if (S === "anchor") {
        const I = ne.current;
        if (!I) return;
        const G = I.getBoundingClientRect(), J = 320, le = G.bottom + J > window.innerHeight ? Math.max(8, G.top - J - 4) : G.bottom + 4;
        V({ left: Math.min(G.left, window.innerWidth - 320), top: le });
      }
      oe(!0);
    }
  }, U = se(() => oe(!1), [oe]), [ee, ie] = B(!1), [ue, K] = B(null), re = F(null);
  (!re.current || re.current.name !== n) && (re.current = { name: n, code: e });
  const ct = Wf(e, re.current, ue, r), en = La(e, ct, a), xt = La(e, ct), _e = (I) => {
    !l && I[0] && K({ code: I[0].cd, name: I[0].nm }), c ? c(I) : I[0] && o && o(I[0].cd, { code: I[0].cd, name: I[0].nm });
  }, [pe, tn] = B(null), [Re, Pe] = B(-1), [nn, it] = B(null), Dt = F(null), an = F(0), He = F(`axe-cp-${++Ry}`), Hn = F(s);
  Hn.current = s;
  const Un = F(r);
  Un.current = r;
  const j = se(() => {
    Dt.current != null && (window.clearTimeout(Dt.current), Dt.current = null), an.current += 1, tn(null), Pe(-1);
  }, []);
  H(() => j, [j]);
  const O = (I) => {
    Dt.current != null && window.clearTimeout(Dt.current), an.current += 1;
    const G = an.current;
    if (!I.trim()) {
      tn(null), Pe(-1);
      return;
    }
    Dt.current = window.setTimeout(async () => {
      var Qe;
      let J = [], le = !1;
      try {
        const ut = Hn.current;
        if (ut) {
          const on = await ut.fetch({ q: I, ty: null, page: 0 });
          J = on.rows, le = !!on.hasMore || J.length > Vn;
        } else {
          const on = I.trim().toLowerCase();
          J = ((Qe = Un.current) != null ? Qe : []).filter((qt) => {
            var to;
            return qt.code.toLowerCase().includes(on) || qt.name.toLowerCase().includes(on) || ((to = qt.sub) != null ? to : "").toLowerCase().includes(on);
          }).map((qt) => ({ cd: qt.code, nm: qt.name, sub: qt.sub })), le = J.length > Vn;
        }
      } catch {
        return;
      }
      G === an.current && (tn({ rows: J.slice(0, Vn), more: le, q: I }), Pe(-1));
    }, br);
  }, te = (I) => {
    j(), _e([I]);
  };
  return H(() => {
    if (!pe) {
      it(null);
      return;
    }
    const I = () => {
      const G = ne.current;
      if (!G) return;
      const J = G.getBoundingClientRect(), le = Math.min(pe.rows.length, Vn) * 28 + 34, Qe = J.bottom + le > window.innerHeight - 8 && J.top - le - 2 > 8 ? J.top - le - 2 : J.bottom + 2, ut = Math.max(J.width, 260);
      it({ left: Math.max(8, Math.min(J.left, window.innerWidth - ut - 8)), top: Qe, width: ut });
    };
    return I(), window.addEventListener("resize", I), window.addEventListener("scroll", I, !0), () => {
      window.removeEventListener("resize", I), window.removeEventListener("scroll", I, !0);
    };
  }, [pe]), /* @__PURE__ */ t.createElement("span", { ref: ne, className: [P === "none" ? z.rootNone : z.root, E].filter(Boolean).join(" ") }, P === "input" && /* @__PURE__ */ t.createElement("span", { className: z.field }, /* @__PURE__ */ t.createElement(
    "input",
    {
      className: z.codeInput,
      style: { paddingRight: 24 },
      value: ee ? e : en,
      placeholder: y,
      disabled: $,
      maxLength: k,
      inputMode: D ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": L,
      "aria-invalid": A ? !0 : void 0,
      onChange: (I) => {
        const G = I.target.value.trim(), J = D ? G.replace(/[^0-9]/g, "") : G, le = k ? J.slice(0, k) : J;
        o && o(le), !$ && (s || r) && O(le);
      },
      onKeyDown: (I) => {
        if (I.key === "F2") {
          I.preventDefault(), j(), T();
          return;
        }
        if (!pe) {
          I.key === "Enter" && v && !I.nativeEvent.isComposing ? (I.preventDefault(), v()) : I.key === "Escape" && C && (I.preventDefault(), C());
          return;
        }
        const G = pe.rows.length;
        I.key === "ArrowDown" && G ? (I.preventDefault(), Pe((J) => (J + 1) % G)) : I.key === "ArrowUp" && G ? (I.preventDefault(), Pe((J) => (J <= 0 ? G : J) - 1)) : I.key === "Enter" && Re >= 0 && pe.rows[Re] ? (I.preventDefault(), te(pe.rows[Re])) : I.key === "Enter" && v && !I.nativeEvent.isComposing ? (I.preventDefault(), j(), v()) : I.key === "Escape" && (I.preventDefault(), I.stopPropagation(), I.nativeEvent.stopImmediatePropagation(), j());
      },
      onFocus: () => ie(!0),
      onBlur: () => {
        ie(!1), j(), x && x();
      },
      title: typeof A == "string" && A ? A : xt && xt !== e ? `${xt} (F2: 코드도움)` : "F2: 코드도움",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!pe,
      "aria-controls": pe ? He.current : void 0,
      "aria-activedescendant": pe && Re >= 0 ? `${He.current}-${Re}` : void 0,
      "aria-describedby": typeof A == "string" && A ? `${He.current}-inv` : void 0
    }
  ), typeof A == "string" && A && /* @__PURE__ */ t.createElement(yr, { id: `${He.current}-inv` }, A), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: z.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: $,
      onClick: T,
      onMouseDown: (I) => I.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement(oa, { name: "search", size: 13 })
  )), P === "summary" && /* @__PURE__ */ t.createElement("button", { type: "button", className: z.summaryBtn, disabled: $, onClick: T }, /* @__PURE__ */ t.createElement("span", null, zf(i != null ? i : [], d, a)), /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ t.createElement(oa, { name: "search", size: 13 }))), pe && nn && P === "input" && !R && /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: z.suggest,
      style: { left: nn.left, top: nn.top, width: nn.width },
      onMouseDown: (I) => I.preventDefault()
    },
    pe.rows.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: z.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ t.createElement("ul", { id: He.current, role: "listbox", className: z.suggestList }, pe.rows.map((I, G) => /* @__PURE__ */ t.createElement(
      "li",
      {
        key: I.cd,
        id: `${He.current}-${G}`,
        role: "option",
        "aria-selected": G === Re,
        className: [z.suggestRow, G === Re ? z.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Pe(G),
        onClick: () => te(I)
      },
      /* @__PURE__ */ t.createElement("code", null, Eo(I.cd, pe.q)),
      /* @__PURE__ */ t.createElement("span", null, Eo(I.nm, pe.q)),
      I.useYn === !1 && /* @__PURE__ */ t.createElement("em", null, "중단")
    ))),
    pe.more && /* @__PURE__ */ t.createElement("div", { className: z.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), R && N === "static" && S === "anchor" && Y && /* @__PURE__ */ t.createElement(
    Py,
    {
      items: r != null ? r : [],
      value: e,
      title: _,
      popupRef: g,
      anchorRef: ne,
      pos: Y,
      onPick: (I) => {
        K({ code: I.code, name: I.name }), o && o(I.code, I), U();
      },
      onClose: U
    }
  ), R && (N === "source" || S === "modal") && /* @__PURE__ */ t.createElement(
    Oy,
    {
      source: s,
      items: r,
      title: _,
      multiple: l,
      selected: i,
      current: m,
      searchRef: X,
      onConfirm: (I) => {
        _e(I), U();
      },
      onClose: U
    }
  ));
}
function Py({
  items: e,
  value: n,
  title: a,
  popupRef: o,
  anchorRef: r,
  pos: s,
  onPick: l,
  onClose: i
}) {
  const [c, m] = B(""), u = xe(() => {
    const d = c.trim().toLowerCase();
    return d ? e.filter(
      (f) => {
        var p;
        return f.code.toLowerCase().includes(d) || f.name.toLowerCase().includes(d) || ((p = f.sub) != null ? p : "").toLowerCase().includes(d);
      }
    ) : e;
  }, [e, c]);
  return H(() => {
    const d = (p) => {
      const y = p.target;
      o.current && !o.current.contains(y) && r.current && !r.current.contains(y) && i();
    }, f = (p) => {
      p.key === "Escape" && i();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", f), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", f);
    };
  }, [o, r, i]), /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: o,
      className: z.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ t.createElement("header", { className: z.popupHead }, /* @__PURE__ */ t.createElement("strong", null, a), /* @__PURE__ */ t.createElement("button", { type: "button", "aria-label": "닫기", onClick: i }, "✕")),
    /* @__PURE__ */ t.createElement("div", { className: z.searchRow }, /* @__PURE__ */ t.createElement(
      "input",
      {
        autoFocus: !0,
        value: c,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (d) => m(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && u.length && l(u[0]), d.key === "Escape" && i();
        }
      }
    )),
    /* @__PURE__ */ t.createElement("ul", { className: z.list }, u.map((d) => /* @__PURE__ */ t.createElement("li", { key: d.code }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => l(d), className: d.code === n ? z.current : "" }, /* @__PURE__ */ t.createElement("code", null, d.code), /* @__PURE__ */ t.createElement("span", null, d.name), d.sub && /* @__PURE__ */ t.createElement("small", null, d.sub)))), u.length === 0 && /* @__PURE__ */ t.createElement("li", { className: z.empty }, "검색 결과가 없습니다"))
  ));
}
function Xy(e, n) {
  const a = e.map((o) => ({ cd: o.code, nm: o.name, sub: o.sub }));
  return {
    key: "static",
    title: typeof n == "string" ? n : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: o }) => {
      const r = o.trim().toLowerCase();
      return r ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(r) || s.nm.toLowerCase().includes(r) || String((l = s.sub) != null ? l : "").toLowerCase().includes(r);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Oy({
  source: e,
  items: n,
  title: a,
  multiple: o,
  selected: r,
  current: s,
  searchRef: l,
  onConfirm: i,
  onClose: c
}) {
  const m = xe(() => Xy(n != null ? n : [], a), [n, a]), u = e != null ? e : m, [d, f] = B(""), [p, y] = B(null), [_, b] = B(0), [$, E] = B([]), [k, D] = B(!1), [h, w] = B(!1), [v, C] = B(null), [x, A] = B(0), [N, L] = B(/* @__PURE__ */ new Map()), S = F(u);
  S.current = u, H(() => {
    f(""), y(null), b(0), A(0), C(null), L(new Map((r != null ? r : []).map((U) => [U.cd, U])));
    const T = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(T);
  }, [u.key]), H(() => {
    let T = !0;
    w(!0);
    const U = () => {
      S.current.fetch({ q: d.trim(), ty: p, page: _ }).then((ie) => {
        var K, re;
        if (!T) return;
        E((K = ie.rows) != null ? K : []), D(!!ie.hasMore), C(null);
        const ue = s ? ((re = ie.rows) != null ? re : []).findIndex((ct) => ct.cd === s) : -1;
        A(ue > 0 ? ue : 0);
      }).catch((ie) => {
        T && (E([]), D(!1), C(ie instanceof Error ? ie.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        T && w(!1);
      });
    }, ee = window.setTimeout(U, d.trim() ? br : 0);
    return () => {
      T = !1, window.clearTimeout(ee);
    };
  }, [u.key, d, p, _]);
  const P = F(null);
  H(() => {
    const T = P.current && P.current.children[x];
    T && "scrollIntoView" in T && T.scrollIntoView({ block: "nearest" });
  }, [x, $]);
  const W = xe(() => {
    var U, ee;
    const T = [
      { key: "cd", label: "코드", width: (U = u.codeWidth) != null ? U : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (ie) => /* @__PURE__ */ t.createElement(t.Fragment, null, ie.nm, ie.useYn === !1 && /* @__PURE__ */ t.createElement("span", { className: z.stop }, "중단"))
      }
    ];
    return u.typeLabel && T.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (ie) => u.typeLabel ? u.typeLabel(ie) : ""
    }), T.concat((ee = u.extraColumns) != null ? ee : []);
  }, [u]), q = se((T) => {
    L((U) => {
      const ee = new Map(U);
      return ee.has(T.cd) ? ee.delete(T.cd) : ee.set(T.cd, T), ee;
    });
  }, []), R = se((T) => i([T]), [i]), oe = se(() => i(Array.from(N.values())), [N, i]), ne = $.length > 0 && $.every((T) => N.has(T.cd)), g = () => {
    L((T) => {
      const U = new Map(T);
      return ne ? $.forEach((ee) => U.delete(ee.cd)) : $.forEach((ee) => U.set(ee.cd, ee)), U;
    });
  }, X = F(null);
  H(() => {
    const T = document.activeElement;
    return () => {
      window.setTimeout(() => {
        T && T.isConnected && typeof T.focus == "function" && (!document.activeElement || document.activeElement === document.body) && T.focus();
      }, 0);
    };
  }, []);
  const Y = F(c);
  Y.current = c, H(() => {
    const T = (U) => {
      U.key !== "Escape" || U.isComposing || (U.stopPropagation(), U.preventDefault(), Y.current());
    };
    return document.addEventListener("keydown", T, !0), () => document.removeEventListener("keydown", T, !0);
  }, []);
  const V = (T) => {
    if (!(T.nativeEvent.isComposing || T.keyCode === 229)) {
      if (T.key === "Tab" && X.current) {
        const U = Array.from(X.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
        if (U.length) {
          const ee = U[0], ie = U[U.length - 1], ue = document.activeElement;
          T.shiftKey && ue === ee ? (T.preventDefault(), ie.focus()) : !T.shiftKey && ue === ie && (T.preventDefault(), ee.focus());
        }
        return;
      }
      if (T.key === "Escape") {
        T.stopPropagation(), c();
        return;
      }
      if (T.key === "ArrowDown" || T.key === "ArrowUp") {
        T.preventDefault(), A((U) => Math.max(0, Math.min($.length - 1, U + (T.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (T.key === " " && o && $[x]) {
        T.preventDefault(), q($[x]);
        return;
      }
      if (T.key === "Enter") {
        if (T.preventDefault(), h) return;
        o ? oe() : $[x] && R($[x]);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement("div", { className: z.ov, onClick: c }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: u.wide ? `${z.modal} ${z.modalWide}` : z.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: X,
      onClick: (T) => T.stopPropagation(),
      onKeyDown: V
    },
    /* @__PURE__ */ t.createElement("div", { className: z.head }, /* @__PURE__ */ t.createElement("h2", null, u.title), o && /* @__PURE__ */ t.createElement("span", { className: z.sub }, "복수 선택 가능"), /* @__PURE__ */ t.createElement("button", { type: "button", className: z.x, onClick: c, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ t.createElement("div", { className: z.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ t.createElement("div", { className: z.chips }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${z.chip} ${z.chipOn}` : z.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), u.filters.map((T) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: T.value,
        type: "button",
        className: p === T.value ? `${z.chip} ${z.chipOn}` : z.chip,
        onClick: () => {
          y(T.value), b(0);
        }
      },
      T.label
    ))), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: l,
        className: z.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (T) => {
          f(T.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ t.createElement("div", { className: z.tbl }, /* @__PURE__ */ t.createElement("table", null, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, o && /* @__PURE__ */ t.createElement("th", { className: z.chk }, /* @__PURE__ */ t.createElement(
      "input",
      {
        type: "checkbox",
        checked: ne,
        onChange: g,
        "aria-label": "표시된 행 전체 선택"
      }
    )), W.map((T) => /* @__PURE__ */ t.createElement("th", { key: T.key, style: T.width ? { width: T.width } : void 0 }, T.label)))), /* @__PURE__ */ t.createElement("tbody", { ref: P, className: h && $.length > 0 ? z.busy : void 0, "aria-busy": h }, $.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: z.emptyCell, colSpan: W.length + (o ? 1 : 0) }, h ? "조회 중…" : v || u.emptyText || "검색 결과가 없습니다")) : $.map((T, U) => /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: T.cd,
        className: [
          z.row,
          U === x ? z.rowCursor : "",
          N.has(T.cd) ? z.rowPicked : "",
          !o && s && T.cd === s ? z.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": U === x,
        onClick: () => {
          A(U), o ? q(T) : R(T);
        }
      },
      o && /* @__PURE__ */ t.createElement("td", { className: z.chk }, /* @__PURE__ */ t.createElement(
        "input",
        {
          type: "checkbox",
          checked: N.has(T.cd),
          onChange: () => q(T),
          onClick: (ee) => ee.stopPropagation(),
          "aria-label": `${T.cd} 선택`
        }
      )),
      W.map((ee) => {
        var ie, ue;
        return /* @__PURE__ */ t.createElement(
          "td",
          {
            key: ee.key,
            className: ee.align === "left" ? z.tdLeft : z.tdCenter,
            title: ee.render ? void 0 : String((ie = T[ee.key]) != null ? ie : "")
          },
          ee.render ? ee.render(T) : String((ue = T[ee.key]) != null ? ue : ""),
          ee.key === "cd" && !o && s && T.cd === s && /* @__PURE__ */ t.createElement("em", { className: z.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ t.createElement("p", { className: z.count, role: "status", "aria-live": "polite" }, h ? "조회 중…" : v ? "" : `${$.length}건`, !o && !h && !v && $.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (k || _ > 0) && /* @__PURE__ */ t.createElement("div", { className: z.more }, /* @__PURE__ */ t.createElement("span", null, k ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ t.createElement("span", { className: z.pager }, /* @__PURE__ */ t.createElement("button", { type: "button", disabled: _ === 0, onClick: () => b((T) => Math.max(0, T - 1)) }, "이전"), /* @__PURE__ */ t.createElement("b", null, _ + 1), k && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => b((T) => T + 1) }, "다음"))), o && /* @__PURE__ */ t.createElement("p", { className: z.note }, "선택 ", /* @__PURE__ */ t.createElement("b", null, N.size), "건 — 선택이 없으면 ", /* @__PURE__ */ t.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ t.createElement("div", { className: z.foot }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: z.ghost, onClick: () => L(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ t.createElement("button", { type: "button", className: z.ghost, onClick: c }, "취소"), o && /* @__PURE__ */ t.createElement("button", { type: "button", className: z.primary, onClick: oe }, "확인"))
  )));
}
const vo = "1900-01-01", ko = "2099-12-31", ga = ["일", "월", "화", "수", "목", "금", "토"], ra = (e) => String(e).padStart(2, "0");
function ze(e, n) {
  return new Date(Date.UTC(e, n, 0)).getUTCDate();
}
function Ve(e, n, a) {
  return `${String(e).padStart(4, "0")}-${ra(n)}-${ra(a)}`;
}
function de(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2], r = +n[3];
  return o < 1 || o > 12 || r < 1 || r > ze(a, o) ? null : { y: a, m: o, d: r };
}
function zy(e) {
  const n = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2];
  return o < 1 || o > 12 ? null : { y: a, m: o, d: 1 };
}
function Bn(e, n) {
  return n === "month" ? zy(e) : de(e);
}
function je(e, n) {
  return n === "month" ? `${String(e.y).padStart(4, "0")}-${ra(e.m)}` : Ve(e.y, e.m, e.d);
}
function Me(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function gn(e, n) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + n));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function It(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = (a % 12 + 12) % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, ze(o, r)) };
}
function Wy(e, n, a) {
  return e >= n && e <= a;
}
function dn(e, n) {
  return e.replace(/\D/g, "").slice(0, n === "month" ? 6 : 8);
}
function Ea(e, n) {
  const a = e.slice(0, 4), o = e.slice(4, 6), r = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + o), n === "date" && e.length > 6 && (s += "-" + r), s;
}
function wo(e, n) {
  if (n <= 0) return 0;
  let a = 0;
  for (let o = 0; o < e.length; o++)
    if (/\d/.test(e[o]) && (a++, a === n))
      return o + 1;
  return e.length;
}
function ta(e, n, a) {
  let o, r, s = 1;
  if (n === "month")
    if (e.length === 6)
      o = +e.slice(0, 4), r = +e.slice(4, 6);
    else if (e.length === 4)
      o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    o = +e.slice(0, 4), r = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    o = a.y, r = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return r < 1 || r > 12 || s < 1 || s > ze(o, r) ? null : { y: o, m: r, d: s };
}
function Ky(e, n, a) {
  const o = e.trim(), r = n === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(o) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(o);
  if (r) {
    const s = { y: +r[1], m: +r[2], d: n === "month" ? 1 : +r[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= ze(s.y, s.m) ? s : null;
  }
  return ta(o.replace(/\D/g, ""), n, a);
}
function Hy(e, n) {
  const a = { y: e, m: n, d: 1 }, o = gn(a, -Me(a));
  return Array.from({ length: 42 }, (r, s) => gn(o, s));
}
function Uy(e, n) {
  const a = e.y, o = [], r = (m, u) => `${String(m).padStart(4, "0")}-${ra(u)}`, s = (m, u, d) => Ve(m, u, d);
  if (n === "month") {
    o.push({ label: "이번 달", from: r(a, e.m), to: r(a, e.m) });
    const m = It(e, -1);
    o.push({ label: "지난달", from: r(m.y, m.m), to: r(m.y, m.m) }), o.push({ label: "올해", from: r(a, 1), to: r(a, 12) }), o.push({ label: "올해 누계", from: r(a, 1), to: r(a, e.m) }), o.push({ label: "전년도", from: r(a - 1, 1), to: r(a - 1, 12) });
    for (let u = 1; u <= 4; u++) o.push({ label: `${u}분기`, from: r(a, u * 3 - 2), to: r(a, u * 3) });
    return o.push({ label: "상반기", from: r(a, 1), to: r(a, 6) }), o.push({ label: "하반기", from: r(a, 7), to: r(a, 12) }), o;
  }
  const l = Ve(e.y, e.m, e.d);
  o.push({ label: "오늘", from: l, to: l });
  const i = gn(e, -Me(e));
  o.push({ label: "이번 주", from: je(i, "date"), to: je(gn(i, 6), "date") }), o.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, ze(a, e.m)) });
  const c = It({ ...e, d: 1 }, -1);
  o.push({ label: "지난달", from: s(c.y, c.m, 1), to: s(c.y, c.m, ze(c.y, c.m)) }), o.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), o.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), o.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let m = 1; m <= 4; m++)
    o.push({ label: `${m}분기`, from: s(a, m * 3 - 2, 1), to: s(a, m * 3, ze(a, m * 3)) });
  return o;
}
const Gy = "_wrap_uxy72_1", Yy = "_disabled_uxy72_18", Vy = "_input_uxy72_22", Jy = "_month_uxy72_36", Qy = "_weekday_uxy72_39", Zy = "_sun_uxy72_40", e1 = "_sat_uxy72_41", t1 = "_icon_uxy72_43", n1 = "_readOnly_uxy72_57", a1 = "_required_uxy72_62", o1 = "_invalid_uxy72_63", r1 = "_pop_uxy72_66", s1 = "_calHead_uxy72_79", l1 = "_calTitleStatic_uxy72_80", c1 = "_calTitle_uxy72_80", i1 = "_grid_uxy72_90", u1 = "_wd_uxy72_91", m1 = "_day_uxy72_95", d1 = "_mon_uxy72_36", _1 = "_out_uxy72_104", p1 = "_sel_uxy72_105", f1 = "_today_uxy72_108", y1 = "_months_uxy72_111", b1 = "_foot_uxy72_114", h1 = "_clear_uxy72_127", g1 = "_range_uxy72_130", E1 = "_tilde_uxy72_131", v1 = "_rangeErr_uxy72_132", ae = {
  wrap: Gy,
  disabled: Yy,
  input: Vy,
  month: Jy,
  weekday: Qy,
  sun: Zy,
  sat: e1,
  icon: t1,
  readOnly: n1,
  required: a1,
  invalid: o1,
  pop: r1,
  calHead: s1,
  calTitleStatic: l1,
  calTitle: c1,
  grid: i1,
  wd: u1,
  day: m1,
  mon: d1,
  out: _1,
  sel: p1,
  today: f1,
  months: y1,
  foot: b1,
  clear: h1,
  range: g1,
  tilde: E1,
  rangeErr: v1
}, Bt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function No({
  value: e,
  onChange: n,
  mode: a = "date",
  min: o,
  max: r,
  disabled: s,
  readOnly: l,
  required: i,
  invalid: c,
  showWeekday: m,
  onReject: u,
  placeholder: d,
  id: f,
  name: p,
  onBlur: y,
  "aria-label": _,
  "aria-describedby": b,
  className: $ = "",
  style: E
}) {
  const k = a === "month", D = o || (k ? vo.slice(0, 7) : vo), h = r || (k ? ko.slice(0, 7) : ko), w = (j) => Wy(j, D, h), v = !!s || !!l, [C, x] = B(e || ""), [A, N] = B(!1), [L, S] = B(!1), [P, W] = B(k ? "month" : "day"), [q, R] = B(() => {
    var O;
    const j = (O = Bn(e, a)) != null ? O : Bt();
    return { y: j.y, m: j.m };
  }), [oe, ne] = B({ top: 0, left: 0 }), g = F(null), X = F(null), Y = F(null), V = F(null);
  H(() => {
    x(e || ""), N(!1);
  }, [e]), H(() => {
    const j = Bn(e, a);
    j && R({ y: j.y, m: j.m });
  }, [e, a]), Ke(() => {
    const j = X.current;
    V.current != null && j && document.activeElement === j && j.setSelectionRange(V.current, V.current), V.current = null;
  }, [C]), Ke(() => {
    if (!L) return;
    const j = () => {
      const O = g.current, te = Y.current;
      if (!O || !te) return;
      const I = O.getBoundingClientRect(), G = te.offsetHeight, J = te.offsetWidth;
      let le = I.bottom + 4;
      le + G > window.innerHeight - 8 && I.top - G - 4 > 8 && (le = I.top - G - 4);
      const Qe = Math.max(8, Math.min(I.left, window.innerWidth - J - 8));
      ne((ut) => ut.top === le && ut.left === Qe ? ut : { top: le, left: Qe });
    };
    return j(), window.addEventListener("resize", j), window.addEventListener("scroll", j, !0), () => {
      window.removeEventListener("resize", j), window.removeEventListener("scroll", j, !0);
    };
  }, [L, P, q.y, q.m]), H(() => {
    if (!L) return;
    const j = (O) => {
      var I, G;
      const te = O.target;
      (I = g.current) != null && I.contains(te) || (G = Y.current) != null && G.contains(te) || S(!1);
    };
    return document.addEventListener("mousedown", j), () => document.removeEventListener("mousedown", j);
  }, [L]);
  const T = (j) => {
    j !== (e || "") && n(j);
  }, U = (j) => {
    x(j), N(!1), T(j);
  }, ee = () => {
    const j = dn(C, a);
    if (!j) return;
    const O = ta(j, a, Bt()), te = O ? je(O, a) : null;
    if (te && w(te)) {
      U(te);
      return;
    }
    u == null || u(C, te ? "range" : "format"), x(e || ""), N(!1);
  }, ie = (j, O) => {
    const te = dn(j.slice(0, O), a).length, I = dn(j, a), G = Ea(I, a);
    if (V.current = wo(G, Math.min(te, I.length)), x(G), !I) {
      N(!1), T("");
      return;
    }
    if (I.length === (k ? 6 : 8)) {
      const J = ta(I, a, Bt()), le = J ? je(J, a) : null;
      le && w(le) ? (N(!1), T(le)) : N(!0);
    } else N(!1);
  }, ue = (j, O) => {
    var Qe;
    const te = Bt(), I = dn(C, a), G = (Qe = ta(I, a, te)) != null ? Qe : Bn(e, a);
    let J;
    G ? k ? J = It(G, j === "year" ? 12 * O : O) : j === "day" ? J = gn(G, O) : J = It(G, j === "month" ? O : 12 * O) : J = te;
    const le = je(J, a);
    w(le) && U(le);
  }, K = (j) => {
    var O;
    U(j), S(!1), (O = X.current) == null || O.focus();
  }, re = () => {
    var O;
    if (v) return;
    const j = (O = Bn(e, a)) != null ? O : Bt();
    R({ y: j.y, m: j.m }), W(k ? "month" : "day"), S(!0);
  }, ct = (j) => {
    var te, I;
    if (v) return;
    const O = j.currentTarget;
    switch (j.key) {
      case "Escape":
        L ? (S(!1), j.preventDefault(), j.stopPropagation(), j.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (x(e || ""), N(!1), j.preventDefault(), j.stopPropagation(), j.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => O.select()));
        break;
      case "ArrowDown":
        j.preventDefault(), j.altKey ? L ? S(!1) : re() : ue("day", 1);
        break;
      case "ArrowUp":
        j.preventDefault(), ue("day", -1);
        break;
      case "PageDown":
        j.preventDefault(), ue("month", 1);
        break;
      case "PageUp":
        j.preventDefault(), ue("month", -1);
        break;
      case "F2":
      case "F4":
        j.preventDefault(), L ? S(!1) : re();
        break;
      case "Enter":
        ee(), L && S(!1);
        break;
      case "t":
      case "T":
        if (j.ctrlKey || j.metaKey || j.altKey) break;
        j.preventDefault(), U(je(Bt(), a));
        break;
      case "Backspace": {
        const G = (te = O.selectionStart) != null ? te : 0;
        if (G === ((I = O.selectionEnd) != null ? I : 0) && G > 0 && C[G - 1] === "-") {
          j.preventDefault();
          const J = dn(C.slice(0, G), a).length, le = dn(C, a);
          ie(Ea(le.slice(0, J - 1) + le.slice(J), a), 0), V.current = wo(Ea(le.slice(0, J - 1) + le.slice(J), a), J - 1);
        }
        break;
      }
    }
  }, en = (j) => {
    if (v) return;
    j.preventDefault();
    const O = Ky(j.clipboardData.getData("text"), a, Bt()), te = O ? je(O, a) : null;
    te && w(te) ? U(te) : N(!0);
  }, xt = (j) => {
    var te, I;
    const O = j.relatedTarget;
    O && ((te = g.current) != null && te.contains(O) || (I = Y.current) != null && I.contains(O)) || (ee(), S(!1), y && y());
  }, _e = Bn(e, a), pe = Bt(), tn = A || !!c, Re = m && !k && _e ? Me(_e) : null, Pe = (j) => je(j, a), nn = (j, O) => {
    const te = je({ y: j, m: O, d: 1 }, "date"), I = je({ y: j, m: O, d: ze(j, O) }, "date"), G = k ? D + "-01" : D, J = k ? h + "-31" : h;
    return I >= G && te <= J;
  }, it = (j) => {
    const O = It({ y: q.y, m: q.m, d: 1 }, j);
    R({ y: O.y, m: O.m });
  }, Dt = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: ae.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => it(-12) }, "«"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => it(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => W("month") }, q.y, "년 ", q.m, "월"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => it(1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => it(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: ae.grid }, ga.map((j, O) => /* @__PURE__ */ t.createElement("span", { key: j, className: [ae.wd, O === 0 ? ae.sun : "", O === 6 ? ae.sat : ""].join(" ") }, j)), Hy(q.y, q.m).map((j) => {
    const O = je(j, "date"), te = Me(j), I = [
      ae.day,
      j.m !== q.m ? ae.out : "",
      te === 0 ? ae.sun : "",
      te === 6 ? ae.sat : "",
      O === je(pe, "date") ? ae.today : "",
      _e && O === je(_e, "date") ? ae.sel : ""
    ].join(" "), G = !w(O);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: O,
        type: "button",
        tabIndex: -1,
        className: I,
        disabled: G,
        "aria-label": `${j.y}년 ${j.m}월 ${j.d}일 ${ga[te]}요일`,
        "aria-pressed": !!_e && O === je(_e, "date"),
        onClick: () => K(O)
      },
      j.d
    );
  }))), an = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: ae.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => it(-12) }, "«"), /* @__PURE__ */ t.createElement("span", { className: ae.calTitleStatic }, q.y, "년"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => it(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (j, O) => O + 1).map((j) => {
    const O = !!_e && _e.y === q.y && _e.m === j, te = [ae.mon, O ? ae.sel : "", pe.y === q.y && pe.m === j ? ae.today : ""].join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: j,
        type: "button",
        tabIndex: -1,
        className: te,
        disabled: !nn(q.y, j),
        "aria-pressed": O,
        onClick: () => {
          k ? K(Pe({ y: q.y, m: j, d: 1 })) : (R({ y: q.y, m: j }), W("day"));
        }
      },
      j,
      "월"
    );
  }))), He = je(pe, a), Hn = k ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !w(He), onClick: () => K(He) }, "이번 달")) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !w(He), onClick: () => K(He) }, "오늘"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !w(Pe({ y: q.y, m: q.m, d: 1 })),
      onClick: () => K(Pe({ y: q.y, m: q.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !w(Pe({ y: q.y, m: q.m, d: ze(q.y, q.m) })),
      onClick: () => K(Pe({ y: q.y, m: q.m, d: ze(q.y, q.m) }))
    },
    "월말"
  )), Un = [
    ae.wrap,
    s ? ae.disabled : "",
    l ? ae.readOnly : "",
    i && !e && !C ? ae.required : "",
    tn ? ae.invalid : "",
    k ? ae.month : "",
    $
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { ref: g, className: Un, style: E, onBlur: xt }, /* @__PURE__ */ t.createElement(
    "input",
    {
      ref: X,
      id: f,
      name: p,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: d != null ? d : k ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": L,
      "aria-label": _,
      "aria-describedby": b,
      "aria-invalid": tn || void 0,
      "aria-required": i || void 0,
      onChange: (j) => {
        var O;
        return ie(j.target.value, (O = j.target.selectionStart) != null ? O : j.target.value.length);
      },
      onKeyDown: ct,
      onPaste: en
    }
  ), Re != null && /* @__PURE__ */ t.createElement("span", { className: [ae.weekday, Re === 0 ? ae.sun : "", Re === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", ga[Re], ")"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: v,
      "aria-label": k ? "월 선택 열기" : "달력 열기",
      onMouseDown: (j) => j.preventDefault(),
      onClick: () => {
        var j;
        (j = X.current) == null || j.focus(), L ? S(!1) : re();
      }
    },
    /* @__PURE__ */ t.createElement(oa, { name: "calendar", size: 15 })
  ), L && /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: Y,
      className: ae.pop,
      style: { top: oe.top, left: oe.left },
      role: "dialog",
      "aria-label": k ? "월 선택" : "날짜 선택",
      onMouseDown: (j) => j.preventDefault()
    },
    P === "day" && !k ? Dt() : an(),
    /* @__PURE__ */ t.createElement("div", { className: ae.foot }, Hn, !i && /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => K("") }, "지우기"))
  )));
}
const Ut = (e) => String(e).padStart(2, "0");
function hr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Ut(e.getMonth() + 1)}-${Ut(e.getDate())}`;
}
function Lx(e) {
  if (!e) return "";
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? String(e) : `${n.getFullYear()}-${Ut(n.getMonth() + 1)}-${Ut(n.getDate())} ${Ut(n.getHours())}:${Ut(n.getMinutes())}:${Ut(n.getSeconds())}`;
}
function Ix(e, n) {
  return !!e && !!n && e <= n;
}
function qx({
  from: e,
  to: n,
  onChange: a,
  mode: o = "date",
  min: r,
  max: s,
  disabled: l,
  label: i = "기간",
  presets: c = !0,
  showWeekday: m,
  onReject: u
}) {
  const d = !!e && !!n && e > n, f = /* @__PURE__ */ new Date(), p = c === !1 ? [] : Array.isArray(c) ? c : Uy({ y: f.getFullYear(), m: f.getMonth() + 1, d: f.getDate() }, o), y = (_) => (!r || _.from >= r) && (!s || _.to <= s);
  return /* @__PURE__ */ t.createElement("span", { className: ae.range }, /* @__PURE__ */ t.createElement(
    No,
    {
      value: e,
      mode: o,
      min: r,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${i} 시작`,
      onChange: (_) => a(_, n),
      onReject: u && ((_, b) => u(_, b, "from"))
    }
  ), /* @__PURE__ */ t.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ t.createElement(
    No,
    {
      value: n,
      mode: o,
      min: r,
      max: s,
      disabled: l,
      showWeekday: m,
      "aria-label": `${i} 끝`,
      onChange: (_) => a(e, _),
      onReject: u && ((_, b) => u(_, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ t.createElement(
    i_,
    {
      label: "기간",
      title: `${i} 빠른 선택`,
      disabled: l,
      entries: p.map((_) => c_(
        _.label,
        _.label,
        () => a(_.from, _.to),
        y(_) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), d && /* @__PURE__ */ t.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작이 끝보다 늦습니다"));
}
const gr = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function Er(e, n = gr) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let o = null;
  for (const r of n) r.start <= e.slice(0, 10) && (!o || r.start > o.start) && (o = r);
  return o ? { era: o, year: +a[1] - +o.start.slice(0, 4) + 1 } : null;
}
function k1(e, n = {}) {
  const a = Er(e, n.eras);
  return a ? `${a.era.name}${a.year === 1 && n.gannen !== !1 ? "元" : a.year}年` : null;
}
function Fx(e, n) {
  const a = Er(e, n);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Ae = 1440, sa = (e) => String(e).padStart(2, "0");
function be(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return n ? Date.UTC(+n[1], +n[2] - 1, +n[3], n[4] ? +n[4] : 0, n[5] ? +n[5] : 0) / 6e4 : NaN;
}
function Yt(e) {
  const n = new Date(e * 6e4);
  return Ve(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate());
}
function qn(e) {
  const n = new Date(e * 6e4);
  return `${Yt(e)}T${sa(n.getUTCHours())}:${sa(n.getUTCMinutes())}`;
}
function st(e) {
  const n = (e % Ae + Ae) % Ae;
  return `${sa(Math.floor(n / 60))}:${sa(n % 60)}`;
}
function we(e, n) {
  const a = de(e);
  if (!a) return e;
  const o = gn(a, n);
  return Ve(o.y, o.m, o.d);
}
function En(e, n) {
  return Math.round((be(n) - be(e)) / Ae);
}
function Xn(e) {
  const n = de(e);
  if (!n) return !1;
  const a = Me(n);
  return a === 0 || a === 6;
}
function w1(e) {
  var r;
  const n = be(e.start);
  if (Number.isNaN(n)) return null;
  const a = (r = e.allDay) != null ? r : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = Yt(n), l = e.end ? Yt(be(e.end)) : s, i = l < s ? s : l;
    return { ev: e, s: be(s), e: be(i) + Ae, allDay: a, sDay: s, eDay: i };
  }
  let o = e.end ? be(e.end) : n + 60;
  return (Number.isNaN(o) || o <= n) && (o = n + 30), { ev: e, s: n, e: o, allDay: a, sDay: Yt(n), eDay: Yt(o - 1) };
}
function da(e, n, a, o) {
  const r = [];
  for (const s of e) {
    const l = o && s.id === o.id ? { ...s, start: o.start, end: o.end } : s, i = w1(l);
    i && i.eDay >= n && i.sDay <= a && r.push(i);
  }
  return r.sort(N1);
}
function N1(e, n) {
  if (e.sDay !== n.sDay) return e.sDay < n.sDay ? -1 : 1;
  const a = En(n.sDay, n.eDay) - En(e.sDay, e.eDay);
  return a || (e.allDay !== n.allDay ? e.allDay ? -1 : 1 : e.s !== n.s ? e.s - n.s : e.ev.title.localeCompare(n.ev.title));
}
function $1(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function vr(e) {
  return e.allDay || e.e - e.s >= Ae;
}
function la(e, n) {
  const a = de(e);
  if (!a) return e;
  const o = (Me(a) - n + 7) % 7;
  return we(e, -o);
}
function _a(e, n) {
  const a = En(e, n);
  return Array.from({ length: Math.max(0, a + 1) }, (o, r) => we(e, r));
}
function kr(e, n) {
  const a = de(e), o = Ve(a.y, a.m, 1), r = Ve(a.y, a.m, ze(a.y, a.m)), s = la(o, n), l = we(la(r, n), 6), i = _a(s, l), c = [];
  for (let m = 0; m < i.length; m += 7) c.push(i.slice(m, m + 7));
  return c;
}
function Ua(e, n, a) {
  if (e === "month") {
    const o = kr(n, a);
    return { from: o[0][0], to: o[o.length - 1][6] };
  }
  if (e === "agenda") {
    const o = de(n);
    return { from: Ve(o.y, o.m, 1), to: Ve(o.y, o.m, ze(o.y, o.m)) };
  }
  if (e === "week") {
    const o = la(n, a);
    return { from: o, to: we(o, 6) };
  }
  return { from: n, to: n };
}
function x1(e, n, a, o = !1) {
  const r = de(n);
  if (!r) return n;
  if (e === "month" || e === "agenda") {
    const l = It(r, a);
    return Ve(l.y, l.m, l.d);
  }
  if (e === "week") return we(n, 7 * a);
  let s = we(n, a);
  for (; o && Xn(s); ) s = we(s, a);
  return s;
}
function D1(e, n, a, o) {
  if (!de(n)) return "";
  if (e === "month" || e === "agenda") return o.ym(`${n.slice(0, 7)}-01`);
  if (e === "day") return o.dayTitle(n);
  const { from: r, to: s } = Ua("week", n, a);
  return o.year(r) !== o.year(s) ? `${o.ymd(r)} – ${o.ymd(s)}` : r.slice(5, 7) !== s.slice(5, 7) ? `${o.ymd(r)} – ${o.md(s)}` : `${o.ymd(r)} – ${o.d(s)}`;
}
function wr(e, n) {
  const a = [], o = [];
  for (const r of e) {
    let s = -1, l = -1;
    for (let c = 0; c < n.length; c++)
      n[c] >= r.sDay && n[c] <= r.eDay && (s < 0 && (s = c), l = c);
    if (s < 0) continue;
    let i = o.findIndex((c) => c < s);
    i < 0 ? (i = o.length, o.push(l)) : o[i] = l, a.push({ item: r, col: s, span: l - s + 1, lane: i, contL: r.sDay < n[s], contR: r.eDay > n[l] });
  }
  return a;
}
function C1(e, n, a) {
  const o = new Array(n).fill(0);
  for (const i of e) for (let c = i.col; c < i.col + i.span; c++) o[c]++;
  const r = Math.max(1, a), s = e.filter((i) => {
    if (i.lane < r - 1) return !0;
    if (i.lane > r - 1) return !1;
    for (let c = i.col; c < i.col + i.span; c++) if (o[c] > r) return !1;
    return !0;
  }), l = new Array(n).fill(0);
  for (const i of s) for (let c = i.col; c < i.col + i.span; c++) l[c]++;
  return { shown: s, more: o.map((i, c) => i - l[c]) };
}
const A1 = 20;
function S1(e, n) {
  const a = be(n), o = a + Ae, r = e.filter((m) => !vr(m) && m.s < o && m.e > a).map((m) => ({
    item: m,
    top: Math.max(m.s, a) - a,
    bottom: Math.min(m.e, o) - a,
    col: 0,
    cols: 1,
    contTop: m.s < a,
    contBottom: m.e > o
  })).sort((m, u) => m.top - u.top || u.bottom - m.bottom);
  let s = [], l = [], i = -1;
  const c = () => {
    for (const m of s) m.cols = l.length;
    s = [], l = [];
  };
  for (const m of r) {
    m.top >= i && c();
    const u = Math.max(m.bottom, m.top + A1);
    let d = l.findIndex((f) => f <= m.top);
    d < 0 ? (d = l.length, l.push(u)) : l[d] = u, m.col = d, s.push(m), i = Math.max(i, u);
  }
  return c(), r;
}
function $o(e, n) {
  return Math.round(e / n) * n;
}
function Ia(e, n) {
  if (e.allDay) {
    const a = Math.round(n / Ae);
    return { start: we(e.sDay, a), end: we(e.eDay, a) };
  }
  return { start: qn(e.s + n), end: qn(e.e + n) };
}
function Ga(e, n = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return n;
    const l = de(e.sDay), i = de(e.eDay);
    return `${l.m}/${l.d} – ${i.m}/${i.d}`;
  }
  const a = be(e.sDay), o = st(e.s - a);
  if (e.sDay === e.eDay) return `${o} – ${e.e - a === Ae ? "24:00" : st(e.e - a)}`;
  const r = de(e.sDay), s = de(Yt(e.e));
  return `${r.m}/${r.d} ${o} – ${s.m}/${s.d} ${st(e.e - be(Yt(e.e)))}`;
}
const De = (e) => {
  const n = de(e);
  return { ...n, w: Me(n) };
};
function xo(e, n, a, o, r) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (n === "gregorian") return s;
  const l = k1(e, { eras: o, gannen: r });
  return l ? n === "era" ? l : `${s}(${l})` : s;
}
function B1(e = "ko", n = {}) {
  var c, m;
  const a = (c = n.year) != null ? c : e === "ja" ? "era" : "gregorian", o = (m = n.eras) != null ? m : gr, r = n.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], d = (p) => xo(p, a, "年", o, r), f = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${f[p]} (P)`,
      next: (p) => `次の${f[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: d,
      ym: (p) => `${d(p)}${De(p).m}月`,
      ymd: (p) => {
        const y = De(p);
        return `${d(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${De(p).d}日`,
      m: (p) => `${De(p).m}月`,
      dayTitle: (p) => {
        const y = De(p);
        return `${d(p)}${y.m}月${y.d}日(${u[y.w]})`;
      },
      dayAria: (p) => {
        const y = De(p);
        return `${y.m}月${y.d}日 ${u[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (u) => xo(u, a, "년", o, r), i = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${i[u]} (P)`,
    next: (u) => `다음 ${i[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, d) => `${u}/${d}일째`,
    openDay: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일 일 보기`;
    },
    year: l,
    ym: (u) => `${l(u)} ${De(u).m}월`,
    ymd: (u) => {
      const d = De(u);
      return `${l(u)} ${d.m}월 ${d.d}일`;
    },
    md: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일`;
    },
    d: (u) => `${De(u).d}일`,
    m: (u) => `${De(u).m}월`,
    dayTitle: (u) => {
      const d = De(u);
      return `${l(u)} ${d.m}월 ${d.d}일 (${s[d.w]})`;
    },
    dayAria: (u) => {
      const d = De(u);
      return `${d.m}월 ${d.d}일 ${s[d.w]}요일`;
    }
  };
}
const Nr = B1("ko"), j1 = "_cal_ooj0g_2", M1 = "_toolbar_ooj0g_20", T1 = "_navBtns_ooj0g_28", L1 = "_title_ooj0g_29", I1 = "_toolRight_ooj0g_36", q1 = "_toggle_ooj0g_37", F1 = "_body_ooj0g_58", R1 = "_busy_ooj0g_59", P1 = "_sun_ooj0g_71", X1 = "_sat_ooj0g_72", O1 = "_tAccent_ooj0g_75", z1 = "_tOk_ooj0g_76", W1 = "_tWarn_ooj0g_77", K1 = "_tDanger_ooj0g_78", H1 = "_tViolet_ooj0g_79", U1 = "_tGray_ooj0g_80", G1 = "_month_ooj0g_83", Y1 = "_mHead_ooj0g_84", V1 = "_wdName_ooj0g_85", J1 = "_mBody_ooj0g_91", Q1 = "_mWeek_ooj0g_92", Z1 = "_mCells_ooj0g_94", eb = "_cell_ooj0g_96", tb = "_out_ooj0g_104", nb = "_dayNum_ooj0g_105", ab = "_creatable_ooj0g_106", ob = "_selDay_ooj0g_109", rb = "_cellHead_ooj0g_111", sb = "_isToday_ooj0g_124", lb = "_holiday_ooj0g_125", cb = "_addHint_ooj0g_130", ib = "_barLayer_ooj0g_138", ub = "_chip_ooj0g_139", mb = "_more_ooj0g_139", db = "_tEv_ooj0g_155", _b = "_aRow_ooj0g_155", pb = "_popItem_ooj0g_155", fb = "_bar_ooj0g_138", yb = "_contL_ooj0g_165", bb = "_contR_ooj0g_166", hb = "_dotChip_ooj0g_167", gb = "_dot_ooj0g_167", Eb = "_chipTime_ooj0g_170", vb = "_chipTitle_ooj0g_171", kb = "_movable_ooj0g_173", wb = "_ghost_ooj0g_176", Nb = "_time_ooj0g_189", $b = "_tHead_ooj0g_190", xb = "_tAllDay_ooj0g_190", Db = "_gutter_ooj0g_193", Cb = "_tHeadDays_ooj0g_197", Ab = "_tAllDayCells_ooj0g_197", Sb = "_tDay_ooj0g_198", Bb = "_tDayBtn_ooj0g_202", jb = "_tWd_ooj0g_206", Mb = "_tDayNum_ooj0g_208", Tb = "_tAllDayRow_ooj0g_216", Lb = "_allDayCell_ooj0g_218", Ib = "_tBody_ooj0g_222", qb = "_tGrid_ooj0g_223", Fb = "_tGutter_ooj0g_224", Rb = "_tCols_ooj0g_230", Pb = "_tCol_ooj0g_230", Xb = "_tSel_ooj0g_238", Ob = "_tEvTitle_ooj0g_258", zb = "_tEvTime_ooj0g_259", Wb = "_tEvShort_ooj0g_261", Kb = "_contTop_ooj0g_263", Hb = "_contBottom_ooj0g_264", Ub = "_resize_ooj0g_265", Gb = "_now_ooj0g_268", Yb = "_agenda_ooj0g_272", Vb = "_aDay_ooj0g_273", Jb = "_aDate_ooj0g_275", Qb = "_aDateBtn_ooj0g_276", Zb = "_aDayNum_ooj0g_280", eh = "_aDayWd_ooj0g_286", th = "_aList_ooj0g_288", nh = "_aTime_ooj0g_295", ah = "_aTitle_ooj0g_296", oh = "_aSpan_ooj0g_297", rh = "_aLoc_ooj0g_298", sh = "_empty_ooj0g_303", lh = "_pop_ooj0g_155", ch = "_popHead_ooj0g_321", ih = "_popDay_ooj0g_322", uh = "_popClose_ooj0g_329", mh = "_popList_ooj0g_334", M = {
  cal: j1,
  toolbar: M1,
  navBtns: T1,
  title: L1,
  toolRight: I1,
  toggle: q1,
  body: F1,
  busy: R1,
  sun: P1,
  sat: X1,
  tAccent: O1,
  tOk: z1,
  tWarn: W1,
  tDanger: K1,
  tViolet: H1,
  tGray: U1,
  month: G1,
  mHead: Y1,
  wdName: V1,
  mBody: J1,
  mWeek: Q1,
  mCells: Z1,
  cell: eb,
  out: tb,
  dayNum: nb,
  creatable: ab,
  selDay: ob,
  cellHead: rb,
  isToday: sb,
  holiday: lb,
  addHint: cb,
  barLayer: ib,
  chip: ub,
  more: mb,
  tEv: db,
  aRow: _b,
  popItem: pb,
  bar: fb,
  contL: yb,
  contR: bb,
  dotChip: hb,
  dot: gb,
  chipTime: Eb,
  chipTitle: vb,
  movable: kb,
  ghost: wb,
  time: Nb,
  tHead: $b,
  tAllDay: xb,
  gutter: Db,
  tHeadDays: Cb,
  tAllDayCells: Ab,
  tDay: Sb,
  tDayBtn: Bb,
  tWd: jb,
  tDayNum: Mb,
  tAllDayRow: Tb,
  allDayCell: Lb,
  tBody: Ib,
  tGrid: qb,
  tGutter: Fb,
  tCols: Rb,
  tCol: Pb,
  tSel: Xb,
  tEvTitle: Ob,
  tEvTime: zb,
  tEvShort: Wb,
  contTop: Kb,
  contBottom: Hb,
  resize: Ub,
  now: Gb,
  agenda: Yb,
  aDay: Vb,
  aDate: Jb,
  aDateBtn: Qb,
  aDayNum: Zb,
  aDayWd: eh,
  aList: th,
  aTime: nh,
  aTitle: ah,
  aSpan: oh,
  aLoc: rh,
  empty: sh,
  pop: lh,
  popHead: ch,
  popDay: ih,
  popClose: uh,
  popList: mh
}, ca = 22, dh = {
  accent: M.tAccent,
  ok: M.tOk,
  warn: M.tWarn,
  danger: M.tDanger,
  violet: M.tViolet,
  gray: M.tGray
};
function pa(e) {
  var n;
  return e.color ? "" : dh[(n = e.tone) != null ? n : "accent"];
}
function fa(e) {
  if (e.color)
    return { "--ev": e.color };
}
function $r(e, n) {
  return [e.ev.title, Ga(e, n.allDay), e.ev.location].filter(Boolean).join(", ");
}
const Fn = (e, n) => !!e.onEventChange && !n.locked;
function na(e, n, a) {
  var o;
  for (const r of document.elementsFromPoint(e, n)) {
    const s = (o = r.closest) == null ? void 0 : o.call(r, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function ia(e, n) {
  const a = e.clientX, o = e.clientY;
  let r = !1;
  const s = (u) => {
    !r && Math.hypot(u.clientX - a, u.clientY - o) < 4 || (r = !0, n.move(u));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", i), window.removeEventListener("pointercancel", c), window.removeEventListener("keydown", m, !0);
  }, i = (u) => {
    l(), n.end(u, r);
  }, c = () => {
    l(), n.cancel();
  }, m = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), c());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", i), window.addEventListener("pointercancel", c), window.addEventListener("keydown", m, !0);
}
function xr(e) {
  const [n, a] = B(null), [o, r] = B(null), s = F(!1);
  return { preview: n, items: (d, f) => da(e.events, d, f, n), onItemDown: (d, f) => {
    var _;
    if (d.button !== 0 || !Fn(e, f.ev)) return;
    const p = (_ = na(d.clientX, d.clientY, "data-cal-day")) == null ? void 0 : _.dataset.calDay;
    if (!p) return;
    s.current = !1;
    let y = 0;
    ia(d, {
      move: (b) => {
        var E;
        s.current = !0;
        const $ = (E = na(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : E.dataset.calDay;
        $ && (y = En(p, $), a({ id: f.ev.id, ...Ia(f, y * Ae) }));
      },
      end: (b, $) => {
        var E;
        a(null), $ && y && ((E = e.onEventChange) == null || E.call(e, f.ev, Ia(f, y * Ae)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (d, f) => {
    if (d.button !== 0 || !e.onCreate) return;
    d.preventDefault();
    let p = f;
    r({ a: f, b: f }), ia(d, {
      move: (y) => {
        var b;
        const _ = (b = na(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        _ && (p = _, r({ a: f, b: _ }));
      },
      end: () => {
        var b;
        r(null);
        const [y, _] = f <= p ? [f, p] : [p, f];
        (b = e.onCreate) == null || b.call(e, { start: y, end: _, allDay: !0 });
      },
      cancel: () => r(null)
    });
  }, clickItem: (d, f) => {
    var p;
    if (s.current) {
      s.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, f, d);
  }, inSel: (d) => !!o && d >= (o.a < o.b ? o.a : o.b) && d <= (o.a < o.b ? o.b : o.a) };
}
function Dr({
  segs: e,
  cols: n,
  top: a,
  ctx: o,
  drag: r
}) {
  return /* @__PURE__ */ t.createElement("div", { className: M.barLayer }, e.map((s) => {
    var d;
    const l = s.item, i = l.ev, c = $1(l), m = st(l.s - be(l.sDay)), u = [
      M.chip,
      c ? M.bar : M.dotChip,
      pa(i),
      s.contL ? M.contL : "",
      s.contR ? M.contR : "",
      ((d = r.preview) == null ? void 0 : d.id) === i.id ? M.ghost : "",
      Fn(o, i) ? M.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: `${i.id}:${s.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${s.col / n * 100}% + 2px)`,
          width: `calc(${s.span / n * 100}% - 4px)`,
          top: a + s.lane * ca,
          ...fa(i)
        },
        "aria-label": $r(l, o.L),
        onPointerDown: (f) => r.onItemDown(f, l),
        onClick: (f) => r.clickItem(f.currentTarget, i)
      },
      c ? /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, m), i.title) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }), /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, m), /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, i.title))
    );
  }));
}
const va = 26;
function _h({ ctx: e }) {
  const { L: n, cursor: a, today: o, weekStartsOn: r, showWeekends: s, holidays: l } = e, i = a.slice(0, 7), c = xe(
    () => kr(a, r).map((D) => s ? D : D.filter((h) => !Xn(h))),
    [a, r, s]
  ), m = c[0].length, u = xr(e), d = u.items(c[0][0], c[c.length - 1][m - 1]), f = F(null), [p, y] = B(0);
  Ke(() => {
    const D = f.current;
    if (!D) return;
    const h = () => y(D.clientHeight / c.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(h);
    return w.observe(D), () => w.disconnect();
  }, [c.length]);
  const _ = p ? Math.max(1, Math.floor((p - va - 4) / ca)) : 3, b = F(!1), $ = F(null);
  H(() => {
    var D, h;
    b.current && (b.current = !1, (h = (D = $.current) == null ? void 0 : D.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, i]);
  const E = (D, h) => {
    let w = we(D, h);
    for (; !s && Xn(w); ) w = we(w, h > 0 ? 1 : -1);
    return w;
  }, k = (D, h, w) => {
    let v = null;
    if (D.key === "ArrowLeft") v = E(h, -1);
    else if (D.key === "ArrowRight") v = E(h, 1);
    else if (D.key === "ArrowUp") v = E(h, -7);
    else if (D.key === "ArrowDown") v = E(h, 7);
    else if (D.key === "Home") v = w[0];
    else if (D.key === "End") v = w[w.length - 1];
    else if (D.key === "Enter" || D.key === " ") {
      D.preventDefault(), e.goto("day", h);
      return;
    }
    v && (D.preventDefault(), b.current = !0, e.setCursor(v));
  };
  return /* @__PURE__ */ t.createElement("div", { className: M.month, role: "grid", "aria-label": n.ym(`${i}-01`), ref: $ }, /* @__PURE__ */ t.createElement("div", { className: M.mHead, role: "row" }, c[0].map((D) => {
    const h = Me(de(D));
    return /* @__PURE__ */ t.createElement("div", { key: D, role: "columnheader", className: [M.wdName, h === 0 ? M.sun : "", h === 6 ? M.sat : ""].join(" ") }, n.weekdays[h]);
  })), /* @__PURE__ */ t.createElement("div", { className: M.mBody, ref: f }, c.map((D) => {
    const { shown: h, more: w } = C1(wr(d, D), m, _);
    return /* @__PURE__ */ t.createElement("div", { key: D[0], className: M.mWeek, role: "row" }, /* @__PURE__ */ t.createElement("div", { className: M.mCells, style: { gridTemplateColumns: `repeat(${m}, minmax(0, 1fr))` } }, D.map((v) => {
      const C = de(v), x = Me(C), A = l[v], N = d.filter((S) => S.sDay <= v && S.eDay >= v).length, L = [
        M.cell,
        v.slice(0, 7) !== i ? M.out : "",
        x === 0 || A ? M.sun : x === 6 ? M.sat : "",
        v === o ? M.isToday : "",
        u.inSel(v) ? M.selDay : "",
        e.onCreate ? M.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ t.createElement(
        "div",
        {
          key: v,
          role: "gridcell",
          "data-cal-day": v,
          tabIndex: v === a ? 0 : -1,
          "aria-selected": v === a,
          "aria-current": v === o ? "date" : void 0,
          "aria-label": `${n.dayAria(v)}${A ? ` ${A}` : ""}, ${n.eventCount(N)}`,
          className: L,
          onPointerDown: (S) => u.onCellDown(S, v),
          onKeyDown: (S) => k(S, v, D)
        },
        /* @__PURE__ */ t.createElement("div", { className: M.cellHead }, /* @__PURE__ */ t.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: M.dayNum,
            "aria-label": n.openDay(v),
            onPointerDown: (S) => S.stopPropagation(),
            onClick: () => e.goto("day", v)
          },
          C.d === 1 ? n.md(v) : C.d
        ), A && /* @__PURE__ */ t.createElement("span", { className: M.holiday, title: A }, A), e.onCreate && /* @__PURE__ */ t.createElement("span", { className: M.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ t.createElement(Dr, { segs: h, cols: m, top: va, ctx: e, drag: u }), w.map((v, C) => v > 0 ? /* @__PURE__ */ t.createElement(
      "button",
      {
        key: D[C],
        type: "button",
        className: M.more,
        style: {
          left: `calc(${C / m * 100}% + 2px)`,
          width: `calc(${100 / m}% - 4px)`,
          top: va + (_ - 1) * ca
        },
        onClick: (x) => e.openMore(D[C], x.currentTarget)
      },
      n.more(v)
    ) : null));
  })));
}
const ot = 44, ph = Array.from({ length: 23 }, (e, n) => n + 1);
function Do() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function ka(e, n) {
  const a = n.getBoundingClientRect();
  return Math.max(0, Math.min(Ae, (e - a.top) / ot * 60));
}
function Co({ ctx: e, days: n }) {
  const a = n.length, o = e.slotMinutes, r = xr(e), [s, l] = B(null), [i, c] = B(null), m = F(!1), u = da(e.events, n[0], n[a - 1], s != null ? s : r.preview), d = wr(u.filter(vr), n), f = d.reduce((h, w) => Math.max(h, w.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, _] = B(Do);
  H(() => {
    const h = window.setInterval(() => _(Do()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = F(null), $ = n.includes(e.today);
  Ke(() => {
    const h = b.current;
    if (!h) return;
    const w = $ ? Math.max(0, Math.floor((y - be(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = w * ot;
  }, [n[0], a]);
  const E = (h, w) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const v = h.currentTarget, C = Math.min(Ae - o, Math.floor(ka(h.clientY, v) / o) * o);
    let x = C;
    c({ day: w, a: C, b: C + o }), ia(h, {
      move: (A) => {
        x = Math.min(Ae - o, Math.floor(ka(A.clientY, v) / o) * o), c({ day: w, a: Math.min(C, x), b: Math.max(C, x) + o });
      },
      end: (A, N) => {
        var W;
        c(null);
        const L = be(w), S = N ? Math.min(C, x) : C, P = N ? Math.max(C, x) + o : Math.min(C + 60, Ae);
        (W = e.onCreate) == null || W.call(e, { start: qn(L + S), end: qn(L + P), allDay: !1 });
      },
      cancel: () => c(null)
    });
  }, k = (h, w, v) => {
    if (h.stopPropagation(), h.button !== 0 || !Fn(e, w.ev)) return;
    const C = (N, L) => {
      const S = na(N, L, "data-cal-col");
      return S ? be(S.dataset.calCol) + ka(L, S) : null;
    }, x = C(h.clientX, h.clientY);
    if (x == null) return;
    m.current = !1;
    let A = null;
    ia(h, {
      move: (N) => {
        m.current = !0;
        const L = C(N.clientX, N.clientY);
        if (L != null) {
          if (v === "move") {
            const S = $o(L - x, o);
            A = S ? Ia(w, S) : null;
          } else {
            const S = Math.max(w.s + o, $o(L, o));
            A = S !== w.e ? { start: w.ev.start, end: qn(S) } : null;
          }
          l(A ? { id: w.ev.id, ...A } : null);
        }
      },
      end: (N, L) => {
        var S;
        l(null), L && A && ((S = e.onEventChange) == null || S.call(e, w.ev, A));
      },
      cancel: () => l(null)
    });
  }, D = (h, w) => {
    var v;
    if (m.current) {
      m.current = !1;
      return;
    }
    (v = e.onEventClick) == null || v.call(e, w, h);
  };
  return /* @__PURE__ */ t.createElement("div", { className: M.time }, /* @__PURE__ */ t.createElement("div", { className: M.tHead }, /* @__PURE__ */ t.createElement("div", { className: M.gutter }), /* @__PURE__ */ t.createElement("div", { className: M.tHeadDays, style: p }, n.map((h) => {
    const w = de(h), v = Me(w), C = e.holidays[h];
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: h,
        className: [M.tDay, h === e.today ? M.isToday : "", v === 0 || C ? M.sun : v === 6 ? M.sat : ""].join(" ")
      },
      /* @__PURE__ */ t.createElement("button", { type: "button", className: M.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ t.createElement("span", { className: M.tWd }, e.L.weekdays[v]), /* @__PURE__ */ t.createElement("span", { className: M.tDayNum }, w.d)),
      C && /* @__PURE__ */ t.createElement("span", { className: M.holiday, title: C }, C)
    );
  }))), /* @__PURE__ */ t.createElement("div", { className: M.tAllDay }, /* @__PURE__ */ t.createElement("div", { className: M.gutter }, e.L.allDay), /* @__PURE__ */ t.createElement("div", { className: M.tAllDayRow, style: { height: Math.max(1, f) * ca + 6 } }, /* @__PURE__ */ t.createElement("div", { className: M.tAllDayCells, style: p }, n.map((h) => /* @__PURE__ */ t.createElement(
    "div",
    {
      key: h,
      "data-cal-day": h,
      className: [M.allDayCell, r.inSel(h) ? M.selDay : "", e.onCreate ? M.creatable : ""].join(" "),
      onPointerDown: (w) => r.onCellDown(w, h)
    }
  ))), /* @__PURE__ */ t.createElement(Dr, { segs: d, cols: a, top: 3, ctx: e, drag: r }))), /* @__PURE__ */ t.createElement("div", { className: M.tBody, ref: b }, /* @__PURE__ */ t.createElement("div", { className: M.tGrid, style: { height: 24 * ot } }, /* @__PURE__ */ t.createElement("div", { className: M.tGutter, "aria-hidden": !0 }, ph.map((h) => /* @__PURE__ */ t.createElement("span", { key: h, style: { top: h * ot } }, st(h * 60)))), /* @__PURE__ */ t.createElement("div", { className: M.tCols, style: { ...p, backgroundSize: `100% ${ot}px` } }, n.map((h) => {
    const w = S1(u, h);
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [M.tCol, h === e.today ? M.isToday : "", e.onCreate ? M.creatable : ""].join(" "),
        onPointerDown: (v) => E(v, h)
      },
      (i == null ? void 0 : i.day) === h && /* @__PURE__ */ t.createElement("div", { className: M.tSel, style: { top: i.a / 60 * ot, height: (i.b - i.a) / 60 * ot } }, st(i.a), " – ", i.b === Ae ? "24:00" : st(i.b)),
      w.map((v) => {
        const C = v.item.ev, x = (v.bottom - v.top) / 60 * ot, A = [
          M.tEv,
          pa(C),
          x < 34 ? M.tEvShort : "",
          v.contTop ? M.contTop : "",
          v.contBottom ? M.contBottom : "",
          (s == null ? void 0 : s.id) === C.id ? M.ghost : "",
          Fn(e, C) ? M.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ t.createElement(
          "button",
          {
            key: C.id,
            type: "button",
            className: A,
            style: {
              top: v.top / 60 * ot,
              height: Math.max(18, x - 1),
              left: `calc(${v.col / v.cols * 100}% + 1px)`,
              width: `calc(${100 / v.cols}% - 4px)`,
              ...fa(C)
            },
            "aria-label": $r(v.item, e.L),
            onPointerDown: (N) => k(N, v.item, "move"),
            onClick: (N) => D(N.currentTarget, C)
          },
          /* @__PURE__ */ t.createElement("span", { className: M.tEvTitle }, C.title),
          /* @__PURE__ */ t.createElement("span", { className: M.tEvTime }, Ga(v.item, e.L.allDay)),
          Fn(e, C) && !v.contBottom && /* @__PURE__ */ t.createElement("span", { className: M.resize, "aria-hidden": !0, onPointerDown: (N) => k(N, v.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ t.createElement("div", { className: M.now, style: { top: (y - be(h)) / 60 * ot }, "aria-hidden": !0 })
    );
  })))));
}
function Ao(e, n, a) {
  return e.sDay === e.eDay ? Ga(e, a) : e.allDay ? a : n === e.sDay ? `${st(e.s - be(n))} ~` : n === e.eDay ? `~ ${st(e.e - be(n))}` : a;
}
function fh({ ctx: e }) {
  const { L: n } = e, { from: a, to: o } = Ua("agenda", e.cursor, e.weekStartsOn), r = da(e.events, a, o), s = _a(a, o).filter((l) => e.showWeekends || !Xn(l)).map((l) => {
    const i = be(l), c = (u) => Ao(u, l, "") === "" ? -1 : Math.max(u.s, i), m = r.filter((u) => u.sDay <= l && u.eDay >= l);
    return { day: l, list: m.sort((u, d) => c(u) - c(d)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ t.createElement("div", { className: M.agenda }, s.map(({ day: l, list: i }) => {
    const c = de(l), m = e.holidays[l], u = Me(c), d = n.weekdays[u];
    return /* @__PURE__ */ t.createElement("section", { key: l, className: [M.aDay, l === e.today ? M.isToday : ""].join(" "), "aria-label": n.dayAria(l) }, /* @__PURE__ */ t.createElement("div", { className: [M.aDate, u === 0 || m ? M.sun : u === 6 ? M.sat : ""].join(" ") }, /* @__PURE__ */ t.createElement("button", { type: "button", className: M.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ t.createElement("span", { className: M.aDayNum }, c.d), /* @__PURE__ */ t.createElement("span", { className: M.aDayWd }, n.m(l), " · ", d)), m && /* @__PURE__ */ t.createElement("span", { className: M.holiday }, m)), /* @__PURE__ */ t.createElement("ul", { className: M.aList }, i.map((f) => {
      const p = f.ev, y = En(f.sDay, f.eDay) + 1;
      return /* @__PURE__ */ t.createElement("li", { key: p.id }, /* @__PURE__ */ t.createElement(
        "button",
        {
          type: "button",
          className: [M.aRow, pa(p)].join(" "),
          style: fa(p),
          onClick: (_) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, _.currentTarget);
          }
        },
        /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ t.createElement("span", { className: M.aTime }, Ao(f, l, n.allDay)),
        /* @__PURE__ */ t.createElement("span", { className: M.aTitle }, p.title, y > 1 && /* @__PURE__ */ t.createElement("em", { className: M.aSpan }, n.dayOfSpan(En(f.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ t.createElement("span", { className: M.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ t.createElement("div", { className: M.empty }, n.empty);
}
const wa = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function So(e, n, a) {
  const [o, r] = B(n), s = e !== void 0 ? e : o;
  return [s, (i) => {
    e === void 0 && r(i), i !== s && (a == null || a(i));
  }];
}
const Bo = ({ dir: e }) => /* @__PURE__ */ t.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ t.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function Rx({
  events: e,
  view: n,
  defaultView: a,
  onViewChange: o,
  date: r,
  defaultDate: s,
  onDateChange: l,
  views: i = ["month", "week", "day", "agenda"],
  weekStartsOn: c = 0,
  defaultShowWeekends: m = !0,
  weekendToggle: u = !0,
  holidays: d,
  slotMinutes: f = 30,
  scrollToHour: p = 8,
  onRangeChange: y,
  onEventClick: _,
  onCreate: b,
  onEventChange: $,
  locale: E = Nr,
  loading: k,
  headerExtra: D,
  className: h = "",
  style: w,
  "aria-label": v
}) {
  var ue;
  const C = hr(), [x, A] = So(n, (ue = a != null ? a : i[0]) != null ? ue : "month", o), [N, L] = So(r, s != null ? s : C, l), S = de(N) ? N : C, [P, W] = B(m), [q, R] = B(null), oe = F(null), ne = F(!1);
  H(() => {
    var re;
    if (!ne.current) return;
    ne.current = !1;
    const K = oe.current;
    !K || K.contains(document.activeElement) || ((re = K.querySelector('[data-cal-day][tabindex="0"]')) != null ? re : K).focus();
  });
  const { from: g, to: X } = Ua(x, S, c), Y = F(y);
  Y.current = y, H(() => {
    var K;
    (K = Y.current) == null || K.call(Y, { from: g, to: X, view: x });
  }, [g, X, x]);
  const V = (K, re) => {
    L(re), i.includes(K) && A(K);
  }, T = {
    events: e,
    L: E,
    cursor: S,
    today: C,
    weekStartsOn: c,
    showWeekends: P,
    holidays: d != null ? d : {},
    slotMinutes: f,
    scrollToHour: p,
    setCursor: L,
    goto: V,
    openMore: (K, re) => R({ day: K, anchor: re }),
    onEventClick: _,
    onCreate: b,
    onEventChange: $
  }, U = (K) => L(x1(x, S, K, x === "day" && !P)), ee = (K) => {
    if (K.defaultPrevented || K.ctrlKey || K.metaKey || K.altKey || K.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const re = K.nativeEvent.code;
    if (re === "KeyT") L(C);
    else if (re === "KeyN" || re === "KeyJ" || K.key === "PageDown") U(1);
    else if (re === "KeyP" || re === "KeyK" || K.key === "PageUp") U(-1);
    else if (wa[re] && i.includes(wa[re])) A(wa[re]);
    else if (re === "KeyC" && b)
      b(x === "month" || x === "agenda" ? { start: S, end: S, allDay: !0 } : { start: `${S}T09:00`, end: `${S}T10:00`, allDay: !1 });
    else return;
    K.preventDefault(), ne.current = !0;
  }, ie = xe(
    () => _a(g, X).filter((K) => P || !Xn(K)),
    [g, X, P]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [M.cal, h].filter(Boolean).join(" "),
      style: w,
      role: "region",
      "aria-label": v != null ? v : E.region,
      "aria-busy": k || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: ee,
      ref: oe,
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement("div", { className: M.toolbar }, /* @__PURE__ */ t.createElement(hn, { onClick: () => L(C), title: `${E.today} (T)` }, E.today), /* @__PURE__ */ t.createElement("span", { className: M.navBtns }, /* @__PURE__ */ t.createElement(Ma, { label: E.prev(x), onClick: () => U(-1) }, /* @__PURE__ */ t.createElement(Bo, { dir: "l" })), /* @__PURE__ */ t.createElement(Ma, { label: E.next(x), onClick: () => U(1) }, /* @__PURE__ */ t.createElement(Bo, { dir: "r" }))), /* @__PURE__ */ t.createElement("h2", { className: M.title, "aria-live": "polite" }, D1(x, S, c, E)), /* @__PURE__ */ t.createElement("span", { className: M.toolRight }, D, u && x !== "day" && /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: M.toggle,
        "aria-pressed": !P,
        onClick: () => W((K) => !K)
      },
      E.hideWeekends
    ), i.length > 1 && /* @__PURE__ */ t.createElement(
      _r,
      {
        variant: "segmented",
        "aria-label": E.viewTabs,
        items: i.map((K) => ({ key: K, label: E.views[K] })),
        value: x,
        onChange: (K) => A(K)
      }
    ))),
    /* @__PURE__ */ t.createElement("div", { className: M.body }, k && /* @__PURE__ */ t.createElement("div", { className: M.busy, role: "progressbar", "aria-label": E.loading }), x === "month" && /* @__PURE__ */ t.createElement(_h, { ctx: T }), x === "week" && /* @__PURE__ */ t.createElement(Co, { ctx: T, days: ie }), x === "day" && /* @__PURE__ */ t.createElement(Co, { ctx: T, days: [S] }), x === "agenda" && /* @__PURE__ */ t.createElement(fh, { ctx: T })),
    q && /* @__PURE__ */ t.createElement(yh, { ctx: T, day: q.day, anchor: q.anchor, onClose: () => R(null) })
  );
}
function yh({ ctx: e, day: n, anchor: a, onClose: o }) {
  const r = F(null), [s, l] = B({ top: -9999, left: -9999 }), i = de(n), c = da(e.events, n, n);
  return Ke(() => {
    var p;
    const m = r.current;
    if (!m) return;
    const u = a.getBoundingClientRect(), d = m.offsetWidth, f = m.offsetHeight;
    l({
      left: Math.max(8, Math.min(u.left + u.width / 2 - d / 2, window.innerWidth - d - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - f - 8))
    }), (p = m.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), H(() => {
    const m = () => {
      o(), a.isConnected && a.focus();
    }, u = (f) => {
      var p;
      (p = r.current) != null && p.contains(f.target) || o();
    }, d = (f) => {
      f.key === "Escape" && (f.preventDefault(), m());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", d), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", d);
    };
  }, [a, o]), /* @__PURE__ */ t.createElement(wn, null, /* @__PURE__ */ t.createElement("div", { ref: r, className: M.pop, style: s, role: "dialog", "aria-label": `${e.L.md(n)} ${e.L.eventCount(c.length)}` }, /* @__PURE__ */ t.createElement("div", { className: M.popHead }, /* @__PURE__ */ t.createElement("button", { type: "button", className: M.popDay, onClick: () => {
    o(), e.goto("day", n);
  } }, /* @__PURE__ */ t.createElement("span", null, e.L.weekdays[Me(i)]), /* @__PURE__ */ t.createElement("b", null, i.d)), /* @__PURE__ */ t.createElement("button", { type: "button", className: M.popClose, "aria-label": e.L.close, onClick: o }, "✕")), /* @__PURE__ */ t.createElement("ul", { className: M.popList }, c.map((m) => {
    const u = m.ev, d = m.allDay || m.sDay !== m.eDay;
    return /* @__PURE__ */ t.createElement("li", { key: u.id }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [M.popItem, d ? M.bar : M.dotChip, pa(u)].join(" "),
        style: fa(u),
        onClick: () => {
          var f;
          o(), (f = e.onEventClick) == null || f.call(e, u, a);
        }
      },
      !d && /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }),
      !m.allDay && /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, st(Math.max(m.s, be(n)) - be(n))),
      /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, u.title)
    ));
  }))));
}
const bh = "_mini_q7p5n_3", hh = "_nav_q7p5n_5", gh = "_navBtn_q7p5n_6", Eh = "_todayBtn_q7p5n_6", vh = "_title_q7p5n_6", kh = "_day_q7p5n_25", wh = "_mon_q7p5n_25", Nh = "_grid_q7p5n_29", $h = "_wdRow_q7p5n_30", xh = "_row_q7p5n_30", Dh = "_sun_q7p5n_35", Ch = "_sat_q7p5n_36", Ah = "_num_q7p5n_45", Sh = "_sel_q7p5n_46", Bh = "_out_q7p5n_50", jh = "_isToday_q7p5n_52", Mh = "_dots_q7p5n_55", Th = "_months_q7p5n_59", ce = {
  mini: bh,
  nav: hh,
  navBtn: gh,
  todayBtn: Eh,
  title: vh,
  day: kh,
  mon: wh,
  grid: Nh,
  wdRow: $h,
  row: xh,
  sun: Dh,
  sat: Ch,
  num: Ah,
  sel: Sh,
  out: Bh,
  isToday: jh,
  dots: Mh,
  months: Th
}, jo = (e, n) => `${String(e).padStart(4, "0")}-${String(n).padStart(2, "0")}`;
function Px({
  month: e,
  onMonthChange: n,
  value: a,
  onPick: o,
  marks: r = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: i = 0,
  locale: c = Nr,
  today: m,
  children: u,
  className: d = "",
  "aria-label": f
}) {
  const p = m != null ? m : hr(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, _ = de(y), b = la(y, i), $ = _a(b, we(b, 41)), E = s != null ? s : c.eventCount, [k, D] = B("day"), [h, w] = B(_.y), v = (q) => !!q && q.slice(0, 7) === y.slice(0, 7), [C, x] = B(() => v(a) ? a : v(p) ? p : y);
  H(() => {
    v(C) || x(v(a) ? a : v(p) ? p : y);
  }, [y]);
  const A = F(!1), N = F(null);
  H(() => {
    var q, R;
    A.current && (A.current = !1, (R = (q = N.current) == null ? void 0 : q.querySelector(`[data-day="${C}"]`)) == null || R.focus());
  }, [C, y]);
  const L = (q) => {
    A.current = !0, x(q), v(q) || n(q.slice(0, 7));
  }, S = (q) => {
    const R = It(_, q);
    n(jo(R.y, R.m));
  }, P = (q, R) => {
    const oe = de(R), ne = (Me(oe) - i + 7) % 7;
    let g = null;
    if (q.key === "ArrowLeft") g = we(R, -1);
    else if (q.key === "ArrowRight") g = we(R, 1);
    else if (q.key === "ArrowUp") g = we(R, -7);
    else if (q.key === "ArrowDown") g = we(R, 7);
    else if (q.key === "Home") g = we(R, -ne);
    else if (q.key === "End") g = we(R, 6 - ne);
    else if (q.key === "PageUp" || q.key === "PageDown") {
      const X = It(oe, q.key === "PageUp" ? -1 : 1);
      g = Ve(X.y, X.m, X.d);
    }
    g && (q.preventDefault(), L(g));
  }, W = () => {
    w(_.y), D("month");
  };
  return /* @__PURE__ */ t.createElement("div", { className: [ce.mini, d].filter(Boolean).join(" "), role: f ? "group" : void 0, "aria-label": f }, k === "day" ? /* @__PURE__ */ t.createElement("div", { className: ce.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.navBtn, "aria-label": c.prevMonth, onClick: () => S(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.title, "aria-label": `${c.ym(y)}, ${c.pickMonth}`, "aria-live": "polite", onClick: W }, c.ym(y)), /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.navBtn, "aria-label": c.nextMonth, onClick: () => S(1) }, "›"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: ce.todayBtn,
      disabled: v(p),
      onClick: () => {
        n(p.slice(0, 7)), L(p);
      }
    },
    c.today
  )) : /* @__PURE__ */ t.createElement("div", { className: ce.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.navBtn, "aria-label": c.prevYear, onClick: () => w((q) => q - 1) }, "‹"), /* @__PURE__ */ t.createElement("span", { className: ce.title, "aria-live": "polite" }, c.year(`${h}-12-31`)), /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.navBtn, "aria-label": c.nextYear, onClick: () => w((q) => q + 1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", className: ce.todayBtn, onClick: () => D("day"), "aria-label": c.close }, "✕")), k === "month" ? /* @__PURE__ */ t.createElement("div", { className: ce.months, onKeyDown: (q) => {
    q.key === "Escape" && (q.preventDefault(), D("day"));
  } }, Array.from({ length: 12 }, (q, R) => {
    const oe = jo(h, R + 1), ne = oe === y.slice(0, 7);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: oe,
        type: "button",
        className: [ce.mon, ne ? ce.sel : "", oe === p.slice(0, 7) ? ce.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": ne,
        autoFocus: ne,
        onClick: () => {
          n(oe), D("day");
        }
      },
      c.m(`${oe}-01`)
    );
  })) : /* @__PURE__ */ t.createElement("div", { className: ce.grid, role: "grid", "aria-label": c.ym(y), ref: N }, /* @__PURE__ */ t.createElement("div", { className: ce.wdRow, role: "row" }, $.slice(0, 7).map((q) => {
    const R = Me(de(q));
    return /* @__PURE__ */ t.createElement("span", { key: q, role: "columnheader", className: R === 0 ? ce.sun : R === 6 ? ce.sat : "" }, c.weekdays[R]);
  })), [0, 1, 2, 3, 4, 5].map((q) => /* @__PURE__ */ t.createElement("div", { key: q, className: ce.row, role: "row" }, $.slice(q * 7, q * 7 + 7).map((R) => {
    var Y;
    const oe = Me(de(R)), ne = l[R], g = (Y = r[R]) != null ? Y : 0, X = [
      ce.day,
      v(R) ? "" : ce.out,
      oe === 0 || ne ? ce.sun : oe === 6 ? ce.sat : "",
      R === p ? ce.isToday : "",
      R === a ? ce.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: R,
        type: "button",
        role: "gridcell",
        "data-day": R,
        className: X,
        tabIndex: R === C ? 0 : -1,
        "aria-selected": R === a,
        "aria-current": R === p ? "date" : void 0,
        "aria-label": [c.dayAria(R), ne, g ? E(g) : ""].filter(Boolean).join(", "),
        onKeyDown: (V) => P(V, R),
        onFocus: () => x(R),
        onClick: () => o(R)
      },
      /* @__PURE__ */ t.createElement("span", { className: ce.num }, +R.slice(8)),
      /* @__PURE__ */ t.createElement("span", { className: ce.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(g, 3) }, (V, T) => /* @__PURE__ */ t.createElement("i", { key: T })))
    );
  })))), u);
}
function Lh(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function Cr(e) {
  return e.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function Ar(e, n = !0) {
  e = Cr(e);
  const a = n && /^\s*-/.test(e), o = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return o ? (a ? "-" : "") + o.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function Ih(e) {
  var o;
  if (e == null || e === "") return "";
  const n = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(n);
  return a ? a[1] + Lh(a[2]) + ((o = a[3]) != null ? o : "") : n;
}
function qh(e) {
  const n = Ar(e);
  if (n === "" || n === "-") return;
  const a = Number(n);
  return Number.isFinite(a) ? a : void 0;
}
function Fh(e) {
  const n = e.match(/\d/g);
  return n ? n.length : 0;
}
function Xx({
  value: e,
  onChangeAm: n,
  allowNegative: a = !0,
  onReject: o,
  unit: r,
  className: s,
  ...l
}) {
  const i = F(null), c = F(null);
  Ke(() => {
    const u = i.current, d = c.current;
    if (c.current = null, !u || d === null) return;
    let f = 0, p = 0;
    for (; f < u.value.length && p < d; )
      /\d/.test(u.value[f]) && (p += 1), f += 1;
    u.setSelectionRange(f, f);
  });
  const m = /* @__PURE__ */ t.createElement(
    "input",
    {
      ...l,
      ref: i,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: Ih(e),
      onChange: (u) => {
        var p;
        const d = u.target;
        c.current = Fh(d.value.slice(0, (p = d.selectionStart) != null ? p : d.value.length));
        const f = Ar(d.value, a);
        if (o) {
          const y = Cr(d.value);
          !a && /^\s*-/.test(y) ? o("sign") : (/\.\d/.test(y.replace(/^\s*-/, "")) || /\.$/.test(y)) && o("decimal");
        }
        n({ text: f, num: qh(f) });
      }
    }
  );
  return r ? /* @__PURE__ */ t.createElement(t.Fragment, null, m, /* @__PURE__ */ t.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, r)) : m;
}
const Rh = "_box_qzg36_3", Ph = "_banner_qzg36_9", Xh = "_verify_qzg36_10", Oh = "_t_info_qzg36_15", zh = "_t_warn_qzg36_16", Wh = "_t_danger_qzg36_17", Kh = "_error_qzg36_22", Hh = "_note_qzg36_30", Uh = "_noteI_qzg36_42", Gh = "_noteBody_qzg36_43", Yh = "_badge_qzg36_49", Vh = "_b_muted_qzg36_53", Jh = "_b_ok_qzg36_54", Qh = "_b_warn_qzg36_55", Zh = "_b_info_qzg36_56", eg = "_b_off_qzg36_57", We = {
  box: Rh,
  banner: Ph,
  verify: Xh,
  t_info: Oh,
  t_warn: zh,
  t_danger: Wh,
  error: Kh,
  note: Hh,
  noteI: Uh,
  noteBody: Gh,
  badge: Yh,
  b_muted: Vh,
  b_ok: Jh,
  b_warn: Qh,
  b_info: Zh,
  b_off: eg
};
function Ox({ tone: e = "warn", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("div", { className: [We.box, We.banner, We[`t_${e}`], n].filter(Boolean).join(" ") }, a);
}
function zx({ tone: e = "ok", className: n = "", children: a }) {
  const o = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ t.createElement("div", { className: [We.box, We.verify, We[`t_${o}`], n].filter(Boolean).join(" ") }, a);
}
function Sr({ className: e = "", children: n }) {
  return n == null || n === !1 || n === "" ? null : /* @__PURE__ */ t.createElement("p", { className: [We.error, e].filter(Boolean).join(" "), role: "alert" }, typeof n == "string" ? /* @__PURE__ */ t.createElement(tg, { text: n }) : n);
}
function Wx({ label: e = "안내", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("details", { className: [We.note, n].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("summary", null, /* @__PURE__ */ t.createElement("span", { className: We.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ t.createElement("div", { className: We.noteBody }, a));
}
function Kx({ tone: e = "muted", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("span", { className: ["axe-badge", We.badge, We[`b_${e}`], n].filter(Boolean).join(" ") }, a);
}
function tg({ text: e }) {
  return e ? /* @__PURE__ */ t.createElement(t.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((n, a) => a % 2 ? /* @__PURE__ */ t.createElement("b", { key: a }, n) : /* @__PURE__ */ t.createElement(er, { key: a }, n))) : null;
}
const ng = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function ag(e, n = ng) {
  const a = F(e);
  return a.current = e, H(() => {
    if (!e) return;
    const o = (r) => {
      r.preventDefault(), r.returnValue = "";
    };
    return window.addEventListener("beforeunload", o), () => window.removeEventListener("beforeunload", o);
  }, [e]), se(() => !a.current || window.confirm(n), [n]);
}
const og = "_overlay_1c9bs_2", rg = "_modal_1c9bs_7", sg = "_wide_1c9bs_14", lg = "_head_1c9bs_15", cg = "_title_1c9bs_19", ig = "_close_1c9bs_20", ug = "_body_1c9bs_24", mg = "_flush_1c9bs_25", dg = "_error_1c9bs_26", _g = "_foot_1c9bs_28", nt = {
  overlay: og,
  modal: rg,
  wide: sg,
  head: lg,
  title: cg,
  close: ig,
  body: ug,
  flush: mg,
  error: dg,
  foot: _g
}, Gt = [];
function Mo(e) {
  const n = Gt[Gt.length - 1];
  e.key !== "Escape" || !n || !n.esc || (e.preventDefault(), n.close());
}
const pg = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function To(e) {
  return Array.from(e.querySelectorAll(pg)).filter((n) => n.getClientRects().length > 0 && getComputedStyle(n).visibility !== "hidden");
}
let Lo = 0, Io = "";
function Ya({
  title: e,
  onClose: n,
  children: a,
  wide: o,
  footer: r,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: i = !0,
  closeOnEsc: c = !1,
  error: m,
  confirmDiscard: u = !0
}) {
  const [d, f] = B(!1), p = u ? () => {
    d || f(!0);
  } : void 0, y = ag(u && d, "입력한 내용을 저장하지 않고 닫을까요?"), _ = () => {
    y() && n();
  }, b = F(_);
  b.current = _;
  const $ = F({ close: () => b.current(), esc: c });
  $.current.esc = c, H(() => {
    const w = $.current;
    return Gt.push(w), Gt.length === 1 && window.addEventListener("keydown", Mo), () => {
      const v = Gt.lastIndexOf(w);
      v >= 0 && Gt.splice(v, 1), Gt.length === 0 && window.removeEventListener("keydown", Mo);
    };
  }, []);
  const E = F(null), k = F(null), D = F(void 0);
  D.current === void 0 && (D.current = typeof document == "undefined" ? null : document.activeElement), H(() => {
    var C;
    const w = E.current, v = (C = D.current) != null ? C : null;
    return w && !w.contains(document.activeElement) && (k.current && To(k.current)[0] || null || w).focus(), Lo++ === 0 && (Io = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Lo === 0 && (document.body.style.overflow = Io), v && v.isConnected && typeof v.focus == "function" && v.focus();
    };
  }, []);
  const h = (w) => {
    const v = E.current;
    if (w.key !== "Tab" || !v || !v.contains(w.target)) return;
    const C = To(v);
    if (C.length === 0) {
      w.preventDefault(), v.focus();
      return;
    }
    const x = C[0], A = C[C.length - 1], N = document.activeElement;
    w.shiftKey && (N === x || N === v) ? (w.preventDefault(), A.focus()) : !w.shiftKey && N === A && (w.preventDefault(), x.focus());
  };
  return /* @__PURE__ */ t.createElement("div", { className: nt.overlay, onClick: i ? _ : void 0 }, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: E,
      tabIndex: -1,
      className: [nt.modal, o ? nt.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (w) => w.stopPropagation(),
      onKeyDown: h
    },
    /* @__PURE__ */ t.createElement("header", { className: nt.head }, /* @__PURE__ */ t.createElement("strong", { className: nt.title }, e), s, /* @__PURE__ */ t.createElement("button", { type: "button", className: nt.close, onClick: _, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: k,
        className: [nt.body, l ? nt.flush : ""].filter(Boolean).join(" "),
        onInputCapture: p,
        onChangeCapture: p
      },
      a
    ),
    m != null && m !== !1 && m !== "" && /* @__PURE__ */ t.createElement("div", { className: nt.error }, /* @__PURE__ */ t.createElement(Sr, null, m)),
    r && /* @__PURE__ */ t.createElement("footer", { className: nt.foot }, r)
  ));
}
function Hx(e = 4e3) {
  const [n, a] = B(""), [o, r] = B(!1), s = F(void 0), l = se((m) => {
    window.clearTimeout(s.current), r(!1), a(m), s.current = window.setTimeout(() => a(""), e);
  }, [e]), i = se((m) => {
    window.clearTimeout(s.current), r(!0), a(m);
  }, []), c = se(() => {
    window.clearTimeout(s.current), r(!1), a("");
  }, []);
  return [n, l, i, o, c];
}
const fg = "_message_psco6_1", yg = "_details_psco6_2", bg = "_warn_psco6_7", hg = "_field_psco6_8", Jn = {
  message: fg,
  details: yg,
  warn: bg,
  field: hg
};
function Ux() {
  var p, y;
  const [e, n] = B(null), [a, o] = B(""), r = F(null), s = F(null), l = F(null), i = se((_) => new Promise((b) => {
    n({ kind: "confirm", opts: _, resolve: b });
  }), []), c = se((_) => new Promise((b) => {
    var $, E, k, D;
    o((D = (k = _.defaultValue) != null ? k : (E = ($ = _.choices) == null ? void 0 : $[0]) == null ? void 0 : E.value) != null ? D : ""), n({ kind: "prompt", opts: _, resolve: b });
  }), []);
  H(() => {
    var _, b, $;
    e && (e.kind === "prompt" ? (_ = l.current) == null || _.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : ($ = r.current) == null || $.focus());
  }, [e]);
  const m = (_) => {
    e && (e.kind === "confirm" ? e.resolve(_) : e.resolve(_ ? a : null), n(null));
  }, u = e == null ? void 0 : e.opts, d = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), f = e && u ? /* @__PURE__ */ t.createElement(
    Ya,
    {
      title: u.title,
      onClose: () => m(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(hn, { ref: s, onClick: () => m(!1) }, (p = u.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ t.createElement(
        hn,
        {
          ref: r,
          variant: u.danger ? "danger" : "primary",
          disabled: d,
          onClick: () => m(!0)
        },
        (y = u.confirmLabel) != null ? y : "확인"
      ))
    },
    u.message && /* @__PURE__ */ t.createElement("div", { className: Jn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ t.createElement("ul", { className: Jn.details }, u.details.map((_, b) => /* @__PURE__ */ t.createElement("li", { key: b }, _))),
    u.irreversible && /* @__PURE__ */ t.createElement("p", { className: Jn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ t.createElement("label", { className: Jn.field }, /* @__PURE__ */ t.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ t.createElement("select", { ref: l, value: a, onChange: (_) => o(_.target.value) }, e.opts.choices.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.value, value: _.value }, _.label))) : /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (_) => o(_.target.value),
        onKeyDown: (_) => {
          _.key === "Enter" && !d && (_.preventDefault(), m(!0));
        }
      }
    ))
  ) : null;
  return { confirm: i, prompt: c, dialog: f };
}
function Gx(e, n) {
  const a = n ? `${n}에 실패했습니다 — ` : "", o = e > 0 ? ` (오류 ${e})` : "";
  return a + gg(e) + o;
}
function gg(e) {
  return e === 0 ? "서버에 연결하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도하세요" : e === 400 || e === 422 ? "서버가 요청 내용을 받아들이지 않았습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 필요합니다. 다시 로그인해 주세요" : e === 403 ? "이 작업을 할 권한이 없습니다. 필요하면 관리자에게 권한을 요청하세요" : e === 404 ? "요청한 자료나 기능을 찾지 못했습니다. 화면을 새로고침한 뒤 다시 시도하고, 계속되면 관리자에게 알려 주세요" : e === 409 ? "다른 곳에서 먼저 바뀌었습니다. 다시 조회한 뒤 시도하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "서버에서 처리하지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 알려 주세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const Eg = "_section_dyrr7_3", vg = "_row_dyrr7_10", kg = "_label_dyrr7_15", wg = "_value_dyrr7_21", Ng = "_invalid_dyrr7_43", $g = "_help_dyrr7_45", xg = "_err_dyrr7_45", Dg = "_req_dyrr7_49", Cg = "_opt_dyrr7_50", Ag = "_sr_dyrr7_51", Sg = "_ro_dyrr7_10", Bg = "_readonly_dyrr7_58", jg = "_hint_dyrr7_65", Mg = "_toggle_dyrr7_73", Tg = "_table_dyrr7_80", Lg = "_isReq_dyrr7_95", Ce = {
  section: Eg,
  row: vg,
  label: kg,
  value: wg,
  invalid: Ng,
  help: $g,
  err: xg,
  req: Dg,
  opt: Cg,
  sr: Ag,
  ro: Sg,
  readonly: Bg,
  hint: jg,
  toggle: Mg,
  table: Tg,
  isReq: Lg
};
let Ig = 0;
const qg = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function Yx({
  label: e,
  children: n,
  hint: a,
  ro: o,
  htmlFor: r,
  required: s,
  optional: l,
  help: i,
  error: c,
  className: m = ""
}) {
  var h, w, v, C;
  const u = F(`axe-fr${++Ig}`).current, d = `${u}-lbl`, f = F(null), p = i ? `${u}-help` : void 0, y = c ? `${u}-err` : void 0, _ = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let $ = n;
  const E = Aa.count(n) === 1 ? Aa.toArray(n)[0] : null, k = aa(E) && typeof E.type != "string" && !!E.type.axeFormControl;
  if (aa(E) && (typeof E.type == "string" && qg.has(E.type) || k)) {
    const x = E, A = x.props;
    $ = nr(x, {
      id: (h = A.id) != null ? h : r,
      "aria-describedby": (w = A["aria-describedby"]) != null ? w : _,
      "aria-invalid": (v = A["aria-invalid"]) != null ? v : c ? !0 : void 0,
      "aria-required": (C = A["aria-required"]) != null ? C : s ? !0 : void 0
    });
  }
  Ke(() => {
    var L;
    const x = (L = f.current) == null ? void 0 : L.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!x) return;
    const A = (S, P) => {
      const W = `data-fr-${S}`;
      if (P == null) {
        x.hasAttribute(W) && (x.removeAttribute(S), x.removeAttribute(W));
        return;
      }
      x.hasAttribute(S) && !x.hasAttribute(W) || (x.getAttribute(S) !== P && x.setAttribute(S, P), x.setAttribute(W, ""));
    }, N = !!(x.id && document.querySelector(`label[for="${CSS.escape(x.id)}"]`));
    A("aria-labelledby", N ? null : d), A("aria-invalid", c ? "true" : null), A("aria-required", s ? "true" : null), A("aria-describedby", _ != null ? _ : null);
  });
  const D = /* @__PURE__ */ t.createElement(t.Fragment, null, e, s && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ t.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ t.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-form-row", Ce.row, o ? Ce.ro : "", c ? Ce.invalid : "", s ? Ce.isReq : "", m].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-label ${Ce.label}` }, r ? /* @__PURE__ */ t.createElement("label", { htmlFor: r, id: d }, D) : /* @__PURE__ */ t.createElement("span", { id: d }, D), a && /* @__PURE__ */ t.createElement(Zt, { content: b, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ t.createElement("span", { ref: f, className: `axe-form-value ${Ce.value}` }, $, i && /* @__PURE__ */ t.createElement("span", { id: p, className: Ce.help }, i), c && /* @__PURE__ */ t.createElement("span", { id: y, className: Ce.err }, c)));
}
function Vx({ title: e, children: n, className: a = "", variant: o = "stack" }) {
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-form-section", o === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), n);
}
function Jx({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: Ce.readonly }, e);
}
function Qx({ checked: e, onChange: n, disabled: a, label: o, className: r = "" }) {
  return /* @__PURE__ */ t.createElement("label", { className: [Ce.toggle, r].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => n(s.target.checked) }), /* @__PURE__ */ t.createElement("span", null, o));
}
const Fg = "_mono_6omzf_2", Rg = "_invalid_6omzf_3", Pg = "_qty_6omzf_6", Xg = "_qtyInput_6omzf_7", Og = "_unit_6omzf_8", zg = "_note_6omzf_9", Wg = "_qtyErr_6omzf_10", Tt = {
  mono: Fg,
  invalid: Rg,
  qty: Pg,
  qtyInput: Xg,
  unit: Og,
  note: zg,
  qtyErr: Wg
};
function Kg({
  value: e,
  onChange: n,
  disabled: a,
  maxLength: o,
  placeholder: r,
  mono: s,
  invalid: l,
  multiline: i,
  rows: c = 4,
  label: m,
  id: u,
  "aria-describedby": d,
  "aria-invalid": f,
  "aria-required": p,
  className: y = ""
}) {
  const _ = [s ? Tt.mono : "", l ? Tt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: u,
    className: _,
    value: e != null ? e : "",
    maxLength: o,
    placeholder: r,
    disabled: a,
    "aria-label": m,
    "aria-describedby": d,
    "aria-invalid": f != null ? f : l || void 0,
    "aria-required": p,
    onChange: ($) => n($.target.value === "" ? null : $.target.value)
  };
  return i ? /* @__PURE__ */ t.createElement("textarea", { ...b, rows: c }) : /* @__PURE__ */ t.createElement("input", { type: "text", ...b });
}
Kg.axeFormControl = !0;
function Hg(e) {
  const {
    value: n,
    options: a,
    allLabel: o,
    disabled: r,
    label: s,
    id: l,
    "aria-describedby": i,
    "aria-invalid": c,
    "aria-required": m,
    className: u
  } = e, d = (p) => {
    e.codeType === "string" ? e.onChange(p === "" ? null : p) : e.onChange(p === "" ? null : Number(p));
  }, f = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ t.createElement(
    "select",
    {
      id: l,
      className: u,
      value: n == null ? "" : String(n),
      disabled: r,
      "aria-label": s,
      "aria-describedby": i,
      "aria-invalid": c,
      "aria-required": m,
      onChange: (p) => d(p.target.value)
    },
    o != null && /* @__PURE__ */ t.createElement("option", { value: "" }, o),
    f.map(([p, y]) => /* @__PURE__ */ t.createElement("option", { key: p, value: String(p) }, y))
  );
}
Hg.axeFormControl = !0;
function Ug(e) {
  return e.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const Gg = /^-?(\d+\.?\d*|\.\d+)$/;
function jn(e) {
  const n = Ug(e).trim().replace(/,/g, "");
  if (n === "") return { kind: "empty" };
  if (n === "-" || n === "." || n === "-.") return { kind: "partial" };
  if (!Gg.test(n)) return { kind: "bad" };
  const a = Number(n);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function ua(e) {
  if (!Number.isFinite(e)) return 0;
  const n = Math.abs(e).toString(), a = n.indexOf("e-");
  if (a >= 0) {
    const r = n.slice(0, a), s = r.indexOf(".");
    return (s >= 0 ? r.length - s - 1 : 0) + Number(n.slice(a + 2));
  }
  const o = n.indexOf(".");
  return o >= 0 ? n.length - o - 1 : 0;
}
function Br(e, n) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(n));
  if (ua(e) <= a) return e;
  const o = e < 0 ? -1 : 1, r = Math.abs(e).toFixed(Math.min(20, ua(e))), s = Math.round(+`${r}e${a}`), l = o * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function _n(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function Yg(e, n, a) {
  return n != null && e < n || a != null && e > a;
}
function Vg(e, n, a, o, r, s) {
  let l = e == null ? r != null ? r : 0 : Br(e + a * n, Math.max(o, ua(n)));
  return r != null && l < r && (l = r), s != null && l > s && (l = s), l;
}
const Jg = 2500;
function Qg({
  value: e,
  onChange: n,
  decimals: a = 1,
  min: o,
  max: r,
  step: s,
  unit: l,
  disabled: i,
  label: c,
  id: m,
  "aria-describedby": u,
  "aria-invalid": d,
  "aria-required": f,
  width: p,
  onEnter: y,
  onInvalidChange: _,
  placeholder: b,
  className: $ = ""
}) {
  const [E, k] = B(() => _n(e)), [D, h] = B(!1), [w, v] = B(null), [C, x] = B(!1), A = F(null), N = F(E);
  N.current = E, H(() => {
    const g = jn(N.current), X = g.kind === "num" ? g.value : g.kind === "empty" ? null : void 0;
    X !== void 0 && X === (e != null ? e : null) || k(_n(e));
  }, [e]), H(() => () => {
    A.current && clearTimeout(A.current);
  }, []);
  const L = jn(E), S = L.kind === "bad" || L.kind === "partial";
  H(() => {
    S || x(!1);
  }, [S]);
  const P = F(_);
  P.current = _, H(() => {
    var g;
    (g = P.current) == null || g.call(P, S);
  }, [S]), H(() => () => {
    var g;
    (g = P.current) == null || g.call(P, !1);
  }, []);
  const W = (g) => {
    A.current && clearTimeout(A.current), v(g), A.current = setTimeout(() => v(null), Jg);
  }, q = (g) => {
    k(g);
    const X = jn(g);
    X.kind === "empty" ? n(null) : X.kind === "num" && n(X.value);
  }, R = () => {
    const g = jn(E);
    if (g.kind !== "num") return;
    if (ua(g.value) > a) {
      const Y = Br(g.value, a);
      k(_n(Y)), n(Y), W(`반올림했습니다 → ${_n(Y)}`);
      return;
    }
    const X = _n(g.value);
    X !== E && k(X);
  }, oe = (g) => {
    if (!g.nativeEvent.isComposing) {
      if (g.key === "Enter") {
        if (S) {
          x(!0);
          return;
        }
        R(), y == null || y();
        return;
      }
      if (s && (g.key === "ArrowUp" || g.key === "ArrowDown")) {
        g.preventDefault();
        const X = jn(E), Y = X.kind === "num" ? X.value : X.kind === "empty" ? null : e, V = Vg(Y, s, g.key === "ArrowUp" ? 1 : -1, a, o, r);
        k(_n(V)), n(V);
      }
    }
  }, ne = L.kind === "bad" || L.kind === "partial" && (!D || C) || L.kind === "num" && Yg(L.value, o, r);
  return /* @__PURE__ */ t.createElement("span", { className: [Tt.qty, $].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: m,
      className: [Tt.qtyInput, ne ? Tt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: E,
      placeholder: b,
      disabled: i,
      "aria-label": c,
      "aria-describedby": u,
      "aria-invalid": d != null ? d : ne || void 0,
      "aria-required": f,
      onChange: (g) => q(g.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), R();
      },
      onKeyDown: oe
    }
  ), l && /* @__PURE__ */ t.createElement("span", { className: Tt.unit }, l), (L.kind === "bad" || L.kind === "partial" && (!D || C)) && /* @__PURE__ */ t.createElement("span", { className: Tt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ t.createElement("span", { className: Tt.note, role: "status", "aria-live": "polite" }, w));
}
Qg.axeFormControl = !0;
function Zg(e, n) {
  if (e === n || e == null && n == null) return !0;
  if (e == null || n == null) return !1;
  if (typeof e == "object" && typeof n == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(n);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof n == "number" && Number.isNaN(e) && Number.isNaN(n);
}
function eE(e, n) {
  var r;
  if (e === n) return [];
  if (e === null || n === null) return e === null && n === null ? [] : Object.keys((r = e != null ? e : n) != null ? r : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(n)]), o = [];
  return a.forEach((s) => {
    Zg(e[s], n[s]) || o.push(s);
  }), o;
}
function tE(e, n) {
  return e === null || n === null ? e === n : eE(e, n).length === 0;
}
function Zx() {
  const [e, n] = B(null), [a, o] = B(!1), [r, s] = B(null), l = xe(() => a || !tE(r, e), [a, r, e]), i = se((p) => {
    n((y) => y === null ? y : { ...y, ...p });
  }, []), c = se((p, y) => {
    n((_) => _ === null ? _ : { ..._, [p]: y });
  }, []), m = F(null), u = se((p) => {
    m.current = p, n(p), s(p), o(!1);
  }, []), d = se((p) => {
    m.current = p, n(p), s(p), o(!0);
  }, []), f = se(() => n(m.current), []);
  return xe(
    () => ({ draft: e, isNew: a, dirty: l, set: c, patch: i, load: u, start: d, reset: f, snapshot: r }),
    [e, a, l, c, i, u, d, f, r]
  );
}
function e3() {
  const e = F(!1), [n, a] = B(!1), o = se(async (r) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await r();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [n, o];
}
const nE = "_panel_1w7xx_2", aE = "_band_1w7xx_7", oE = "_chev_1w7xx_11", rE = "_title_1w7xx_17", sE = "_note_1w7xx_19", lE = "_chip_1w7xx_21", cE = "_other_1w7xx_32", iE = "_reset_1w7xx_33", uE = "_form_1w7xx_42", bt = {
  panel: nE,
  band: aE,
  chev: oE,
  title: rE,
  note: sE,
  chip: lE,
  other: cE,
  reset: iE,
  form: uE
};
function t3({
  chips: e,
  onReset: n,
  open: a,
  onToggle: o,
  toggleLabel: r = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: i,
  hideWhenEmpty: c,
  ariaLabel: m = "상세검색",
  className: u = ""
}) {
  const d = F(null);
  if (c && !a && e.length === 0) return null;
  const f = (y, _ = 0) => {
    var D, h, w;
    const b = (D = document.querySelector(`section[aria-label="${CSS.escape(m)}"]`)) != null ? D : d.current, $ = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), E = (w = $ && ((h = $[y]) != null ? h : $[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), k = !document.activeElement || document.activeElement === document.body;
    E && E !== document.activeElement && (_ === 0 || k) && E.focus(), _ < 4 && setTimeout(() => f(y, _ + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => f(y));
  };
  return /* @__PURE__ */ t.createElement("section", { className: [bt.panel, u].filter(Boolean).join(" "), "aria-label": m }, /* @__PURE__ */ t.createElement("div", { className: bt.band, ref: d }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: bt.chev, "aria-expanded": !!a, onClick: o }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", r), s !== null && /* @__PURE__ */ t.createElement("span", { className: bt.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ t.createElement("b", null, e.length), "개"), e.map((y, _) => {
    var b;
    return /* @__PURE__ */ t.createElement("span", { key: y.key, className: [bt.chip, y.tone === "other" ? bt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(_)
      },
      "✕"
    ));
  }), n && e.length > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", className: bt.reset, onClick: () => {
    n(), requestAnimationFrame(() => f(0));
  } }, "초기화"), l && /* @__PURE__ */ t.createElement("span", { className: bt.note }, l)), a && i && /* @__PURE__ */ t.createElement("div", { className: bt.form }, i));
}
const mE = "_zone_1y6sp_2", dE = "_drag_1y6sp_8", _E = "_busy_1y6sp_9", pE = "_attached_1y6sp_10", fE = "_left_1y6sp_12", yE = "_icon_1y6sp_13", bE = "_title_1y6sp_18", hE = "_desc_1y6sp_19", gE = "_right_1y6sp_20", EE = "_count_1y6sp_21", vE = "_pick_1y6sp_22", Ge = {
  zone: mE,
  drag: dE,
  busy: _E,
  attached: pE,
  left: fE,
  icon: yE,
  title: bE,
  desc: hE,
  right: gE,
  count: EE,
  pick: vE
};
function n3({
  onFiles: e,
  title: n = "파일 업로드",
  desc: a,
  countText: o,
  accept: r,
  multiple: s = !0,
  disabled: l,
  attached: i,
  pickLabel: c = "파일 선택",
  className: m = ""
}) {
  const u = F(null), [d, f] = B(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Ge.zone, d ? Ge.drag : "", l ? Ge.busy : "", i ? Ge.attached : "", m].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = u.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || f(!0);
      },
      onDragLeave: () => f(!1),
      onDrop: (y) => {
        y.preventDefault(), f(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: Ge.left }, /* @__PURE__ */ t.createElement("div", { className: Ge.icon, "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ t.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ t.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: Ge.title }, n), a && /* @__PURE__ */ t.createElement("div", { className: Ge.desc }, a))),
    /* @__PURE__ */ t.createElement("div", { className: Ge.right }, o && /* @__PURE__ */ t.createElement("span", { className: Ge.count, "aria-live": "polite" }, o), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ge.pick,
        disabled: l,
        onClick: (y) => {
          var _;
          y.stopPropagation(), (_ = u.current) == null || _.click();
        }
      },
      c
    ), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: r,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function kE(e, n) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", o = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (o)
    try {
      return decodeURIComponent(o[1]);
    } catch {
    }
  const r = /filename="?([^";]+)"?/i.exec(a);
  return (l = r == null ? void 0 : r[1]) != null ? l : n;
}
function jr(e, n) {
  const a = URL.createObjectURL(e), o = document.createElement("a");
  o.href = a, o.download = n, document.body.appendChild(o), o.click(), o.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function a3(e, n, a) {
  jr(await e.blob(), a != null ? a : kE(e, n));
}
const wE = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, NE = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Mr(e, n = {}) {
  var r, s;
  const a = e.trim();
  if (n.parenNegative) {
    const l = NE.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(r = l[2]) != null ? r : ""}`;
  }
  const o = wE.exec(a);
  return o ? (o[1] ? "-" : "") + o[2].replace(/,/g, "") + ((s = o[3]) != null ? s : "") : null;
}
function bn(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function $E(e, n = {}) {
  const a = [];
  n.meta && n.meta.length && (n.meta.forEach((l) => a.push(l.map((i) => Zn(bn(String(i != null ? i : "")))).join(","))), a.push(""));
  const o = a.length;
  let r = null;
  const s = (l) => {
    var c;
    const i = xE(l, e);
    !i || i === r || (r = i, a.length > o && a.push(""), a.push(Zn(bn((c = i.getAttribute("data-csv-title")) != null ? c : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var p;
    if (l.tagName !== "TABLE") {
      if ((p = l.parentElement) != null && p.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = DE(l, n);
      if (!y) return;
      s(l), a.push(y.map(Zn).join(","));
      return;
    }
    const i = l;
    s(i);
    const c = i.querySelector("[data-tree-depth]"), m = c ? c.closest("td, th") : null, u = m ? m.cellIndex : -1, d = u >= 0 && !!i.querySelector("[data-csv-path]"), f = [];
    Array.from(i.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const _ = [];
      let b = 0;
      const $ = () => {
        for (; f[b] && f[b].n > 0; )
          f[b].n -= 1, f[b].skip || _.push(""), b += 1;
      };
      Array.from(y.cells).forEach((E) => {
        var v, C;
        $();
        const k = AE(E), D = k ? "" : SE(E, n), h = Math.max(1, E.colSpan || 1), w = Math.max(1, E.rowSpan || 1);
        for (let x = 0; x < h; x += 1)
          k || _.push(x === 0 ? D : ""), f[b] = { n: w - 1, skip: k }, b += 1;
        if (u >= 0 && E.cellIndex === u) {
          const x = E.querySelector("[data-tree-depth]");
          x ? (_.push(String(Number(x.getAttribute("data-tree-depth")) + 1)), d && _.push(bn((v = x.getAttribute("data-csv-path")) != null ? v : ""))) : ((C = y.parentElement) == null ? void 0 : C.tagName) === "THEAD" ? (_.push("단계"), d && _.push("상위 경로")) : (_.push(""), d && _.push(""));
        }
      }), $(), _.some((E) => E !== "") && a.push(_.map(Zn).join(","));
    });
  }), a.join(`\r
`);
}
function xE(e, n) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === n) return null;
    a = a.parentElement;
  }
  return null;
}
function DE(e, n) {
  var m, u;
  const a = e.querySelector("[data-csv-k]"), o = e.querySelector("[data-csv-v]"), r = e.querySelector("[data-csv-unit]"), s = r ? Qn(r) : "";
  let i = ((m = e.getAttribute("data-csv-kv")) != null ? m : "") || (a ? Qn(a) : "");
  if (!i) return null;
  s && (i = `${i} (${s})`);
  let c;
  if (o) {
    const d = o.cloneNode(!0);
    d.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((f) => f.remove()), c = Qn(d);
  } else {
    const d = e.cloneNode(!0);
    d.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((f) => f.remove()), c = Qn(d);
  }
  return (c === "—" || c === "-" || c === "–") && (c = ""), [bn(i), (u = Mr(c, n)) != null ? u : bn(c)];
}
function Qn(e) {
  var n, a;
  return ((a = (n = e.innerText) != null ? n : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function CE(e, n) {
  const a = n.toLowerCase().endsWith(".csv") ? n : `${n}.csv`;
  jr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function AE(e) {
  var n;
  return ((n = e.textContent) != null ? n : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function SE(e, n) {
  var r, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((i) => i.remove()), a.querySelectorAll("[data-csv-sep]").forEach((i) => i.after(" ")));
  let o = ((s = (r = a.innerText) != null ? r : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!o && a.textContent && (o = a.textContent.replace(/\s+/g, " ").trim()), !o) {
    const i = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    i && (o = i.value.trim());
  }
  return o === "—" || o === "-" || o === "–" ? "" : (l = Mr(o, n)) != null ? l : bn(o);
}
function Zn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const BE = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function o3({ target: e, fileName: n, label: a = "CSV 내려받기", disabled: o, parenNegative: r, prepare: s, meta: l }) {
  return /* @__PURE__ */ t.createElement(
    Ma,
    {
      label: a,
      disabled: o,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let i;
        s && (i = await s(), await BE());
        try {
          const c = e.current;
          if (!c) return;
          CE($E(c, { parenNegative: r, meta: l == null ? void 0 : l() }), typeof n == "function" ? n() : n);
        } finally {
          typeof i == "function" && i();
        }
      }
    },
    /* @__PURE__ */ t.createElement(oa, { name: "download", size: 14 }),
    "CSV"
  );
}
const jE = "_card_1adld_1", ME = "_sub_1adld_2", TE = "_state_1adld_3", LE = "_list_1adld_7", IE = "_row_1adld_8", qE = "_warn_1adld_20", FE = "_danger_1adld_21", Ot = {
  card: jE,
  sub: ME,
  state: TE,
  list: LE,
  row: IE,
  warn: qE,
  danger: FE
};
function r3({
  title: e,
  sub: n,
  trailing: a,
  state: o = "ready",
  error: r,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: i,
  className: c = ""
}) {
  return /* @__PURE__ */ t.createElement(
    fr,
    {
      flush: !0,
      className: [Ot.card, c].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(t.Fragment, null, e, n ? /* @__PURE__ */ t.createElement("small", { className: Ot.sub }, n) : null),
      trailing: a
    },
    o === "loading" && /* @__PURE__ */ t.createElement("div", { className: Ot.state }, l),
    o === "error" && /* @__PURE__ */ t.createElement("div", { className: Ot.state }, /* @__PURE__ */ t.createElement(Sr, null, r != null ? r : "불러오지 못했습니다"), s && /* @__PURE__ */ t.createElement(Ha, { onClick: s }, "다시 시도")),
    o === "ready" && /* @__PURE__ */ t.createElement("div", { className: Ot.list }, i.map((m, u) => {
      var p, y;
      const d = [Ot.row, m.tone ? Ot[m.tone] : ""].filter(Boolean).join(" "), f = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", null, m.label), /* @__PURE__ */ t.createElement("strong", null, m.value, m.unit ? /* @__PURE__ */ t.createElement("small", null, m.unit) : null));
      return m.onClick ? /* @__PURE__ */ t.createElement("button", { type: "button", key: (p = m.key) != null ? p : u, className: d, onClick: m.onClick }, f) : /* @__PURE__ */ t.createElement("div", { key: (y = m.key) != null ? y : u, className: d }, f);
    }))
  );
}
function RE(e, n, a, o, r) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, r != null && r > 0 ? Math.floor(r) : s)), i = Math.max(1, Math.min(l, Math.floor((n + o) / (a + o)))), c = Math.ceil(s / i);
  return Math.ceil(s / c);
}
const PE = "_group_afgop_1", XE = "_tile_afgop_2", OE = "_click_afgop_8", zE = "_ok_afgop_11", WE = "_warn_afgop_12", KE = "_danger_afgop_13", HE = "_info_afgop_14", UE = "_accent_afgop_15", GE = "_muted_afgop_16", YE = "_label_afgop_17", VE = "_value_afgop_19", JE = "_desc_afgop_23", Wt = {
  group: PE,
  tile: XE,
  click: OE,
  ok: zE,
  warn: WE,
  danger: KE,
  info: HE,
  accent: UE,
  muted: GE,
  label: YE,
  value: VE,
  desc: JE
};
function s3({
  label: e,
  value: n,
  unit: a,
  desc: o,
  tone: r = "info",
  onClick: s,
  className: l = ""
}) {
  const i = [Wt.tile, Wt[r], s ? Wt.click : "", l].filter(Boolean).join(" "), c = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: Wt.label, "data-csv-k": "" }, /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ t.createElement("span", { className: Wt.value, "data-csv-v": "" }, n, a ? /* @__PURE__ */ t.createElement("small", { "data-csv-unit": "" }, a) : null), o ? /* @__PURE__ */ t.createElement("span", { className: Wt.desc, title: typeof o == "string" ? o : void 0 }, o) : null);
  return s ? /* @__PURE__ */ t.createElement("button", { type: "button", className: i, onClick: s, "data-csv-kv": "" }, c) : /* @__PURE__ */ t.createElement("div", { className: i, "data-csv-kv": "" }, c);
}
const QE = 150, ZE = 12, ev = 8;
function l3({ children: e, columns: n, className: a = "" }) {
  const o = F(null), r = Aa.toArray(e).filter(aa).length, s = n != null || r <= ev, [l, i] = B(null);
  Ke(() => {
    const u = o.current;
    if (!s || !u || (i(u.clientWidth), typeof ResizeObserver == "undefined")) return;
    const d = new ResizeObserver(() => i(u.clientWidth));
    return d.observe(u), () => d.disconnect();
  }, [s]);
  const c = s ? RE(r, l != null ? l : Number.MAX_SAFE_INTEGER, QE, ZE, n) : 0, m = s ? { gridTemplateColumns: `repeat(${c}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ t.createElement("div", { ref: o, className: [Wt.group, a].filter(Boolean).join(" "), style: m }, e);
}
const tv = "_card_1lav2_1", nv = "_n_1lav2_2", av = "_list_1lav2_7", ov = "_row_1lav2_8", rv = "_go_1lav2_15", sv = "_name_1lav2_16", lv = "_empty_1lav2_17", cv = "_star_1lav2_18", iv = "_clear_1lav2_27", at = {
  card: tv,
  n: nv,
  list: av,
  row: ov,
  go: rv,
  name: sv,
  empty: lv,
  star: cv,
  clear: iv
};
function c3({
  mine: e,
  recent: n,
  onOpen: a,
  onClearRecent: o,
  mineHint: r = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: s = ""
}) {
  const [l, i] = B("mine"), c = l === "mine" ? e : n;
  return /* @__PURE__ */ t.createElement(
    fr,
    {
      flush: !0,
      className: [at.card, s].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(
        _r,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (m) => i(m),
          items: [
            { key: "mine", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ t.createElement("em", { className: at.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "최근 사용", n.length > 0 && /* @__PURE__ */ t.createElement("em", { className: at.n }, n.length)) }
          ]
        }
      ),
      trailing: l === "recent" && n.length > 0 && o ? /* @__PURE__ */ t.createElement(Ha, { className: at.clear, onClick: o }, "지우기") : void 0
    },
    c.length > 0 ? /* @__PURE__ */ t.createElement("ul", { className: at.list }, c.map((m) => /* @__PURE__ */ t.createElement("li", { key: m.path }, /* @__PURE__ */ t.createElement("button", { type: "button", className: at.row, onClick: () => a(m) }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: at.go }, "↗"), /* @__PURE__ */ t.createElement("span", { className: at.name }, m.label))))) : /* @__PURE__ */ t.createElement("div", { className: at.empty }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: at.star }, "★"), /* @__PURE__ */ t.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ t.createElement("p", null, l === "mine" ? r : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function qo(e) {
  var n;
  try {
    const a = JSON.parse((n = window.localStorage.getItem(e)) != null ? n : "[]");
    return Array.isArray(a) ? a.filter((o) => o && typeof o.path == "string" && typeof o.label == "string") : [];
  } catch {
    return [];
  }
}
function Na(e, n) {
  try {
    window.localStorage.setItem(e, JSON.stringify(n));
  } catch {
  }
}
function i3({ mineKey: e, recentKey: n, recentMax: a = 6 }) {
  const [o, r] = B(() => qo(e)), [s, l] = B(() => qo(n)), i = se((d) => o.some((f) => f.path === d), [o]), c = se((d) => r((f) => {
    const p = f.some((y) => y.path === d.path) ? f.filter((y) => y.path !== d.path) : [...f, d];
    return Na(e, p), p;
  }), [e]), m = se((d) => l((f) => {
    const p = [d, ...f.filter((y) => y.path !== d.path)].slice(0, a);
    return Na(n, p), p;
  }), [n, a]), u = se(() => {
    l([]), Na(n, []);
  }, [n]);
  return { mine: o, recent: s, isMine: i, toggleMine: c, remember: m, clearRecent: u };
}
const uv = "_banner_7tqhk_2", mv = "_heading_7tqhk_7", dv = "_sparkleBox_7tqhk_8", _v = "_eyebrow_7tqhk_12", pv = "_headline_7tqhk_13", fv = "_desc_7tqhk_15", yv = "_err_7tqhk_16", bv = "_chips_7tqhk_18", hv = "_footer_7tqhk_28", gv = "_kicker_7tqhk_35", Ev = "_list_7tqhk_36", vv = "_row_7tqhk_37", kv = "_icon_7tqhk_39", wv = "_text_7tqhk_40", Nv = "_cap_7tqhk_41", $v = "_body_7tqhk_43", xv = "_reason_7tqhk_44", Dv = "_empty_7tqhk_45", he = {
  banner: uv,
  heading: mv,
  sparkleBox: dv,
  eyebrow: _v,
  headline: pv,
  desc: fv,
  err: yv,
  chips: bv,
  footer: hv,
  kicker: gv,
  list: Ev,
  row: vv,
  icon: kv,
  text: wv,
  cap: Nv,
  body: $v,
  reason: xv,
  empty: Dv
};
function Fo({ size: e = 18 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function u3({
  eyebrow: e,
  headline: n,
  desc: a,
  error: o,
  groups: r,
  maxChips: s = 4,
  onOpen: l,
  note: i,
  noteError: c,
  allLabel: m = "전체 업무 제안 보기",
  allDisabled: u,
  className: d = ""
}) {
  const f = r.slice(0, s), p = r.length - f.length;
  return /* @__PURE__ */ t.createElement("section", { className: [he.banner, d].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: he.heading }, /* @__PURE__ */ t.createElement("span", { className: he.sparkleBox }, /* @__PURE__ */ t.createElement(Fo, { size: 22 })), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: he.eyebrow }, /* @__PURE__ */ t.createElement(Fo, { size: 11 }), " ", e), /* @__PURE__ */ t.createElement("h2", { className: he.headline }, n), a ? /* @__PURE__ */ t.createElement("p", { className: [he.desc, o ? he.err : ""].filter(Boolean).join(" ") }, a) : null)), r.length > 0 && /* @__PURE__ */ t.createElement("div", { className: he.chips }, f.map((y) => /* @__PURE__ */ t.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ t.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ t.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), p > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ t.createElement("div", { className: he.footer }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: c ? he.err : void 0,
      role: c ? "alert" : void 0
    },
    i
  ), /* @__PURE__ */ t.createElement(Ha, { onClick: () => l(null), disabled: u }, m, " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Cv({ items: e, onRun: n, onSkip: a, busy: o, emptyText: r = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: he.empty }, r) : /* @__PURE__ */ t.createElement("ul", { className: he.list }, e.map((s) => {
    var l, i;
    return /* @__PURE__ */ t.createElement("li", { key: s.id, className: he.row }, /* @__PURE__ */ t.createElement("span", { className: he.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ t.createElement("div", { className: he.text }, /* @__PURE__ */ t.createElement("div", { className: he.cap }, s.title, s.meta ? /* @__PURE__ */ t.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ t.createElement("div", { className: he.body }, s.body), s.reason ? /* @__PURE__ */ t.createElement("div", { className: he.reason }, s.reason) : null), /* @__PURE__ */ t.createElement(hn, { variant: "primary", disabled: o, onClick: () => n(s) }, (i = s.actionLabel) != null ? i : "실행"), /* @__PURE__ */ t.createElement(hn, { disabled: o, onClick: () => a(s) }, "무시"));
  }));
}
function m3({ title: e, kicker: n = "ProActive AI 업무 제안", items: a, onClose: o, onRun: r, onSkip: s }) {
  const l = F(!1), [i, c] = B(!1), [m, u] = B(""), d = async (f) => {
    if (!l.current) {
      l.current = !0, c(!0), u("");
      try {
        await f();
      } catch (p) {
        u(p instanceof Error ? p.message : "처리에 실패했습니다");
      } finally {
        l.current = !1, c(!1);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(
    Ya,
    {
      title: e,
      onClose: o,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ t.createElement("span", { className: he.kicker }, "✦ ", n),
      error: m,
      footer: /* @__PURE__ */ t.createElement(hn, { onClick: o }, "닫기")
    },
    /* @__PURE__ */ t.createElement(Cv, { items: a, busy: i, onRun: (f) => d(() => r(f)), onSkip: (f) => d(() => s(f)) })
  );
}
const Av = "_wrap_1wvdc_2", Sv = "_header_1wvdc_7", Bv = "_iconBox_1wvdc_8", jv = "_headText_1wvdc_12", Mv = "_eyebrow_1wvdc_13", Tv = "_headline_1wvdc_14", Lv = "_headerExtra_1wvdc_16", Iv = "_grid_1wvdc_19", qv = "_card_1wvdc_20", Fv = "_badge_1wvdc_29", Rv = "_toneRed_1wvdc_33", Pv = "_toneViolet_1wvdc_34", Xv = "_toneGreen_1wvdc_35", Ov = "_toneBlue_1wvdc_36", zv = "_title_1wvdc_38", Wv = "_summary_1wvdc_42", Kv = "_action_1wvdc_46", Hv = "_notice_1wvdc_53", Uv = "_err_1wvdc_56", fe = {
  wrap: Av,
  header: Sv,
  iconBox: Bv,
  headText: jv,
  eyebrow: Mv,
  headline: Tv,
  headerExtra: Lv,
  grid: Iv,
  card: qv,
  badge: Fv,
  toneRed: Rv,
  toneViolet: Pv,
  toneGreen: Xv,
  toneBlue: Ov,
  title: zv,
  summary: Wv,
  action: Kv,
  notice: Hv,
  err: Uv
};
function Ro({ size: e = 16 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const Gv = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function d3({
  items: e,
  onOpen: n,
  eyebrow: a = "PROACTIVE AI",
  headline: o = "지금 처리할 수 있는 업무를 발견했습니다",
  error: r,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: i,
  className: c = ""
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [fe.wrap, c].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: fe.header }, /* @__PURE__ */ t.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ t.createElement(Ro, { size: 18 })), /* @__PURE__ */ t.createElement("div", { className: fe.headText }, /* @__PURE__ */ t.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ t.createElement("h2", { className: fe.headline }, o)), i ? /* @__PURE__ */ t.createElement("div", { className: fe.headerExtra }, i) : null), r ? /* @__PURE__ */ t.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, r) : null, e.length === 0 ? r ? null : s ? /* @__PURE__ */ t.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ t.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ t.createElement("div", { className: fe.grid }, e.map((m) => {
    var u, d;
    return /* @__PURE__ */ t.createElement("button", { type: "button", key: m.id, className: fe.card, onClick: () => n(m) }, /* @__PURE__ */ t.createElement("span", { className: [fe.badge, Gv[(u = m.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ t.createElement(Ro, { size: 9 }), m.badge), /* @__PURE__ */ t.createElement("span", { className: fe.title }, m.title), m.summary ? /* @__PURE__ */ t.createElement("span", { className: fe.summary, title: typeof m.summary == "string" ? m.summary : void 0 }, m.summary) : null, /* @__PURE__ */ t.createElement("span", { className: fe.action }, (d = m.actionLabel) != null ? d : "상세 보기", " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const Yv = "_screen_1bsma_1", Vv = "_shell_1bsma_8", Jv = "_command_1bsma_10", Qv = "_body_1bsma_20", Zv = "_overview_1bsma_22", e0 = "_areaHead_1bsma_25", fn = {
  screen: Yv,
  shell: Vv,
  command: Jv,
  body: Qv,
  overview: Zv,
  areaHead: e0
};
function _3({ search: e, panel: n, children: a, className: o = "" }) {
  var r;
  return /* @__PURE__ */ t.createElement("main", { className: [fn.screen, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: fn.shell }, e && /* @__PURE__ */ t.createElement("div", { className: fn.command }, /* @__PURE__ */ t.createElement(
    Uu,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (r = e.hint) != null ? r : /* @__PURE__ */ t.createElement("kbd", null, "F10")
    }
  ), n), /* @__PURE__ */ t.createElement("div", { className: fn.body }, a)));
}
function p3({ children: e, className: n = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: [fn.overview, n].filter(Boolean).join(" ") }, e);
}
function f3({ title: e, hint: n }) {
  return /* @__PURE__ */ t.createElement("div", { className: fn.areaHead }, /* @__PURE__ */ t.createElement("h2", null, e), n && /* @__PURE__ */ t.createElement("span", null, n));
}
const t0 = "_group_oodts_1", n0 = "_grid_oodts_7", a0 = "_row_oodts_8", o0 = "_item_oodts_9", r0 = "_launch_oodts_14", s0 = "_name_oodts_17", l0 = "_desc_oodts_18", c0 = "_badge_oodts_19", i0 = "_disabled_oodts_23", u0 = "_tab_oodts_25", m0 = "_star_oodts_25", d0 = "_on_oodts_30", _0 = "_empty_oodts_32", Fe = {
  group: t0,
  grid: n0,
  row: a0,
  item: o0,
  launch: r0,
  name: s0,
  desc: l0,
  badge: c0,
  disabled: i0,
  tab: u0,
  star: m0,
  on: d0,
  empty: _0
};
function p0() {
  return /* @__PURE__ */ t.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function f0() {
  return /* @__PURE__ */ t.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function y3({ title: e, items: n, emptyText: a, className: o = "" }) {
  return /* @__PURE__ */ t.createElement("section", { className: [Fe.group, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), /* @__PURE__ */ t.createElement("div", { className: Fe.grid }, n.map((r) => /* @__PURE__ */ t.createElement("div", { className: Fe.row, key: r.key }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Fe.item, r.disabled ? Fe.disabled : ""].filter(Boolean).join(" "),
      disabled: r.disabled,
      onClick: r.onOpen
    },
    /* @__PURE__ */ t.createElement("span", { className: Fe.launch }, /* @__PURE__ */ t.createElement(p0, null)),
    /* @__PURE__ */ t.createElement("span", { className: Fe.name }, r.label),
    r.desc && /* @__PURE__ */ t.createElement("span", { className: Fe.desc }, r.desc),
    r.badge != null && /* @__PURE__ */ t.createElement("em", { className: Fe.badge }, r.badge)
  ), r.onOpenNewTab && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Fe.tab,
      "aria-label": `${r.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: r.onOpenNewTab
    },
    /* @__PURE__ */ t.createElement(f0, null)
  ), r.onToggleStar && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Fe.star, r.starred ? Fe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!r.starred,
      "aria-label": `${r.label} ${r.starred ? "마이메뉴에서 빼기" : "마이메뉴에 담기"}`,
      onClick: r.onToggleStar
    },
    r.starred ? "★" : "☆"
  ))), n.length === 0 && a != null && /* @__PURE__ */ t.createElement("p", { className: Fe.empty }, a)));
}
const y0 = "_strip_8zhai_2", b0 = "_day_8zhai_9", h0 = "_total_8zhai_10", g0 = "_sel_8zhai_31", E0 = "_today_8zhai_35", v0 = "_md_8zhai_35", k0 = "_off_8zhai_36", w0 = "_head_8zhai_45", N0 = "_wd_8zhai_46", $0 = "_sun_8zhai_47", x0 = "_sat_8zhai_48", D0 = "_lock_8zhai_50", C0 = "_value_8zhai_60", A0 = "_mark_8zhai_66", S0 = "_warn_8zhai_67", B0 = "_danger_8zhai_68", j0 = "_info_8zhai_69", Ne = {
  strip: y0,
  day: b0,
  total: h0,
  sel: g0,
  today: E0,
  md: v0,
  off: k0,
  head: w0,
  wd: N0,
  sun: $0,
  sat: x0,
  lock: D0,
  value: C0,
  mark: A0,
  warn: S0,
  danger: B0,
  info: j0
}, Po = ["일", "월", "화", "수", "목", "금", "토"];
function M0(e) {
  const [n, a, o] = e.split("-").map(Number), r = new Date(n, a - 1, o).getDay();
  return { md: `${a}/${o}`, wd: r };
}
function b3({
  days: e,
  selected: n,
  today: a,
  onSelect: o,
  total: r,
  totalLabel: s = "합계",
  "aria-label": l,
  className: i
}) {
  const c = F([]), m = (f) => {
    var y;
    const p = e.length;
    for (let _ = 0; _ < p; _++) {
      const b = (f + _ + p) % p;
      if (!e[b].disabled) {
        (y = c.current[b]) == null || y.focus();
        return;
      }
    }
  }, u = (f, p) => {
    f.key === "ArrowRight" ? (f.preventDefault(), m(p + 1)) : f.key === "ArrowLeft" ? (f.preventDefault(), m(p - 1)) : f.key === "Home" ? (f.preventDefault(), m(0)) : f.key === "End" && (f.preventDefault(), m(e.length - 1));
  }, d = Math.max(0, e.findIndex((f) => f.date === n));
  return /* @__PURE__ */ t.createElement("div", { className: `${Ne.strip}${i ? ` ${i}` : ""}`, role: "group", "aria-label": l }, e.map((f, p) => {
    var E, k, D, h;
    const { md: y, wd: _ } = M0(f.date), b = [
      Ne.day,
      f.off ? Ne.off : "",
      f.date === n ? Ne.sel : "",
      f.date === a ? Ne.today : "",
      _ === 0 ? Ne.sun : _ === 6 ? Ne.sat : ""
    ].filter(Boolean).join(" "), $ = [`${y}(${Po[_]})`, f.offLabel, f.locked ? "잠김" : null, (E = f.mark) == null ? void 0 : E.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: f.date,
        ref: (w) => {
          c.current[p] = w;
        },
        type: "button",
        className: b,
        disabled: f.disabled,
        tabIndex: p === d ? 0 : -1,
        "aria-pressed": f.date === n,
        "aria-label": $,
        title: $,
        onClick: () => o == null ? void 0 : o(f.date),
        onKeyDown: (w) => u(w, p)
      },
      /* @__PURE__ */ t.createElement("span", { className: Ne.head }, /* @__PURE__ */ t.createElement("span", { className: Ne.wd }, Po[_]), /* @__PURE__ */ t.createElement("span", { className: Ne.md }, y), f.locked && /* @__PURE__ */ t.createElement("span", { className: Ne.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ t.createElement("span", { className: Ne.value }, f.value),
      /* @__PURE__ */ t.createElement("span", { className: `${Ne.mark}${f.mark ? ` ${Ne[f.mark.tone]}` : ""}` }, (h = (k = f.mark) == null ? void 0 : k.text) != null ? h : f.off && (D = f.offLabel) != null ? D : "")
    );
  }), r !== void 0 && /* @__PURE__ */ t.createElement("div", { className: Ne.total }, /* @__PURE__ */ t.createElement("span", { className: Ne.wd }, s), /* @__PURE__ */ t.createElement("span", { className: Ne.value }, r)));
}
const T0 = "_stepper_1wbt2_1", L0 = "_nav_1wbt2_2", I0 = "_today_1wbt2_3", q0 = "_range_1wbt2_14", Mn = {
  stepper: T0,
  nav: L0,
  today: I0,
  range: q0
};
function Tr(e) {
  const [n, a, o] = e.split("-").map(Number);
  return new Date(Date.UTC(n, a - 1, o));
}
function Lr(e) {
  return e.toISOString().slice(0, 10);
}
function F0(e) {
  const n = e.getUTCDay();
  return n === 0 ? 7 : n;
}
function R0(e, n = 1) {
  const a = Tr(e), o = (F0(a) - n + 7) % 7;
  return a.setUTCDate(a.getUTCDate() - o), Lr(a);
}
function $a(e, n) {
  const a = Tr(e);
  return a.setUTCDate(a.getUTCDate() + n), Lr(a);
}
function h3({ value: e, onChange: n, weekStart: a = 1, today: o, disabled: r, label: s = "주" }) {
  const l = $a(e, 6), i = R0(o, a), c = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ t.createElement("span", { className: Mn.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Mn.nav,
      onClick: () => n($a(e, -7)),
      disabled: r,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ t.createElement("span", { className: Mn.range, "aria-live": "polite" }, e, " ~ ", c), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Mn.nav,
      onClick: () => n($a(e, 7)),
      disabled: r,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Mn.today,
      onClick: () => n(i),
      disabled: r || e === i
    },
    "이번 주"
  ));
}
const P0 = "_wrap_1dtpy_1", X0 = "_svg_1dtpy_2", O0 = "_grid_1dtpy_3", z0 = "_axis_1dtpy_4", W0 = "_accent_1dtpy_5", K0 = "_muted_1dtpy_6", H0 = "_ok_1dtpy_7", U0 = "_warn_1dtpy_8", G0 = "_danger_1dtpy_9", Y0 = "_legend_1dtpy_10", V0 = "_dot_accent_1dtpy_13", J0 = "_dot_muted_1dtpy_14", Q0 = "_dot_ok_1dtpy_15", Z0 = "_dot_warn_1dtpy_16", ek = "_dot_danger_1dtpy_17", jt = {
  wrap: P0,
  svg: X0,
  grid: O0,
  axis: z0,
  accent: W0,
  muted: K0,
  ok: H0,
  warn: U0,
  danger: G0,
  legend: Y0,
  dot_accent: V0,
  dot_muted: J0,
  dot_ok: Q0,
  dot_warn: Z0,
  dot_danger: ek
}, tk = 600;
function nk(e) {
  if (e <= 0) return 1;
  const n = Math.pow(10, Math.floor(Math.log10(e))), a = e / n;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * n;
}
const Xo = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function g3({ categories: e, series: n, unit: a = "", height: o = 180, label: r, labelEvery: s }) {
  const l = F(null), [i, c] = B(tk);
  Ke(() => {
    const v = l.current;
    if (!v) return;
    const C = () => {
      const A = v.clientWidth;
      A > 0 && c((N) => N === A ? N : A);
    };
    if (C(), typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver(C);
    return x.observe(v), () => x.disconnect();
  }, []);
  const m = o, u = 40, d = 22, f = 8, p = i - u - 4, y = m - d - f, _ = n.flatMap((v) => v.values.filter((C) => C != null)), b = nk(Math.max(0, ..._)), $ = Math.max(e.length, 1), E = p / $, k = Math.min(8, E * 0.2), D = Math.max(1, (E - k) / Math.max(n.length, 1)), h = s != null ? s : Math.max(1, Math.ceil($ / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ t.createElement("div", { className: jt.wrap, ref: l }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: jt.svg,
      viewBox: `0 0 ${i} ${m}`,
      role: "img",
      "aria-label": r,
      style: { height: o }
    },
    w.map((v) => {
      const C = f + y - v / b * y;
      return /* @__PURE__ */ t.createElement("g", { key: v }, /* @__PURE__ */ t.createElement("line", { className: jt.grid, x1: u, x2: i - 4, y1: C, y2: C }), /* @__PURE__ */ t.createElement("text", { className: jt.axis, x: u - 4, y: C + 3, textAnchor: "end" }, Xo(v)));
    }),
    e.map((v, C) => /* @__PURE__ */ t.createElement("g", { key: v }, n.map((x, A) => {
      var S;
      const N = x.values[C];
      if (N == null || N <= 0) return null;
      const L = N / b * y;
      return /* @__PURE__ */ t.createElement(
        "rect",
        {
          key: x.key,
          className: jt[(S = x.tone) != null ? S : "accent"],
          x: u + C * E + k / 2 + A * D,
          y: f + y - L,
          width: D,
          height: L
        },
        /* @__PURE__ */ t.createElement("title", null, `${v} · ${x.label} ${Xo(N)}${a}`)
      );
    }), C % h === 0 && /* @__PURE__ */ t.createElement("text", { className: jt.axis, x: u + C * E + E / 2, y: m - 6, textAnchor: "middle" }, v)))
  ), /* @__PURE__ */ t.createElement("ul", { className: jt.legend }, n.map((v) => {
    var C;
    return /* @__PURE__ */ t.createElement("li", { key: v.key }, /* @__PURE__ */ t.createElement("i", { className: jt[`dot_${(C = v.tone) != null ? C : "accent"}`], "aria-hidden": "true" }), v.label, a ? ` (${a})` : "");
  })));
}
const ak = "_wrap_85lir_1", ok = "_track_85lir_2", rk = "_accent_85lir_3", sk = "_muted_85lir_3", lk = "_ok_85lir_3", ck = "_warn_85lir_3", ik = "_danger_85lir_3", uk = "_center_85lir_9", mk = "_legend_85lir_10", dk = "_name_85lir_13", _k = "_val_85lir_14", pk = "_pct_85lir_15", fk = "_dot_accent_85lir_16", yk = "_dot_muted_85lir_17", bk = "_dot_ok_85lir_18", hk = "_dot_warn_85lir_19", gk = "_dot_danger_85lir_20", ht = {
  wrap: ak,
  track: ok,
  accent: rk,
  muted: sk,
  ok: lk,
  warn: ck,
  danger: ik,
  center: uk,
  legend: mk,
  name: dk,
  val: _k,
  pct: pk,
  dot_accent: fk,
  dot_muted: yk,
  dot_ok: bk,
  dot_warn: hk,
  dot_danger: gk
}, qa = 40, Oo = 2 * Math.PI * qa;
function E3({ items: e, center: n, size: a = 120, label: o, emptyText: r = "자료 없음", unit: s = "" }) {
  const l = e.reduce((c, m) => c + Math.max(0, m.value), 0);
  let i = 0;
  return /* @__PURE__ */ t.createElement("div", { className: ht.wrap }, /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": o }, /* @__PURE__ */ t.createElement("circle", { className: ht.track, cx: "50", cy: "50", r: qa }), l > 0 && e.map((c) => {
    var d;
    const m = Math.max(0, c.value) / l * Oo, u = i;
    return i += m, m <= 0 ? null : /* @__PURE__ */ t.createElement(
      "circle",
      {
        key: c.key,
        className: ht[(d = c.tone) != null ? d : "accent"],
        cx: "50",
        cy: "50",
        r: qa,
        strokeDasharray: `${m} ${Oo - m}`,
        strokeDashoffset: -u,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ t.createElement("title", null, `${c.label} ${c.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ t.createElement("text", { className: ht.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? n != null ? n : l.toLocaleString("ko-KR") : r)), /* @__PURE__ */ t.createElement("ul", { className: ht.legend }, e.map((c) => {
    var m;
    return /* @__PURE__ */ t.createElement("li", { key: c.key }, /* @__PURE__ */ t.createElement("i", { className: ht[`dot_${(m = c.tone) != null ? m : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ t.createElement("span", { className: ht.name }, c.label), /* @__PURE__ */ t.createElement("span", { className: ht.val }, c.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ t.createElement("span", { className: ht.pct }, l > 0 ? `${Math.round(c.value / l * 100)}%` : "-"));
  })));
}
const Ek = "_wrap_1b8ll_1", vk = "_track_1b8ll_2", kk = "_compact_1b8ll_3", wk = "_fill_1b8ll_4", Nk = "_accent_1b8ll_5", $k = "_muted_1b8ll_6", xk = "_ok_1b8ll_7", Dk = "_warn_1b8ll_8", Ck = "_danger_1b8ll_9", Ak = "_num_1b8ll_10", Sk = "_none_1b8ll_12", zt = {
  wrap: Ek,
  track: vk,
  compact: kk,
  fill: wk,
  accent: Nk,
  muted: $k,
  ok: xk,
  warn: Dk,
  danger: Ck,
  num: Ak,
  none: Sk
};
function v3({ value: e, label: n, tone: a = "accent", compact: o }) {
  if (e == null)
    return /* @__PURE__ */ t.createElement("span", { className: zt.none, "aria-label": `${n} 해당 없음` }, "-");
  const r = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: [zt.wrap, o ? zt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": n,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": r
    },
    /* @__PURE__ */ t.createElement("span", { className: zt.track }, /* @__PURE__ */ t.createElement("span", { className: `${zt.fill} ${zt[a]}`, style: { width: `${r}%` } })),
    /* @__PURE__ */ t.createElement("span", { className: zt.num }, r, "%")
  );
}
const Bk = { day: 28, week: 10, month: 3 }, Va = 864e5;
function Lt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / Va);
}
function jk(e) {
  const n = new Date(e * Va);
  return `${n.getUTCFullYear()}-${String(n.getUTCMonth() + 1).padStart(2, "0")}-${String(n.getUTCDate()).padStart(2, "0")}`;
}
function Vt(e, n) {
  return jk(Lt(e) + n);
}
function Fa(e, n) {
  return Lt(n) - Lt(e) + 1;
}
function Ir(e) {
  return new Date(Lt(e) * Va).getUTCDay();
}
const zo = (e) => {
  const n = Ir(e);
  return n === 0 || n === 6;
};
function pn(e, n, a, o) {
  const r = [], s = Fa(e, n);
  for (let l = 0; l < s; l++) {
    const i = Vt(e, l), c = a(i), m = r[r.length - 1];
    m && m.key === c ? m.days++ : r.push({ key: c, label: o(i), offset: l, days: 1 });
  }
  return r;
}
function Mk(e, n, a) {
  const o = (s) => s.slice(0, 7), r = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: pn(e, n, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: pn(e, n, o, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Vt(l, -((Ir(l) + 6) % 7));
    return {
      top: pn(e, n, o, r),
      bottom: pn(e, n, s, (l) => {
        const i = s(l);
        return `${Number(i.slice(5, 7))}/${Number(i.slice(8, 10))}`;
      })
    };
  }
  return {
    top: pn(e, n, o, r),
    bottom: pn(e, n, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function xa(e, n, a, o) {
  if (a === "move") return { start: Vt(e, o), end: Vt(n, o) };
  if (a === "start") {
    const s = Vt(e, o);
    return { start: s > n ? n : s, end: n };
  }
  const r = Vt(n, o);
  return { start: e, end: r < e ? e : r };
}
const Tk = "_gantt_1smka_3", Lk = "_scroll_1smka_15", Ik = "_canvas_1smka_21", qk = "_head_1smka_24", Fk = "_headLabel_1smka_32", Rk = "_headTrack_1smka_43", Pk = "_band_1smka_44", Xk = "_seg_1smka_46", Ok = "_tick_1smka_59", zk = "_tickOff_1smka_60", Wk = "_body_1smka_62", Kk = "_overlay_1smka_65", Hk = "_weekend_1smka_66", Uk = "_holiday_1smka_66", Gk = "_today_1smka_68", Yk = "_row_1smka_70", Vk = "_label_1smka_76", Jk = "_sel_1smka_77", Qk = "_track_1smka_77", Zk = "_dim_1smka_78", ew = "_labelText_1smka_95", tw = "_dot_1smka_96", nw = "_warn_1smka_97", aw = "_err_1smka_98", ow = "_bar_1smka_113", rw = "_can_1smka_21", sw = "_dragging_1smka_126", lw = "_fill_1smka_127", cw = "_late_1smka_128", iw = "_summary_1smka_130", uw = "_handle_1smka_133", mw = "_hL_1smka_134", dw = "_hR_1smka_135", _w = "_mark_1smka_137", pw = "_barText_1smka_138", fw = "_empty_1smka_147", yw = "_srOnly_1smka_150", Z = {
  gantt: Tk,
  scroll: Lk,
  canvas: Ik,
  head: qk,
  headLabel: Fk,
  headTrack: Rk,
  band: Pk,
  seg: Xk,
  tick: Ok,
  tickOff: zk,
  body: Wk,
  overlay: Kk,
  weekend: Hk,
  holiday: Uk,
  today: Gk,
  row: Yk,
  label: Vk,
  sel: Jk,
  track: Qk,
  dim: Zk,
  labelText: ew,
  dot: tw,
  warn: nw,
  err: aw,
  bar: ow,
  can: rw,
  dragging: sw,
  fill: lw,
  late: cw,
  summary: iw,
  handle: uw,
  hL: mw,
  hR: dw,
  mark: _w,
  barText: pw,
  empty: fw,
  srOnly: yw
}, Wo = 28, Ko = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let bw = 0;
function k3({
  rows: e,
  from: n,
  to: a,
  scale: o = "day",
  holidays: r = {},
  today: s,
  scrollToToday: l = !0,
  onChange: i,
  onRowClick: c,
  selectedId: m,
  labelWidth: u = 280,
  labelHeader: d,
  lockedReason: f,
  scrollMemory: p,
  className: y = "",
  style: _,
  "aria-label": b
}) {
  const $ = F("");
  $.current || ($.current = `axe-gantt-keys-${++bw}`);
  const E = Bk[o], k = Math.max(Fa(n, a), 1), D = Lt(n), h = k * E, w = xe(() => Mk(n, a, o), [n, a, o]), v = xe(() => {
    const g = [];
    for (let X = 0; X < k; X++) {
      const Y = Vt(n, X), V = Y in r;
      if (!V && !zo(Y)) continue;
      const T = g[g.length - 1];
      T && T.offset + T.days === X && T.holiday === V ? T.days++ : g.push({ offset: X, days: 1, holiday: V });
    }
    return g;
  }, [n, k, r]), [C, x] = B(null), A = F(null), N = (g) => !!i && !g.locked && !g.summary && !!g.start && !!g.end, L = (g, X, Y) => {
    if (!N(X) || g.button !== 0) return;
    g.stopPropagation(), g.currentTarget.setPointerCapture(g.pointerId);
    const V = { id: X.id, mode: Y, x: g.clientX, delta: 0, moved: !1 };
    A.current = V, x(V);
  }, S = (g) => {
    const X = A.current;
    if (!X) return;
    const Y = Math.round((g.clientX - X.x) / E), V = X.moved || Math.abs(g.clientX - X.x) > 3;
    if (Y !== X.delta || V !== X.moved) {
      const T = { ...X, delta: Y, moved: V };
      A.current = T, x(T);
    }
  }, P = (g) => {
    const X = A.current;
    if (A.current = null, x(null), !!X) {
      if (!X.moved) {
        c == null || c(g);
        return;
      }
      X.delta !== 0 && g.start && g.end && (i == null || i(g, xa(g.start, g.end, X.mode, X.delta), X.mode));
    }
  }, W = () => {
    A.current = null, x(null);
  }, q = (g, X) => {
    if (g.key === "Escape" && A.current) {
      W();
      return;
    }
    if (g.key === "Enter") {
      c == null || c(X);
      return;
    }
    if (!N(X) || g.key !== "ArrowLeft" && g.key !== "ArrowRight") return;
    g.preventDefault();
    const Y = g.key === "ArrowLeft" ? -1 : 1, V = g.shiftKey ? "end" : g.altKey ? "start" : "move";
    i == null || i(X, xa(X.start, X.end, V, Y), V);
  }, R = s ? Lt(s) - D : -1, oe = F(null), ne = F(null);
  return Ke(() => {
    const g = oe.current;
    if (g && (p != null && p.current) && ne.current === null) {
      ne.current = o, g.scrollLeft = p.current.left, g.scrollTop = p.current.top;
      return;
    }
    if (!l || !g || R < 0 || R >= k || ne.current === o) return;
    ne.current = o;
    const X = Math.max(g.clientWidth - u, 0);
    g.scrollLeft = Math.max(0, R * E + E / 2 - X / 3);
  }, [l, o, R, k, E, u]), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Z.gantt, y].filter(Boolean).join(" "),
      style: _,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (g) => {
        g.key === "Escape" && A.current && W();
      }
    },
    /* @__PURE__ */ t.createElement("span", { id: $.current, className: Z.srOnly }, Ko),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: oe,
        className: Z.scroll,
        onScroll: p ? (g) => {
          p.current = { left: g.currentTarget.scrollLeft, top: g.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ t.createElement("div", { className: Z.canvas, style: { width: u + h } }, /* @__PURE__ */ t.createElement("div", { className: Z.head, style: { gridTemplateColumns: `${u}px ${h}px` } }, /* @__PURE__ */ t.createElement("div", { className: Z.headLabel }, d), /* @__PURE__ */ t.createElement("div", { className: Z.headTrack }, /* @__PURE__ */ t.createElement("div", { className: Z.band }, w.top.map((g) => /* @__PURE__ */ t.createElement("span", { key: g.key, className: Z.seg, style: { left: g.offset * E, width: g.days * E }, title: g.label }, g.label))), /* @__PURE__ */ t.createElement("div", { className: Z.band }, w.bottom.map((g) => {
        var Y;
        const X = o === "day" && (g.key in r || zo(g.key));
        return /* @__PURE__ */ t.createElement(
          "span",
          {
            key: g.key,
            className: [Z.seg, Z.tick, X ? Z.tickOff : ""].filter(Boolean).join(" "),
            style: { left: g.offset * E, width: g.days * E },
            title: (Y = r[g.key]) != null ? Y : g.key
          },
          g.days * E >= 16 ? g.label : ""
        );
      })))), /* @__PURE__ */ t.createElement("div", { className: Z.body, style: { minHeight: Wo } }, /* @__PURE__ */ t.createElement("div", { className: Z.overlay, style: { left: u, width: h }, "aria-hidden": "true" }, v.map((g) => /* @__PURE__ */ t.createElement("span", { key: g.offset, className: g.holiday ? Z.holiday : Z.weekend, style: { left: g.offset * E, width: g.days * E } })), R >= 0 && R < k && /* @__PURE__ */ t.createElement("span", { className: Z.today, style: { left: R * E + E / 2 }, title: "오늘" })), e.map((g) => {
        var re, ct, en, xt;
        const X = !!g.start && !!g.end && g.start <= g.end, Y = C && C.id === g.id ? C : null, V = X && Y && Y.delta !== 0 ? xa(g.start, g.end, Y.mode, Y.delta) : X ? { start: g.start, end: g.end } : null, T = V ? (Lt(V.start) - D) * E : 0, U = V ? Fa(V.start, V.end) * E : 0, ee = Math.max(0, Math.min(100, (re = g.progress) != null ? re : 0)), ie = m != null && m === g.id, ue = N(g), K = !ue && i && V ? f == null ? void 0 : f(g) : void 0;
        return /* @__PURE__ */ t.createElement(
          "div",
          {
            key: g.id,
            className: [Z.row, ie ? Z.sel : "", g.dim ? Z.dim : ""].filter(Boolean).join(" "),
            style: { height: Wo }
          },
          /* @__PURE__ */ t.createElement(
            "div",
            {
              className: Z.label,
              style: { width: u },
              title: g.name,
              onClick: () => c == null ? void 0 : c(g)
            },
            /* @__PURE__ */ t.createElement("span", { className: Z.labelText }, g.label),
            g.marked && /* @__PURE__ */ t.createElement("span", { className: Z.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            g.warn && /* @__PURE__ */ t.createElement("span", { className: Z.warn, title: g.warn, "aria-label": g.warn }, "⚠"),
            g.error && /* @__PURE__ */ t.createElement("span", { className: Z.err, title: g.error, "aria-label": g.error }, "!")
          ),
          /* @__PURE__ */ t.createElement("div", { className: Z.track, style: { width: h }, onClick: () => !Y && (c == null ? void 0 : c(g)) }, V ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
            "div",
            {
              className: [Z.bar, g.summary ? Z.summary : "", g.late ? Z.late : "", ue ? Z.can : "", Y ? Z.dragging : ""].filter(Boolean).join(" "),
              style: { left: T, width: Math.max(U, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(ct = g.name) != null ? ct : ""} ${V.start} ~ ${V.end}${g.progress != null ? ` ${ee}%` : ""}${g.late ? " 지연" : ""}${K ? ` 잠김: ${K}` : ""}`,
              "aria-describedby": ue ? $.current : void 0,
              title: `${V.start} ~ ${V.end}${g.progress != null ? ` · ${ee}%` : ""}${g.late ? " · 지연" : ""}${ue ? `
끌어 옮기기·양 끝 조절
${Ko}` : ""}${K ? `
잠김: ${K}` : ""}`,
              onPointerDown: (_e) => L(_e, g, "move"),
              onPointerMove: S,
              onPointerUp: () => P(g),
              onPointerCancel: W,
              onClick: (_e) => _e.stopPropagation(),
              onKeyDown: (_e) => q(_e, g)
            },
            g.progress != null && /* @__PURE__ */ t.createElement("span", { className: Z.fill, style: { width: `${ee}%` } }),
            ue && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: `${Z.handle} ${Z.hL}`, onPointerDown: (_e) => L(_e, g, "start") }), /* @__PURE__ */ t.createElement("span", { className: `${Z.handle} ${Z.hR}`, onPointerDown: (_e) => L(_e, g, "end") }))
          ), g.markDate && g.markDate >= n && g.markDate <= a && /* @__PURE__ */ t.createElement("span", { className: Z.mark, style: { left: (Lt(g.markDate) - D + 1) * E - 1 }, title: (en = g.markLabel) != null ? en : g.markDate }), g.barText && /* @__PURE__ */ t.createElement("span", { className: Z.barText, style: { left: T + Math.max(U, 2) + 4 } }, g.barText)) : /* @__PURE__ */ t.createElement("span", { className: Z.empty }, (xt = g.emptyText) != null ? xt : "기간 없음"))
        );
      })))
    )
  );
}
const hw = "_board_192fl_3", gw = "_col_192fl_15", Ew = "_over_192fl_23", vw = "_head_192fl_25", kw = "_title_192fl_33", ww = "_count_192fl_34", Nw = "_hint_192fl_43", $w = "_list_192fl_45", xw = "_empty_192fl_54", Dw = "_card_192fl_56", Cw = "_sel_192fl_68", Aw = "_dragging_192fl_69", Sw = "_hasErr_192fl_70", Bw = "_dot_192fl_71", jw = "_err_192fl_72", Se = {
  board: hw,
  col: gw,
  over: Ew,
  head: vw,
  title: kw,
  count: ww,
  hint: Nw,
  list: $w,
  empty: xw,
  card: Dw,
  sel: Cw,
  dragging: Aw,
  hasErr: Sw,
  dot: Bw,
  err: jw
}, Da = "application/x-axerp-kanban";
function w3({
  columns: e,
  cards: n,
  cardKey: a,
  columnOf: o,
  renderCard: r,
  cardLabel: s,
  onMove: l,
  onCardClick: i,
  selectedKey: c,
  marked: m,
  error: u,
  lockedReason: d,
  emptyText: f = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: _,
  "aria-label": b
}) {
  const $ = Qt("axe-kb"), [E, k] = B(null), [D, h] = B(null), w = new Map(n.map((N) => [String(a(N)), N])), v = F(null), C = F(null);
  H(() => {
    var S, P;
    const N = C.current;
    if (!N) return;
    if (Date.now() > N.until) {
      C.current = null;
      return;
    }
    const L = Array.from((P = (S = v.current) == null ? void 0 : S.querySelectorAll("[data-kanban-key]")) != null ? P : []).find((W) => W.dataset.kanbanKey === N.key);
    L && document.activeElement !== L && L.focus(), C.current = null;
  });
  const x = (N, L) => {
    N.preventDefault(), k(null), h(null);
    const S = N.dataTransfer.getData(Da), P = w.get(S);
    P && o(P) !== L && (l == null || l(P, L));
  }, A = (N, L) => {
    if (N.key === "Enter" || N.key === " ") {
      N.preventDefault(), i == null || i(L);
      return;
    }
    if (!l || !N.altKey || N.key !== "ArrowLeft" && N.key !== "ArrowRight" || d != null && d(L)) return;
    N.preventDefault();
    const S = e.findIndex((W) => W.key === o(L)), P = S + (N.key === "ArrowLeft" ? -1 : 1);
    S >= 0 && P >= 0 && P < e.length && (C.current = { key: String(a(L)), until: Date.now() + 1500 }, l(L, e[P].key));
  };
  return /* @__PURE__ */ t.createElement("div", { ref: v, className: [Se.board, y].filter(Boolean).join(" "), style: _, role: "region", "aria-label": b != null ? b : "보드" }, e.map((N) => {
    const L = n.filter((S) => o(S) === N.key);
    return /* @__PURE__ */ t.createElement(
      "section",
      {
        key: N.key,
        className: [Se.col, E === N.key ? Se.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof N.title == "string" ? N.title : void 0,
        onDragOver: l ? (S) => {
          S.dataTransfer.types.includes(Da) && (S.preventDefault(), k(N.key));
        } : void 0,
        onDragLeave: l ? (S) => {
          S.currentTarget.contains(S.relatedTarget) || k((P) => P === N.key ? null : P);
        } : void 0,
        onDrop: l ? (S) => x(S, N.key) : void 0
      },
      /* @__PURE__ */ t.createElement("header", { className: Se.head }, /* @__PURE__ */ t.createElement("span", { className: Se.title }, N.title), /* @__PURE__ */ t.createElement("span", { className: Se.count }, L.length), N.hint && /* @__PURE__ */ t.createElement("span", { className: Se.hint }, N.hint)),
      /* @__PURE__ */ t.createElement("div", { className: Se.list }, L.length === 0 && /* @__PURE__ */ t.createElement("p", { className: Se.empty }, f), L.map((S) => {
        const P = a(S), W = d == null ? void 0 : d(S), q = u == null ? void 0 : u(S), R = !!l && !W, oe = W != null ? W : R ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ t.createElement(
          "article",
          {
            key: P,
            className: [Se.card, c === P ? Se.sel : "", D === P ? Se.dragging : "", q ? Se.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(P),
            role: "button",
            "aria-label": s == null ? void 0 : s(S),
            "aria-keyshortcuts": R ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: oe,
            "aria-describedby": oe ? `${$}-h-${String(P)}` : void 0,
            draggable: R,
            onDragStart: R ? (ne) => {
              ne.dataTransfer.setData(Da, String(P)), ne.dataTransfer.effectAllowed = "move", h(P);
            } : void 0,
            onDragEnd: () => {
              h(null), k(null);
            },
            onClick: () => i == null ? void 0 : i(S),
            onKeyDown: (ne) => A(ne, S)
          },
          oe && /* @__PURE__ */ t.createElement(yr, { id: `${$}-h-${String(P)}` }, oe),
          (m == null ? void 0 : m(S)) && /* @__PURE__ */ t.createElement("span", { className: Se.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          r(S),
          q && /* @__PURE__ */ t.createElement("p", { className: Se.err, role: "alert" }, q)
        );
      }))
    );
  }));
}
const Mw = "_list_1aqum_2", Tw = "_empty_1aqum_3", Lw = "_item_1aqum_5", Iw = "_row_block_1aqum_6", qw = "_row_warn_1aqum_7", Fw = "_head_1aqum_9", Rw = "_mark_1aqum_16", Pw = "_msg_1aqum_17", Xw = "_count_1aqum_18", Ow = "_aside_1aqum_19", zw = "_caret_1aqum_20", Ww = "_block_1aqum_22", Kw = "_warn_1aqum_23", Hw = "_info_1aqum_24", Uw = "_body_1aqum_29", Gw = "_actions_1aqum_30", Be = {
  list: Mw,
  empty: Tw,
  item: Lw,
  row_block: Iw,
  row_warn: qw,
  head: Fw,
  mark: Rw,
  msg: Pw,
  count: Xw,
  aside: Ow,
  caret: zw,
  block: Ww,
  warn: Kw,
  info: Hw,
  body: Uw,
  actions: Gw
}, Yw = { block: "■", warn: "▲", info: "●" }, Vw = { block: "차단", warn: "경고", info: "정보" };
function N3({ items: e, empty: n = "점검할 항목이 없습니다", openTones: a = ["block"], className: o = "" }) {
  const [r, s] = B({}), [l, i] = B(e);
  return l !== e && (i(e), s({})), e.length ? /* @__PURE__ */ t.createElement("ul", { className: `${Be.list} ${o}` }, e.map((c) => {
    var f;
    const m = !!c.detail || !!c.actions, u = m && ((f = r[c.key]) != null ? f : a.includes(c.tone)), d = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: `${Be.mark} ${Be[c.tone]}`, "aria-label": Vw[c.tone], role: "img" }, Yw[c.tone]), /* @__PURE__ */ t.createElement("span", { className: Be.msg }, c.message), !!c.count && /* @__PURE__ */ t.createElement("span", { className: `${Be.count} ${Be[c.tone]}` }, c.count.toLocaleString("ko-KR"), "건"), c.aside != null && /* @__PURE__ */ t.createElement("span", { className: Be.aside }, c.aside), m && /* @__PURE__ */ t.createElement("span", { className: Be.caret, "aria-hidden": "true" }, u ? "▾" : "▸"));
    return /* @__PURE__ */ t.createElement("li", { key: c.key, className: `${Be.item} ${Be[`row_${c.tone}`]}` }, m ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Be.head,
        "aria-expanded": u,
        onClick: () => s((p) => ({ ...p, [c.key]: !u }))
      },
      d
    ) : /* @__PURE__ */ t.createElement("div", { className: Be.head }, d), u && /* @__PURE__ */ t.createElement("div", { className: Be.body }, c.detail, c.actions && /* @__PURE__ */ t.createElement("div", { className: Be.actions }, c.actions)));
  })) : /* @__PURE__ */ t.createElement("p", { className: `${Be.empty} ${o}` }, n);
}
function Jw(e, n) {
  const a = Math.max(1, Math.floor(n) || 1), o = Math.min(a, Math.max(1, Math.floor(e) || 1)), r = (s, l) => Array.from({ length: l - s + 1 }, (i, c) => s + c);
  return a <= 10 ? r(1, a) : o <= 5 ? [...r(1, 7), "…", a] : o >= a - 4 ? [1, "…", ...r(a - 6, a)] : [1, "…", ...r(o - 2, o + 2), "…", a];
}
function Qw(e, n) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, n), Math.max(1, a)) : null;
}
function $3(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function x3(e, n) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, n)));
}
const Zw = "_nav_1r2z8_1", eN = "_list_1r2z8_3", tN = "_btn_1r2z8_4", nN = "_cur_1r2z8_13", aN = "_gap_1r2z8_15", oN = "_total_1r2z8_16", rN = "_jump_1r2z8_17", sN = "_go_1r2z8_20", lN = "_size_1r2z8_22", cN = "_more_1r2z8_24", iN = "_moreBtn_1r2z8_25", uN = "_moreN_1r2z8_29", ve = {
  nav: Zw,
  list: eN,
  btn: tN,
  cur: nN,
  gap: aN,
  total: oN,
  jump: rN,
  in: "_in_1r2z8_18",
  go: sN,
  size: lN,
  more: cN,
  moreBtn: iN,
  moreN: uN
};
function D3({ page: e, pageCount: n, onPageChange: a, jump: o = !1, pageSizes: r, pageSize: s, onPageSizeChange: l, total: i, className: c = "" }) {
  const m = Math.max(1, n), u = Math.min(m, Math.max(1, e)), [d, f] = B(String(u));
  H(() => f(String(u)), [u]);
  const p = (_) => {
    _ !== u && _ >= 1 && _ <= m && a(_);
  }, y = () => {
    const _ = Qw(d, m);
    if (_ === null) {
      f(String(u));
      return;
    }
    f(String(_)), p(_);
  };
  return /* @__PURE__ */ t.createElement("nav", { className: [ve.nav, c].filter(Boolean).join(" "), "aria-label": "페이지 이동" }, i !== void 0 && /* @__PURE__ */ t.createElement("span", { className: ve.total }, "총 ", i.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ t.createElement("ol", { className: ve.list }, /* @__PURE__ */ t.createElement("li", null, /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.btn, onClick: () => p(1), disabled: u === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ t.createElement("li", null, /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.btn, onClick: () => p(u - 1), disabled: u === 1, "aria-label": "이전 쪽" }, "‹")), Jw(u, m).map((_, b) => _ === "…" ? /* @__PURE__ */ t.createElement("li", { key: `e${b}`, className: ve.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ t.createElement("li", { key: _ }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [ve.btn, _ === u ? ve.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(_),
      "aria-current": _ === u ? "page" : void 0,
      "aria-label": `${_}쪽`
    },
    _
  ))), /* @__PURE__ */ t.createElement("li", null, /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.btn, onClick: () => p(u + 1), disabled: u === m, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ t.createElement("li", null, /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.btn, onClick: () => p(m), disabled: u === m, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ t.createElement("span", { className: ve.total }, "전체 ", m, "쪽"), o && /* @__PURE__ */ t.createElement("span", { className: ve.jump }, /* @__PURE__ */ t.createElement(
    "input",
    {
      className: ve.in,
      inputMode: "numeric",
      value: d,
      "aria-label": "이동할 쪽 번호",
      onChange: (_) => f(_.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (_) => {
        _.key === "Enter" && (_.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.go, onClick: y }, "이동")), r && s !== void 0 && l && /* @__PURE__ */ t.createElement("label", { className: ve.size }, "쪽당", /* @__PURE__ */ t.createElement("select", { value: s, onChange: (_) => l(Number(_.target.value)) }, r.map((_) => /* @__PURE__ */ t.createElement("option", { key: _, value: _ }, _, "건")))));
}
function C3({ shown: e, total: n, onMore: a, busy: o = !1, className: r = "" }) {
  return e >= n ? null : /* @__PURE__ */ t.createElement("div", { className: [ve.more, r].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("button", { type: "button", className: ve.moreBtn, onClick: a, disabled: o, "aria-busy": o }, "더보기 ", /* @__PURE__ */ t.createElement("span", { className: ve.moreN }, "(", e.toLocaleString("ko-KR"), "/", n.toLocaleString("ko-KR"), ")")));
}
const mN = "_ol_fbatg_1", dN = "_li_fbatg_2", _N = "_done_fbatg_5", pN = "_now_fbatg_5", fN = "_item_fbatg_6", yN = "_dot_fbatg_12", bN = "_label_fbatg_19", hN = "_opt_fbatg_21", gN = "_sr_fbatg_22", gt = {
  ol: mN,
  li: dN,
  done: _N,
  now: pN,
  item: fN,
  dot: yN,
  label: bN,
  opt: hN,
  sr: gN
};
function A3({ steps: e, current: n, onStepClick: a, className: o = "" }) {
  return /* @__PURE__ */ t.createElement("ol", { className: [gt.ol, o].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(n + 1, e.length)}단계` }, e.map((r, s) => {
    const l = s < n ? "done" : s === n ? "now" : "todo", i = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: gt.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ t.createElement("span", { className: gt.label }, r.label, r.optional && /* @__PURE__ */ t.createElement("span", { className: gt.opt }, " (선택)"), l === "done" && /* @__PURE__ */ t.createElement("span", { className: gt.sr }, " 완료"))), c = !!a && s <= n;
    return /* @__PURE__ */ t.createElement("li", { key: r.key, className: [gt.li, gt[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, c ? /* @__PURE__ */ t.createElement("button", { type: "button", className: gt.item, onClick: () => a(s, r) }, i) : /* @__PURE__ */ t.createElement("span", { className: gt.item }, i));
  }));
}
const EN = "_root_7y5bc_5", vN = "_block_7y5bc_6", kN = "_svg_7y5bc_7", wN = "_sm_7y5bc_8", NN = "_md_7y5bc_9", $N = "_lg_7y5bc_10", xN = "_track_7y5bc_11", DN = "_bar_7y5bc_12", CN = "_spin_7y5bc_13", AN = "_txt_7y5bc_15", Mt = {
  root: EN,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: vN,
  svg: kN,
  sm: wN,
  md: NN,
  lg: $N,
  track: xN,
  bar: DN,
  spin: CN,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: AN,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function S3({ size: e = "md", value: n, label: a = "불러오는 중", delay: o = 300, block: r = !1, className: s = "" }) {
  const l = typeof n == "number", i = l ? Math.min(100, Math.max(0, n)) : 0, c = 15.9155;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: [Mt.root, r ? Mt.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${o}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ t.createElement("svg", { className: [Mt.svg, Mt[e], l ? "" : Mt.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ t.createElement("circle", { className: Mt.track, cx: "18", cy: "18", r: c, fill: "none" }), /* @__PURE__ */ t.createElement(
      "circle",
      {
        className: Mt.bar,
        cx: "18",
        cy: "18",
        r: c,
        fill: "none",
        strokeDasharray: l ? `${i} ${100 - i}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ t.createElement("span", { className: Mt.txt }, a, l ? ` ${Math.round(i)}%` : "")
  );
}
const SN = "_group_xpsei_1", BN = "_legend_xpsei_2", jN = "_req_xpsei_3", MN = "_opts_xpsei_4", TN = "_inline_xpsei_5", LN = "_all_xpsei_6", IN = "_opt_xpsei_4", qN = "_dis_xpsei_11", FN = "_radio_xpsei_12", RN = "_check_xpsei_12", PN = "_text_xpsei_14", XN = "_hint_xpsei_15", ON = "_err_xpsei_16", ye = {
  group: SN,
  legend: BN,
  req: jN,
  opts: MN,
  inline: TN,
  all: LN,
  opt: IN,
  dis: qN,
  radio: FN,
  check: RN,
  text: PN,
  hint: XN,
  err: ON
};
function qr({ legend: e, required: n }) {
  return /* @__PURE__ */ t.createElement("legend", { className: ye.legend }, e, n && /* @__PURE__ */ t.createElement("span", { className: ye.req }, " (필수)"));
}
function B3({ name: e, legend: n, options: a, value: o, onChange: r, required: s, disabled: l, error: i, inline: c = !1, className: m = "" }) {
  const u = Qt("axe-rg-err");
  return /* @__PURE__ */ t.createElement(
    "fieldset",
    {
      className: [ye.group, m].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": i ? u : void 0,
      "aria-invalid": i ? !0 : void 0
    },
    /* @__PURE__ */ t.createElement(qr, { legend: n, required: s }),
    /* @__PURE__ */ t.createElement("div", { className: [ye.opts, c ? ye.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((d) => /* @__PURE__ */ t.createElement("label", { key: d.value, className: [ye.opt, d.disabled ? ye.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
      "input",
      {
        type: "radio",
        className: ye.radio,
        name: e,
        value: d.value,
        checked: o === d.value,
        disabled: d.disabled,
        required: s,
        onChange: () => r(d.value)
      }
    ), /* @__PURE__ */ t.createElement("span", { className: ye.text }, d.label, d.hint && /* @__PURE__ */ t.createElement("span", { className: ye.hint }, d.hint))))),
    i && /* @__PURE__ */ t.createElement("p", { id: u, className: ye.err }, i)
  );
}
function Ho({ checked: e, indeterminate: n = !1, onChange: a, disabled: o, children: r, className: s = "" }) {
  return /* @__PURE__ */ t.createElement("label", { className: [ye.opt, o ? ye.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "checkbox",
      className: ye.check,
      checked: e,
      disabled: o,
      ref: (l) => {
        l && (l.indeterminate = n && !e);
      },
      onChange: (l) => a(l.target.checked)
    }
  ), r !== void 0 && /* @__PURE__ */ t.createElement("span", { className: ye.text }, r));
}
function j3({ legend: e, options: n, value: a, onChange: o, required: r, disabled: s, error: l, inline: i = !1, selectAll: c, className: m = "" }) {
  const u = Qt("axe-cg-err"), d = n.filter((_) => !_.disabled).map((_) => _.value), f = d.length > 0 && d.every((_) => a.includes(_)), p = d.some((_) => a.includes(_)), y = (_, b) => o(b ? [...a, _] : a.filter(($) => $ !== _));
  return /* @__PURE__ */ t.createElement(
    "fieldset",
    {
      className: [ye.group, m].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? u : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ t.createElement(qr, { legend: e, required: r }),
    c && /* @__PURE__ */ t.createElement("div", { className: ye.all }, /* @__PURE__ */ t.createElement(
      Ho,
      {
        checked: f,
        indeterminate: p && !f,
        onChange: (_) => o(_ ? Array.from(/* @__PURE__ */ new Set([...a, ...d])) : a.filter((b) => !d.includes(b)))
      },
      c
    )),
    /* @__PURE__ */ t.createElement("div", { className: [ye.opts, i ? ye.inline : ""].filter(Boolean).join(" ") }, n.map((_) => /* @__PURE__ */ t.createElement(Ho, { key: _.value, checked: a.includes(_.value), disabled: _.disabled, onChange: (b) => y(_.value, b) }, _.label, _.hint && /* @__PURE__ */ t.createElement("span", { className: ye.hint }, _.hint)))),
    l && /* @__PURE__ */ t.createElement("p", { id: u, className: ye.err }, l)
  );
}
const zN = "_list_13vw7_1", WN = "_tag_13vw7_2", KN = "_main_13vw7_3", HN = "_x_13vw7_6", UN = "_t_muted_13vw7_10", GN = "_t_accent_13vw7_11", YN = "_t_ok_13vw7_12", VN = "_t_warn_13vw7_13", JN = "_t_danger_13vw7_14", QN = "_sel_13vw7_16", Kt = {
  list: zN,
  tag: WN,
  main: KN,
  x: HN,
  t_muted: UN,
  t_accent: GN,
  t_ok: YN,
  t_warn: VN,
  t_danger: JN,
  sel: QN
};
function M3({ children: e, tone: n = "muted", selected: a, onClick: o, onRemove: r, removeLabel: s, disabled: l, className: i = "" }) {
  const c = [Kt.tag, Kt[`t_${n}`], a ? Kt.sel : "", i].filter(Boolean).join(" "), m = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ t.createElement("span", { className: c }, o ? /* @__PURE__ */ t.createElement("button", { type: "button", className: Kt.main, onClick: o, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ t.createElement("span", { className: Kt.main }, e), r && /* @__PURE__ */ t.createElement("button", { type: "button", className: Kt.x, onClick: r, disabled: l, "aria-label": m }, "✕"));
}
function T3({ label: e, children: n, className: a = "" }) {
  return /* @__PURE__ */ t.createElement("ul", { className: [Kt.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(n) ? n : [n]).filter(Boolean).map((o, r) => /* @__PURE__ */ t.createElement("li", { key: r }, o)));
}
const ZN = "_acc_1lmty_1", e$ = "_item_1lmty_2", t$ = "_h_1lmty_3", n$ = "_btn_1lmty_4", a$ = "_title_1lmty_8", o$ = "_meta_1lmty_9", r$ = "_chev_1lmty_10", s$ = "_open_1lmty_11", l$ = "_body_1lmty_12", Et = {
  acc: ZN,
  item: e$,
  h: t$,
  btn: n$,
  title: a$,
  meta: o$,
  chev: r$,
  open: s$,
  body: l$
};
function L3({ items: e, single: n = !1, defaultOpen: a = [], openKeys: o, onOpenChange: r, headingLevel: s = 3, className: l = "" }) {
  const [i, c] = B(a), m = o != null ? o : i, u = Qt("axe-acc"), d = `h${s}`, f = (p) => {
    const y = m.includes(p) ? m.filter((_) => _ !== p) : n ? [p] : [...m, p];
    o === void 0 && c(y), r == null || r(y);
  };
  return /* @__PURE__ */ t.createElement("div", { className: [Et.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = m.includes(p.key), _ = `${u}-b-${p.key}`, b = `${u}-p-${p.key}`;
    return /* @__PURE__ */ t.createElement("div", { key: p.key, className: [Et.item, y ? Et.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(d, { className: Et.h }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        id: _,
        className: Et.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => f(p.key)
      },
      /* @__PURE__ */ t.createElement("span", { className: Et.title }, p.title),
      p.meta && /* @__PURE__ */ t.createElement("span", { className: Et.meta }, p.meta),
      /* @__PURE__ */ t.createElement("span", { className: Et.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ t.createElement("div", { id: b, role: "region", "aria-labelledby": _, hidden: !y, className: Et.body }, p.content));
  }));
}
const c$ = "_stack_1u83j_2", i$ = "_toast_1u83j_3", u$ = "_t_danger_1u83j_9", m$ = "_ico_1u83j_10", d$ = "_t_ok_1u83j_11", _$ = "_msg_1u83j_12", p$ = "_act_1u83j_13", f$ = "_x_1u83j_15", Ht = {
  stack: c$,
  toast: i$,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: u$,
  ico: m$,
  t_ok: d$,
  msg: _$,
  act: p$,
  x: f$
}, Fr = Oa(null);
let y$ = 0;
function I3() {
  const e = za(Fr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function b$({ item: e, onClose: n }) {
  var l, i;
  const [a, o] = B(!1), r = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  H(() => {
    if (a || r === 0) return;
    const c = window.setTimeout(n, r);
    return () => window.clearTimeout(c);
  }, [a, r, n, e.message]);
  const s = (i = e.tone) != null ? i : "info";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Ht.toast, Ht[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => o(!0),
      onMouseLeave: () => o(!1),
      onFocus: () => o(!0),
      onBlur: () => o(!1)
    },
    /* @__PURE__ */ t.createElement("span", { className: Ht.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ t.createElement("span", { className: Ht.msg }, e.message),
    e.action && /* @__PURE__ */ t.createElement("button", { type: "button", className: Ht.act, onClick: () => {
      e.action.onAction(), n();
    } }, e.action.label),
    /* @__PURE__ */ t.createElement("button", { type: "button", className: Ht.x, onClick: n, "aria-label": "알림 닫기" }, "✕")
  );
}
function q3({ children: e }) {
  const [n, a] = B([]), o = F(n);
  o.current = n;
  const r = se((i) => a((c) => c.filter((m) => m.id !== i)), []), s = se((i) => {
    const c = typeof i == "string" ? { message: i } : i, m = o.current.find((d) => d.message === c.message);
    if (m)
      return a((d) => d.map((f) => f.id === m.id ? { ...f, ...c } : f)), m.id;
    const u = ++y$;
    return a((d) => [...d, { ...c, id: u }].slice(-3)), u;
  }, []), l = xe(() => ({ toast: s, dismiss: r }), [s, r]);
  return /* @__PURE__ */ t.createElement(Fr.Provider, { value: l }, e, /* @__PURE__ */ t.createElement("div", { className: Ht.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, n.map((i) => /* @__PURE__ */ t.createElement(b$, { key: i.id, item: i, onClose: () => r(i.id) }))));
}
const h$ = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "새 일정 만들기" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function g$(e, n, a) {
  return a || n.ctrl || n.alt || n.meta ? !1 : e === "?";
}
const E$ = "_grid_yplhe_1", v$ = "_group_yplhe_2", k$ = "_h_yplhe_3", w$ = "_list_yplhe_4", N$ = "_row_yplhe_5", $$ = "_keys_yplhe_6", x$ = "_text_yplhe_7", D$ = "_or_yplhe_8", C$ = "_kbd_yplhe_9", vt = {
  grid: E$,
  group: v$,
  h: k$,
  list: w$,
  row: N$,
  keys: $$,
  text: x$,
  or: D$,
  kbd: C$
};
function A$({ onClose: e, extra: n }) {
  const a = [...n != null ? n : [], ...h$];
  return /* @__PURE__ */ t.createElement(Ya, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ t.createElement("div", { className: vt.grid }, a.map((o) => /* @__PURE__ */ t.createElement("section", { key: o.title, className: vt.group }, /* @__PURE__ */ t.createElement("h3", { className: vt.h }, o.title), /* @__PURE__ */ t.createElement("dl", { className: vt.list }, o.items.map((r, s) => /* @__PURE__ */ t.createElement("div", { key: s, className: vt.row }, /* @__PURE__ */ t.createElement("dt", { className: vt.keys }, r.keys.map((l, i) => /* @__PURE__ */ t.createElement("span", { key: l }, i > 0 && /* @__PURE__ */ t.createElement("span", { className: vt.or }, " 또는 "), /* @__PURE__ */ t.createElement("kbd", { className: vt.kbd }, l)))), /* @__PURE__ */ t.createElement("dd", { className: vt.text }, r.text))))))));
}
function S$(e) {
  const n = e;
  return !n || typeof n.closest != "function" ? !1 : !!n.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function F3(e = {}) {
  const { enabled: n = !0, extra: a } = e, [o, r] = B(!1);
  return H(() => {
    if (!n) return;
    const s = (l) => {
      g$(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, S$(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), r(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [n]), { open: () => r(!0), dialog: o ? /* @__PURE__ */ t.createElement(A$, { extra: a, onClose: () => r(!1) }) : null };
}
const Uo = 30, B$ = BigInt(10);
function vn(e) {
  let n = BigInt(1);
  for (let a = 0; a < e; a += 1) n = n * B$;
  return n;
}
function Nt(e, n = 0) {
  return { u: e, s: n };
}
const Rr = Nt(BigInt(0));
function Pr(e, n) {
  if (e.s === n.s) return [e.u, n.u, e.s];
  const a = Math.max(e.s, n.s);
  return [e.u * vn(a - e.s), n.u * vn(a - n.s), a];
}
function On(e, n) {
  const [a, o, r] = Pr(e, n);
  return Nt(a + o, r);
}
function Ja(e, n) {
  const [a, o, r] = Pr(e, n);
  return Nt(a - o, r);
}
function lt(e, n) {
  return Nt(e.u * n.u, e.s + n.s);
}
function Jt(e, n) {
  if (n.u === BigInt(0)) return null;
  const a = e.u * vn(n.s + Uo), o = n.u * vn(e.s);
  return Nt(a / o, Uo);
}
function Xr(e) {
  return Nt(-e.u, e.s);
}
function $t(e, n, a) {
  if (n >= e.s)
    return Nt(e.u * vn(n - e.s), n);
  const o = vn(e.s - n), r = e.u < BigInt(0), s = r ? -e.u : e.u, l = s / o, i = s % o;
  let c;
  return i === BigInt(0) || a === "down" ? c = l : a === "up" ? c = l + BigInt(1) : c = i * BigInt(2) >= o ? l + BigInt(1) : l, Nt(r ? -c : c, n);
}
function ge(e) {
  const n = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(n)) return null;
  const a = n.startsWith("-"), o = n.replace(/^[+-]/, ""), r = o.indexOf("."), s = r < 0 ? o : o.slice(0, r) + o.slice(r + 1), l = r < 0 ? 0 : o.length - r - 1, i = BigInt(s === "" ? "0" : s);
  return Nt(a ? -i : i, l);
}
function Qa(e) {
  var a;
  const n = ge(String(e));
  return n || ((a = ge(e.toFixed(20))) != null ? a : Rr);
}
function Je(e, n = e.s, a = !1) {
  const o = $t(e, Math.max(n, 0), "half"), r = o.u < BigInt(0), s = (r ? -o.u : o.u).toString().padStart(n + 1, "0"), l = s.length - n;
  let i = s.slice(0, l);
  const c = s.slice(l);
  return a && (i = i.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (r ? "-" : "") + i + (n > 0 ? "." + c : "");
}
function Ra(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!n) return null;
  const a = Number(n[1]), o = Number(n[2]), r = Number(n[3]);
  return o < 1 || o > 12 || r < 1 || r > Za(a, o) ? null : { y: a, m: o, d: r };
}
function j$(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Za(e, n) {
  return n === 2 ? j$(e) ? 29 : 28 : [4, 6, 9, 11].includes(n) ? 30 : 31;
}
function yn({ y: e, m: n, d: a }) {
  const o = Math.floor((14 - n) / 12), r = e + 4800 - o, s = n + 12 * o - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * r + Math.floor(r / 4) - Math.floor(r / 100) + Math.floor(r / 400) - 32045;
}
function Or(e, n) {
  const a = yn(e) + n + 32044, o = Math.floor((4 * a + 3) / 146097), r = a - Math.floor(146097 * o / 4), s = Math.floor((4 * r + 3) / 1461), l = r - Math.floor(1461 * s / 4), i = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * i + 2) / 5) + 1,
    m: i + 3 - 12 * Math.floor(i / 10),
    y: 100 * o + s - 4800 + Math.floor(i / 10)
  };
}
function zr(e, n, a = "exclude-first") {
  const o = yn(e) > yn(n), r = o ? n : e, s = o ? e : n, l = a === "include-first", i = yn(s) - yn(r) + (l ? 1 : 0), c = l ? Or(s, 1) : s;
  let m = c.y - r.y, u = c.m - r.m, d = c.d - r.d;
  if (d < 0) {
    u -= 1;
    const f = c.m === 1 ? 12 : c.m - 1, p = c.m === 1 ? c.y - 1 : c.y;
    d += Za(p, f);
  }
  return u < 0 && (m -= 1, u += 12), { days: i, y: m, m: u, d, swapped: o };
}
function ma(e, n) {
  return Or(e, n);
}
function Go(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = a % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, Za(o, r)) };
}
const M$ = ["월", "화", "수", "목", "금", "토", "일"];
function Pa(e) {
  return M$[yn(e) % 7];
}
function Oe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const Tn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Ca = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Yo(e) {
  var n;
  return (n = Ca[e]) != null ? n : e in Ca ? Ca[e] : null;
}
function Xa(e, n) {
  return e.find((a) => a.code === n);
}
function Wr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Kr(e, n, a, o) {
  const r = Xa(e, a), s = Xa(e, o);
  if (!r || !s) return null;
  const l = ge(r.krw), i = ge(s.krw), c = ge(String(r.per)), m = ge(String(s.per));
  if (!l || !i || !c || !m) return null;
  const u = Jt(lt(n, l), c);
  if (!u) return null;
  const d = Jt(lt(u, m), i);
  return d ? {
    value: $t(d, 2, "half"),
    notice: `${Wr(r)} · 샘플 고시(원천 미결)`
  } : null;
}
function T$(e, n) {
  let a = null;
  for (const r of e)
    if (r.value) {
      if (a === null) {
        a = r.sign === "-" ? Xr(r.value) : r.value;
        continue;
      }
      switch (r.sign) {
        case "+":
          a = On(a, r.value);
          break;
        case "-":
          a = Ja(a, r.value);
          break;
        case "*":
          a = lt(a, r.value);
          break;
        default: {
          const s = Jt(a, r.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const o = a != null ? a : Rr;
  return { ok: !0, value: n ? $t(o, n.digits, n.mode) : o };
}
const Vo = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function Rn() {
  return { sign: "+", text: "" };
}
function L$(e) {
  const n = e.replace(/[^\d.-]/g, ""), a = n.startsWith("-"), o = n.replace(/-/g, ""), r = o.indexOf("."), s = r < 0 ? o : o.slice(0, r), l = r < 0 ? "" : "." + o.slice(r + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function I$(e) {
  return e.map((n) => ({ sign: n.sign, value: ge(n.text) }));
}
function q$(e) {
  const { lines: n, onLines: a, active: o, onActive: r, digits: s, onDigits: l, mode: i, onMode: c } = e, m = F([]), u = Math.min(o, n.length - 1);
  H(() => {
    var k;
    (k = m.current[u]) == null || k.focus();
  }, [u, n.length]);
  const d = T$(I$(n), { digits: s, mode: i }), f = d.ok ? Je(d.value, s, !0) : "0으로 나눌 수 없음", p = (k, D) => {
    a(n.map((h, w) => w === k ? { ...h, ...D } : h));
  }, y = (k = n.length, D = "") => {
    const h = [...n];
    h.splice(k, 0, { ...Rn(), text: D }), a(h), r(k);
  }, _ = (k) => {
    if (n.length === 1) {
      a([Rn()]);
      return;
    }
    a(n.filter((D, h) => h !== k)), r(Math.max(0, k - 1));
  }, b = () => {
    d.ok && y(n.length, Je(d.value, s, !0));
  }, $ = (k, D) => {
    const h = k.key, w = F$(h);
    if (w && !(h === "-" && n[D].text === "")) {
      k.preventDefault(), p(D, { sign: w });
      return;
    }
    if (h === "v" || h === "V") {
      k.preventDefault(), b();
      return;
    }
    h === "Enter" ? (k.preventDefault(), D === n.length - 1 ? y() : r(D + 1)) : h === "ArrowDown" ? (k.preventDefault(), r(Math.min(D + 1, n.length - 1))) : h === "ArrowUp" ? (k.preventDefault(), r(Math.max(D - 1, 0))) : h === "Insert" ? (k.preventDefault(), y(D + 1)) : h === "Delete" && n[D].text === "" ? (k.preventDefault(), _(D)) : h === "F4" && (k.preventDefault(), E());
  }, E = () => {
    a([Rn()]), r(0);
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-general" }, /* @__PURE__ */ t.createElement("div", { className: "bical-side" }, /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => _(u) }, "라인삭제 (Del)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: E }, "초기화 (F4)")), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, Vo.map((k) => {
    var D;
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: k.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((D = n[u]) == null ? void 0 : D.sign) === k.key,
        onClick: () => p(u, { sign: k.key })
      },
      k.label,
      " (",
      k.hot,
      ")"
    );
  })), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ t.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (k) => l(Number(k.target.value)) }, [0, 1, 2, 3, 4].map((k) => /* @__PURE__ */ t.createElement("option", { key: k, value: k }, k))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ t.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: i, onChange: (k) => c(k.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ t.createElement("div", { className: "bical-grid" }, n.map((k, D) => {
    var h;
    return /* @__PURE__ */ t.createElement("div", { key: D, className: `bical-line${D === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ t.createElement("span", { className: "bical-caret" }, D === u ? "❯" : ""), /* @__PURE__ */ t.createElement("span", { className: "bical-sign" }, (h = Vo.find((w) => w.key === k.sign)) == null ? void 0 : h.label), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: (w) => {
          m.current[D] = w;
        },
        value: k.text,
        inputMode: "decimal",
        "aria-label": `${D + 1}번째 금액`,
        onFocus: () => r(D),
        onChange: (w) => p(D, { text: L$(w.target.value) }),
        onKeyDown: (w) => $(w, D)
      }
    ));
  })), /* @__PURE__ */ t.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, f))));
}
function F$(e) {
  const n = e.toLowerCase();
  return n === "a" || e === "+" ? "+" : n === "s" || e === "-" ? "-" : n === "d" || e === "*" ? "*" : n === "f" || e === "/" ? "/" : null;
}
function R$(e) {
  const n = [];
  let a = 0;
  for (; a < e.length; ) {
    const o = e[a];
    if (o === " " || o === "	" || o === `
`)
      a += 1;
    else if (o >= "0" && o <= "9" || o === "." || o === ",") {
      let r = a;
      for (; r < e.length && (e[r] >= "0" && e[r] <= "9" || e[r] === "." || e[r] === ","); ) r += 1;
      const s = ge(e.slice(a, r));
      if (!s) return null;
      n.push({ t: "num", v: s }), a = r;
    } else if (o === "+" || o === "-" || o === "*" || o === "/")
      n.push({ t: "op", v: o }), a += 1;
    else if (o === "(")
      n.push({ t: "(" }), a += 1;
    else if (o === ")")
      n.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return n;
}
class P$ {
  constructor(n) {
    this.tokens = n, this.at = 0;
  }
  parse() {
    const n = this.expr();
    return n.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : n;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let n = this.term();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return n;
      this.at += 1;
      const o = this.term();
      if (!o.ok) return o;
      n = { ok: !0, value: a.v === "+" ? On(n.value, o.value) : Ja(n.value, o.value) };
    }
  }
  term() {
    let n = this.unary();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return n;
      this.at += 1;
      const o = this.unary();
      if (!o.ok) return o;
      if (a.v === "*")
        n = { ok: !0, value: lt(n.value, o.value) };
      else {
        const r = Jt(n.value, o.value);
        if (!r) return { ok: !1, error: "divide-by-zero" };
        n = { ok: !0, value: r };
      }
    }
  }
  unary() {
    const n = this.peek();
    if (n && n.t === "op" && (n.v === "+" || n.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: n.v === "-" ? Xr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const n = this.peek();
    if (!n) return { ok: !1, error: "syntax" };
    if (n.t === "num")
      return this.at += 1, { ok: !0, value: n.v };
    if (n.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const o = this.peek();
      return !o || o.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function X$(e) {
  const n = R$(e);
  return !n || n.length === 0 ? { ok: !1, error: "syntax" } : new P$(n).parse();
}
const Pn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], O$ = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function z$(e, n) {
  return e.replace(/오늘/g, Oe(n)).replace(/내일/g, Oe(ma(n, 1))).replace(/어제/g, Oe(ma(n, -1)));
}
function W$(e) {
  const n = [];
  for (const a of e.matchAll(O$)) {
    const o = Ra(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    o && n.push(o);
  }
  return n;
}
const K$ = /부터|까지|에서|일수|며칠|기간|차이|~/;
function H$(e, n) {
  if (n.length < 2 || !K$.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), o = zr(n[0], n[1], a ? "include-first" : "exclude-first"), r = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Oe(n[0])} ~ ${Oe(n[1])} 기간(${r})` + (o.swapped ? " · 역순 입력" : ""),
    value: `${o.days}일 (${o.y}년 ${o.m}개월 ${o.d}일)`
  };
}
const U$ = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function G$(e, n) {
  if (n.length !== 1) return null;
  const a = U$.exec(e);
  if (!a) return null;
  const o = Number(a[1]), r = a[3] === "전" || a[3] === "이전", s = r ? -o : o, l = n[0];
  let i;
  return a[2] === "일" ? i = ma(l, s) : a[2] === "주" ? i = ma(l, s * 7) : a[2] === "년" ? i = Go(l, s * 12) : i = Go(l, s), {
    ok: !0,
    explain: `${Oe(l)} 에서 ${o}${a[2]} ${r ? "전" : "후"}`,
    value: `${Oe(i)} (${Pa(i)})`
  };
}
function Y$(e, n) {
  if (n.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const o = a[2] ? Hr(a[2]) : null, r = ge(a[1]);
  if (!r) return null;
  const s = o ? lt(r, o) : r, l = Yo(a[3]);
  if (!l) return null;
  const c = l !== "KRW" ? "KRW" : Yo(V$(e));
  if (!c || c === l) return null;
  const m = Kr(n, s, l, c);
  return m ? {
    ok: !0,
    explain: `${Je(s, s.s, !0)} ${l} → ${c} · ${m.notice}`,
    value: `${Je(m.value, 2, !0)} ${c}`
  } : null;
}
function V$(e) {
  const n = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return n ? n[1] : "원";
}
const J$ = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Hr(e) {
  var n;
  return (n = ge(J$[e])) != null ? n : Qa(1);
}
const Q$ = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Z$ = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function e2(e) {
  return e.replace(Q$, (n) => {
    let a = ge("0"), o = !1;
    for (const r of n.matchAll(Z$)) {
      const s = ge(r[1]);
      s && (o = !0, a = On(a, r[2] ? lt(s, Hr(r[2])) : s));
    }
    return o ? Je(a, a.s) : n;
  });
}
const t2 = /원화|원|엔|씩|개월|개|명|건/g;
function n2(e) {
  return e2(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(t2, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const a2 = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function o2(e, n, a) {
  const o = ge("1"), r = Je(lt(n, Qa(100)), 0);
  if (a === "add")
    return {
      value: $t(lt(e, On(o, n)), 0, "half"),
      explain: `消費税 ${r}% 가산(税抜 기준)`
    };
  const s = Jt(lt(e, n), On(o, n));
  return {
    value: s ? $t(s, 0, "down") : e,
    explain: `消費税 ${r}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function r2(e, n) {
  var c;
  const a = e.trim();
  if (!a) return { ok: !1, supported: Pn };
  const o = z$(a, n.today), r = W$(o), s = H$(o, r);
  if (s) return s;
  const l = G$(o, r);
  if (l) return l;
  const i = Y$(o, (c = n.rates) != null ? c : []);
  return i || s2(o, n);
}
function s2(e, n) {
  var m, u;
  const a = a2.exec(e), o = a ? e.slice(0, a.index) : e, r = n2(o);
  if (!r) return { ok: !1, supported: Pn };
  const s = X$(r);
  if (!s.ok)
    return { ok: !1, supported: Pn };
  if (!a)
    return { ok: !0, explain: r, value: Jo(s.value), expr: r };
  const l = (u = (m = l2(a[2])) != null ? m : n.taxRate) != null ? u : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...Pn]
    };
  const i = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", c = o2(s.value, l, i);
  return {
    ok: !0,
    explain: `${r} · ${c.explain}`,
    value: Jo(c.value),
    expr: r
  };
}
function l2(e) {
  var a;
  if (!e) return null;
  const n = ge(e);
  return n && (a = Jt(n, Qa(100))) != null ? a : null;
}
function Jo(e) {
  const n = $t(e, 2, "half"), a = $t(n, 0, "down");
  return Ja(n, a).u === BigInt(0) ? Je(n, 0, !0) : Je(n, 2, !0);
}
const Ye = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Qo(e, n) {
  const a = Ye[e].units.find((r) => r.key === n);
  if (!a) return null;
  const o = ge(a.factor);
  if (!o) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return o;
}
function c2(e, n, a, o, r = 4, s = "half") {
  const l = Qo(e, n), i = Qo(e, a);
  if (!l || !i) return null;
  const c = Jt(lt(o, l), i);
  return c ? $t(c, r, s) : null;
}
const i2 = [0, 1, 2, 3, 4, 6], u2 = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function m2(e) {
  const { tab: n, onTab: a, seed: o, onClose: r, history: s, onHistory: l } = e, [i, c] = B(() => o == null ? [Rn()] : [{ sign: "+", text: Je(h2(o), 0, !0) }]), [m, u] = B(0), [d, f] = B(0), [p, y] = B("half"), _ = F(null);
  H(() => {
    const $ = (E) => {
      E.key === "Escape" && (E.preventDefault(), r());
    };
    return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
  }, [r]), H(() => {
    var $, E;
    (E = ($ = _.current) == null ? void 0 : $.querySelector("[data-autofocus]")) == null || E.focus();
  }, [n]);
  const b = ($) => {
    const E = [...i.filter((k) => k.text !== ""), { sign: "+", text: $ }, Rn()];
    c(E), u(E.length - 1), a("general");
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ t.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: _ }, /* @__PURE__ */ t.createElement("div", { className: "bical-head" }, /* @__PURE__ */ t.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ t.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: r }, "✕")), /* @__PURE__ */ t.createElement("div", { className: "bical-tabs", role: "tablist" }, u2.map(($) => /* @__PURE__ */ t.createElement(
    "button",
    {
      key: $.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": $.key === n,
      onClick: () => a($.key)
    },
    $.label
  ))), /* @__PURE__ */ t.createElement("div", { className: "bical-body" }, n === "text" && /* @__PURE__ */ t.createElement(p2, { history: s, onHistory: l, onPush: b }), n === "general" && /* @__PURE__ */ t.createElement(
    q$,
    {
      lines: i,
      onLines: c,
      active: m,
      onActive: u,
      digits: d,
      onDigits: f,
      mode: p,
      onMode: y
    }
  ), n === "date" && /* @__PURE__ */ t.createElement(f2, null), n === "unit" && /* @__PURE__ */ t.createElement(y2, null), n === "fx" && /* @__PURE__ */ t.createElement(b2, null)), /* @__PURE__ */ t.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: r }, "닫기"))));
}
const d2 = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], _2 = 20;
function p2({ history: e, onHistory: n, onPush: a }) {
  var y;
  const [o, r] = B(""), [s, l] = B(null), [i, c] = B(!1), [m, u] = B(!1), d = F(!1), f = xe(eo, []), p = (_) => {
    r(_), u(!1);
    const b = r2(_, { today: f, rates: Tn, taxRate: null });
    l(b), _.trim() && n([_, ...e.filter(($) => $ !== _)].slice(0, _2));
  };
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: o,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (_) => r(_.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (_) => {
        _.key === "Enter" && !_.shiftKey && !d.current && !_.nativeEvent.isComposing && (_.preventDefault(), p(o));
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, d2.map((_) => /* @__PURE__ */ t.createElement("button", { key: _, type: "button", className: "bical-chip", onClick: () => p(_) }, _))), s && (s.ok ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var _;
        (_ = navigator.clipboard) == null || _.writeText(s.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    m ? "복사함" : "결과복사"
  ), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ t.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : Pn).map((_) => /* @__PURE__ */ t.createElement("li", { key: _ }, _))))), e.length > 0 && /* @__PURE__ */ t.createElement("div", { className: "bical-log" }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => c((_) => !_) }, "기록 ", e.length, "건 ", i ? "접기" : "펼치기"), i && /* @__PURE__ */ t.createElement("ol", null, e.map((_) => /* @__PURE__ */ t.createElement("li", { key: _ }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => p(_) }, _))))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function f2() {
  const e = xe(eo, []), [n, a] = B(Oe(e)), [o, r] = B(Oe(e)), [s, l] = B("exclude-first"), i = Ra(n), c = Ra(o), m = i && c ? zr(i, c, s) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ t.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (u) => l(u.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ t.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ t.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: n, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ t.createElement("span", null, "~"), /* @__PURE__ */ t.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: o, onChange: (u) => r(u.target.value) })), m ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, Oe(i), "(", Pa(i), ") ~ ", Oe(c), "(", Pa(c), ")", m.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, m.days.toLocaleString(), "일"), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", m.y, "년 ", m.m, "개월 ", m.d, "일")) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function y2() {
  const [e, n] = B("area"), [a, o] = B(Ye.area.units[0].key), [r, s] = B(Ye.area.units[4].key), [l, i] = B(""), [c, m] = B(4), [u, d] = B("half"), f = (_) => {
    n(_), o(Ye[_].units[0].key), s(Ye[_].units[1].key), i("");
  }, p = ge(l), y = p ? c2(e, a, r, p, c, u) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ t.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (_) => f(_.target.value) }, Object.keys(Ye).map((_) => /* @__PURE__ */ t.createElement("option", { key: _, value: _ }, Ye[_].label))), /* @__PURE__ */ t.createElement("span", { className: "bical-sub" }, "기준 ", Ye[e].base)), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (_) => o(_.target.value) }, Ye[e].units.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.key, value: _.key }, _.label))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: r, onChange: (_) => s(_.target.value) }, Ye[e].units.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.key, value: _.key }, _.label)))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ t.createElement("select", { "aria-label": "자리수", className: "bical-select", value: c, onChange: (_) => m(Number(_.target.value)) }, i2.map((_) => /* @__PURE__ */ t.createElement("option", { key: _, value: _ }, _))), /* @__PURE__ */ t.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: u, onChange: (_) => d(_.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, Zo(e, a), " → ", Zo(e, r), " · 기준단위 1단계 환산"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, y ? Je(y, c, !0) : "—")));
}
function Zo(e, n) {
  var a, o;
  return (o = (a = Ye[e].units.find((r) => r.key === n)) == null ? void 0 : a.label) != null ? o : n;
}
function b2() {
  const e = xe(eo, []), [n, a] = B(Oe(e)), [o, r] = B("JPY"), [s, l] = B("KRW"), [i, c] = B(""), m = ge(i), u = m ? Kr(Tn, m, o, s) : null, d = Xa(Tn, o);
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ t.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: n, onChange: (f) => a(f.target.value) })), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: i,
      onChange: (f) => c(f.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: o, onChange: (f) => r(f.target.value) }, Tn.map((f) => /* @__PURE__ */ t.createElement("option", { key: f.code, value: f.code }, f.code, " (", f.label, ")"))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (f) => l(f.target.value) }, Tn.map((f) => /* @__PURE__ */ t.createElement("option", { key: f.code, value: f.code }, f.code, " (", f.label, ")")))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, d ? Wr(d) : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, u ? Je(u.value, 2, !0) : "—")), /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function eo() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function h2(e) {
  var n;
  return $t((n = ge(String(e))) != null ? n : ge("0"), 0, "half");
}
const Ur = Oa(null);
function R3({ children: e }) {
  const [n, a] = B(!1), [o, r] = B("text"), [s, l] = B(null), [i, c] = B([]), [m, u] = B(0), d = xe(() => ({
    open: (f) => {
      var p, y;
      r((p = f == null ? void 0 : f.tab) != null ? p : "text"), l((y = f == null ? void 0 : f.seed) != null ? y : null), u((_) => _ + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ t.createElement(Ur.Provider, { value: d }, e, n && /* @__PURE__ */ t.createElement(
    m2,
    {
      key: m,
      tab: o,
      onTab: r,
      seed: s,
      onClose: d.close,
      history: i,
      onHistory: c
    }
  ));
}
function P3() {
  var e;
  return (e = za(Ur)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class X3 extends tr {
  constructor() {
    super(...arguments), this.rootRef = Yr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new pr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: n, children: a, ...o } = this.props;
    return /* @__PURE__ */ t.createElement("div", { ref: this.rootRef, ...o }, a);
  }
}
export {
  Z2 as AXActionCard,
  S2 as AXAiIconBadge,
  P2 as AXAiSuggestionBanner,
  cr as AXAvatar,
  B2 as AXAvatarStack,
  j2 as AXBadge,
  ex as AXBreadcrumb,
  G2 as AXButton,
  D2 as AXCardPanel,
  M2 as AXCommentRow,
  $2 as AXCommentThread,
  H2 as AXDataTable,
  C2 as AXDivider,
  nx as AXDrawer,
  ax as AXDropdownMenu,
  X2 as AXEmptyState,
  L3 as AXErpAccordion,
  i_ as AXErpActionMenu,
  Ox as AXErpBanner,
  g3 as AXErpBarChart,
  hn as AXErpButton,
  m2 as AXErpCalculatorModal,
  R3 as AXErpCalculatorProvider,
  Rx as AXErpCalendar,
  fr as AXErpCard,
  j3 as AXErpCheckGroup,
  N3 as AXErpCheckList,
  Ho as AXErpCheckbox,
  Tx as AXErpCodePicker,
  Mx as AXErpContextHelp,
  jx as AXErpCriticalAlert,
  o3 as AXErpCsvButton,
  No as AXErpDatePicker,
  qx as AXErpDateRange,
  E3 as AXErpDonutChart,
  Sr as AXErpError,
  Ep as AXErpField,
  n3 as AXErpFileDrop,
  t3 as AXErpFilterBand,
  Yx as AXErpFormRow,
  Vx as AXErpFormSection,
  k3 as AXErpGantt,
  gx as AXErpGisuField,
  E_ as AXErpGlyph,
  Ex as AXErpGrid,
  wx as AXErpGridStatus,
  hx as AXErpHint,
  oa as AXErpIcon,
  Ma as AXErpIconButton,
  w3 as AXErpKanban,
  s3 as AXErpKpiTile,
  l3 as AXErpKpiTileGroup,
  Ha as AXErpLinkButton,
  C3 as AXErpLoadMore,
  _3 as AXErpMainScreen,
  f3 as AXErpMenuAreaHead,
  y3 as AXErpMenuGroup,
  Px as AXErpMiniCalendar,
  Ya as AXErpModal,
  Xx as AXErpMoneyInput,
  tg as AXErpMsg,
  Wx as AXErpNote,
  p3 as AXErpOverviewGrid,
  rx as AXErpPage,
  D3 as AXErpPagination,
  bx as AXErpPill,
  v3 as AXErpProgressBar,
  u3 as AXErpProposalBanner,
  d3 as AXErpProposalCards,
  Cv as AXErpProposalList,
  m3 as AXErpProposalModal,
  Qg as AXErpQtyInput,
  c3 as AXErpQuickMenu,
  B3 as AXErpRadioGroup,
  Jx as AXErpReadonly,
  yx as AXErpReadout,
  ix as AXErpSaveBar,
  fx as AXErpSearchBar,
  Hg as AXErpSelect,
  A$ as AXErpShortcutHelp,
  ux as AXErpSideBar,
  dx as AXErpSidePanel,
  mx as AXErpSidePanelGroup,
  Bx as AXErpSkipLink,
  Ax as AXErpSortAnnounce,
  Cx as AXErpSortTh,
  S3 as AXErpSpinner,
  _x as AXErpStartGuide,
  r3 as AXErpStatCard,
  Kx as AXErpStateBadge,
  A3 as AXErpStepIndicator,
  Sx as AXErpSummaryCard,
  px as AXErpSummaryList,
  _r as AXErpTabs,
  M3 as AXErpTag,
  T3 as AXErpTagList,
  Kg as AXErpTextInput,
  sx as AXErpTitleBar,
  q3 as AXErpToastProvider,
  Qx as AXErpToggle,
  Zt as AXErpTooltip,
  xx as AXErpTreeCell,
  zx as AXErpVerify,
  yr as AXErpVisuallyHidden,
  h3 as AXErpWeekStepper,
  b3 as AXErpWeekStrip,
  O2 as AXExpandableSummary,
  T2 as AXFileChip,
  Ul as AXFileTypeIcon,
  Y2 as AXIconButton,
  U2 as AXKeyValueGrid,
  L2 as AXKeyValueRow,
  I2 as AXListRow,
  ox as AXModal,
  A2 as AXPanelHeader,
  q2 as AXPersonRow,
  z2 as AXProgressBar,
  F2 as AXRankingRow,
  Uu as AXSearchInput,
  V2 as AXSegmentedControl,
  R2 as AXStatusBadge,
  W2 as AXStepProgress,
  J2 as AXTagChip,
  Q2 as AXToggleSwitch,
  tx as AXTreeItem,
  K2 as AXTypingDots,
  Nr as AX_ERP_CALENDAR_KO,
  ng as AX_ERP_DIRTY_MESSAGE,
  h$ as AX_ERP_SHORTCUTS,
  ar as GW_ORIGIN,
  gr as JAPANESE_ERAS,
  wn as OBTPortal,
  X3 as OBTResizeContainer,
  pr as OBTResizeSensor,
  zn as REFRESH_KEY,
  Sa as SESSION_EXPIRED_EVENT,
  Wa as TOKEN_KEY,
  Ar as amDigits,
  qh as amNumber,
  Wn as authorizedFetch,
  $a as axErpAddDays,
  mf as axErpAriaSort,
  B1 as axErpCalendarLocale,
  eE as axErpChangedKeys,
  La as axErpCodeDisplay,
  zf as axErpCodeLabel,
  Wf as axErpCodeNameOf,
  a3 as axErpDownload,
  kE as axErpFileName,
  vp as axErpGisuLabel,
  Gx as axErpHttpMessage,
  g$ as axErpIsHelpKey,
  RE as axErpKpiColumns,
  c_ as axErpMenuItem,
  lx as axErpMenuSection,
  uf as axErpNextSort,
  x3 as axErpPageCount,
  Jw as axErpPageItems,
  Qw as axErpParsePage,
  ua as axErpQtyDecimals,
  _n as axErpQtyFormat,
  Yg as axErpQtyOutOfRange,
  jn as axErpQtyParse,
  Br as axErpQtyRound,
  Vg as axErpQtyStep,
  Ix as axErpRangeValid,
  lf as axErpRovingMove,
  Nx as axErpRowActivate,
  tE as axErpSameValues,
  jr as axErpSaveBlob,
  CE as axErpSaveCsv,
  df as axErpSortMessage,
  u_ as axErpSubmitShortcutLabel,
  $E as axErpTableToCsv,
  $3 as axErpTotalLabel,
  R0 as axErpWeekOf,
  es as clearTokens,
  v2 as colors,
  k2 as configureAuth,
  N2 as configureComments,
  bn as csvFormulaGuard,
  Mr as csvNumber,
  Ka as decodeClaims,
  Er as eraOf,
  Fx as eraShortDate,
  k1 as eraYearLabel,
  Ih as fmtAm,
  Lx as fmtDt,
  rs as getFreshToken,
  Qr as getStoredToken,
  Jr as isExpired,
  rr as isRefreshExpired,
  ss as isReply,
  kx as measureMoneyMetrics,
  vx as moneyColWidth,
  tf as moneyColWidthForDigits,
  Ln as notifySessionExpired,
  w2 as onSessionExpired,
  lr as refreshTokens,
  Zr as saveTokens,
  ns as startRefreshExpiryWatch,
  sr as stopRefreshExpiryWatch,
  Cr as toHalfWidth,
  hr as todayLocal,
  e3 as useAXErpBusy,
  P3 as useAXErpCalculator,
  Ux as useAXErpConfirm,
  ag as useAXErpDirtyGuard,
  Zx as useAXErpEditor,
  Hx as useAXErpNotice,
  i3 as useAXErpQuickMenu,
  Dx as useAXErpRovingGrid,
  F3 as useAXErpShortcutHelp,
  cx as useAXErpSubmitShortcut,
  I3 as useAXErpToast,
  $x as useAXErpTree,
  Qt as useAXErpUid,
  x2 as useCommentCounts,
  ds as useComments
};
